// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./../images/Frame-1261152715.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./../images/BG-FAQ.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./../images/LOGO.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./../images/BG.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./../images/Rectangle-9397.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./../images/Rectangle-9397-1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./../images/Rectangle-9398.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./../images/li_arrow-right-circle.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./../images/Rectangle-9397-2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./../images/button-submit.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./../fonts/Fontspring-DEMO-nekst-thin.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./../fonts/Fontspring-DEMO-nekst-medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./../fonts/Fontspring-DEMO-nekst-regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./../fonts/Fontspring-DEMO-nekst-light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./../fonts/Fontspring-DEMO-nekst-black.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("./../fonts/Fontspring-DEMO-nekst-semibold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("./../fonts/Fontspring-DEMO-nekst-bold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.w-layout-grid {
  display: grid;
  grid-auto-columns: 1fr;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto;
  grid-row-gap: 16px;
  grid-column-gap: 16px;
}

.navbar-no-shadow {
  width: 100%;
  height: 8.7467967%;
  min-width: 100%;
}

.navbar-no-shadow-container {
  z-index: 5;
  width: 100%;
  max-width: 1140px;
  margin-right: auto;
  margin-left: auto;
  padding: 20px;
  background-color: transparent;
}

.container-regular {
  width: 100%;
  max-width: 1260px;
  min-height: 30px;
  margin-right: auto;
  margin-left: auto;
}

.navbar-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 400;
}

.nav-menu {
  display: flex;
  margin-bottom: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
  justify-content: space-between;
  align-items: center;
}

.nav-link {
  margin-right: 5px;
  margin-left: 5px;
  padding: 5px 10px;
  color: #fff;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  text-decoration: none;
}

.nav-link:hover {
  color: rgba(26, 27, 31, 0.75);
}

.nav-link:focus-visible {
  border-radius: 4px;
  outline-color: #0050bd;
  outline-offset: 0px;
  outline-style: solid;
  outline-width: 2px;
  color: #0050bd;
}

.nav-link[data-wf-focus-visible] {
  border-radius: 4px;
  outline-color: #0050bd;
  outline-offset: 0px;
  outline-style: solid;
  outline-width: 2px;
  color: #0050bd;
}

.nav-dropdown {
  margin-right: 5px;
  margin-left: 5px;
}

.nav-dropdown-toggle {
  padding: 5px 30px 5px 10px;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
}

.nav-dropdown-toggle:hover {
  color: rgba(26, 27, 31, 0.75);
}

.nav-dropdown-toggle:focus-visible {
  border-radius: 5px;
  outline-color: #0050bd;
  outline-offset: 0px;
  outline-style: solid;
  outline-width: 2px;
  color: #0050bd;
}

.nav-dropdown-toggle[data-wf-focus-visible] {
  border-radius: 5px;
  outline-color: #0050bd;
  outline-offset: 0px;
  outline-style: solid;
  outline-width: 2px;
  color: #0050bd;
}

.nav-dropdown-icon {
  margin-right: 10px;
}

.nav-dropdown-list {
  border-radius: 12px;
  background-color: #fff;
}

.nav-dropdown-list.w--open {
  padding-top: 10px;
  padding-bottom: 10px;
}

.nav-dropdown-link {
  padding-top: 5px;
  padding-bottom: 5px;
  font-size: 14px;
}

.nav-dropdown-link:focus-visible {
  border-radius: 5px;
  outline-color: #0050bd;
  outline-offset: 0px;
  outline-style: solid;
  outline-width: 2px;
  color: #0050bd;
}

.nav-dropdown-link[data-wf-focus-visible] {
  border-radius: 5px;
  outline-color: #0050bd;
  outline-offset: 0px;
  outline-style: solid;
  outline-width: 2px;
  color: #0050bd;
}

.nav-button-wrapper {
  margin-left: 120px;
}

.button-primary {
  overflow: visible;
  width: 180px;
  height: 56px;
  padding: 12px 25px;
  border: 1px none #000;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: 0px 0px;
  background-size: auto;
  background-attachment: scroll;
  transition: all 200ms ease;
  color: transparent;
  font-size: 17px;
  line-height: 33px;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.button-primary:hover {
  background-color: #32343a;
  color: #fff;
}

.button-primary:active {
  background-color: #43464d;
}

.body {
  max-height: 100%;
  max-width: 100%;
  min-height: 100%;
  min-width: 100%;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: 0px 0px;
  background-size: cover;
  color: #fff;
  background-clip: border-box;
  -webkit-text-fill-color: inherit;
  object-fit: fill;
  padding-right: 25px;
  padding-left:25px;
}

.image {
  width: 100%;
  height: 100%;
  max-height: 40px;
  max-width: 119px;
  min-height: 40px;
  min-width: 119px;
  margin-left: -124px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position: 0px 0px;
  background-size: auto;
}

.text-block {
  color: #fff;
}

.heading {
  margin-top: 69px;
  margin-left: -72px;
  font-family: 'Fontspring demo nekst', sans-serif;
  color: #fff;
  font-size: 80px;
  line-height: 90px;
}

.container {
  font-size: 80px;
}

.text-block-2 {
  font-size: 12px;
}

.text-block-3 {
  font-size: 12px;
}

.text-block-4 {
  width: 591px;
  height: 118px;
  margin-bottom: 80px;
  margin-left: -72px;
  font-family: Inter, sans-serif;
  color: #5f5f5f;
  font-size: 16px;
  line-height: 35px;
}

.hero-heading-center {
  position: relative;
  padding: 80px 30px;
  border-bottom: 1px solid #e4ebf3;
  background-color: #f5f7fa;
}

.container-2 {
  width: 100%;
  max-width: 940px;
  margin-right: auto;
  margin-left: auto;
}

.centered-heading {
  margin-bottom: 16px;
  text-align: center;
}

.centered-heading.margin-bottom-32px {
  margin-bottom: 32px;
}

.hero-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.hero-split {
  display: flex;
  max-width: 46%;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.margin-bottom-24px {
  margin-bottom: 24px;
}

.button-primary-2 {
  padding: 12px 25px;
  background-color: #1a1b1f;
  transition: all 200ms ease;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.button-primary-2:hover {
  background-color: #32343a;
  color: #fff;
}

.button-primary-2:active {
  background-color: #43464d;
}

.shadow-two {
  box-shadow: 0 4px 24px 0 rgba(150, 163, 181, 0.08);
}

.heading-2 {
  margin-top: 20px;
  font-family: 'Fontspring demo nekst', sans-serif;
  color: #fff;
  font-size: 44px;
  text-align: center;
}

.text-block-5 {
  margin: 20px 200px 20px 230px;
  padding-right: 70px;
  padding-left: 70px;
  font-family: Inter, sans-serif;
  color: #5f5f5f;
  font-size: 16px;
  line-height: 25px;
  text-align: center;
}

.image-2 {
  margin-top: 97px;
  margin-left: 413px;
  text-align: center;
}

.image-3 {
  position: static;
  margin-top: 20px;
  margin-bottom: -20px;
  margin-left: 0px;
  padding-left: 0px;
}

.image-4 {
  display: block;
  width: 100%;
  height: 100%;
  max-height: 240px;
  max-width: 1201px;
  min-height: 240px;
  min-width: 1201px;
  margin-left: 244px;
  text-align: center;
}

.image-5 {
  display: inline;
  text-align: left;
}

.heading-3 {
  font-family: 'Fontspring demo nekst', sans-serif;
  color: #fff;
  text-align: center;
}

.grid {
  grid-template-areas: "Area";
  grid-template-columns: 1fr 1fr 1fr;
}

.image-6 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-position: 0px 0px;
  background-size: cover;
  background-repeat: repeat;
  background-attachment: fixed;
}

.navbar-no-shadow-container-2 {
  z-index: 5;
  width: 100%;
  max-width: 1140px;
  margin-right: auto;
  margin-left: auto;
  padding: 20px;
  background-color: transparent;
}

.container-regular-2 {
  width: 100%;
  max-width: 1260px;
  min-height: 30px;
  margin-right: auto;
  margin-left: auto;
}

.navbar-wrapper-2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav-menu-2 {
  display: flex;
  margin-bottom: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
  justify-content: space-between;
  align-items: center;
}

.nav-link-2 {
  margin-right: 5px;
  margin-left: 5px;
  padding: 5px 10px;
  color: #1a1b1f;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  text-decoration: none;
}

.nav-link-2:hover {
  color: rgba(26, 27, 31, 0.75);
}

.nav-link-2:focus-visible {
  border-radius: 4px;
  outline-color: #0050bd;
  outline-offset: 0px;
  outline-style: solid;
  outline-width: 2px;
  color: #0050bd;
}

.nav-link-2[data-wf-focus-visible] {
  border-radius: 4px;
  outline-color: #0050bd;
  outline-offset: 0px;
  outline-style: solid;
  outline-width: 2px;
  color: #0050bd;
}

.nav-dropdown-2 {
  margin-right: 5px;
  margin-left: 5px;
}

.nav-dropdown-toggle-2 {
  padding: 5px 30px 5px 10px;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
}

.nav-dropdown-toggle-2:hover {
  color: rgba(26, 27, 31, 0.75);
}

.nav-dropdown-toggle-2:focus-visible {
  border-radius: 5px;
  outline-color: #0050bd;
  outline-offset: 0px;
  outline-style: solid;
  outline-width: 2px;
  color: #0050bd;
}

.nav-dropdown-toggle-2[data-wf-focus-visible] {
  border-radius: 5px;
  outline-color: #0050bd;
  outline-offset: 0px;
  outline-style: solid;
  outline-width: 2px;
  color: #0050bd;
}

.nav-dropdown-icon-2 {
  margin-right: 10px;
}

.nav-dropdown-list-2 {
  border-radius: 12px;
  background-color: #fff;
}

.nav-dropdown-list-2.w--open {
  padding-top: 10px;
  padding-bottom: 10px;
}

.nav-dropdown-link-2 {
  padding-top: 5px;
  padding-bottom: 5px;
  font-size: 14px;
}

.nav-dropdown-link-2:focus-visible {
  border-radius: 5px;
  outline-color: #0050bd;
  outline-offset: 0px;
  outline-style: solid;
  outline-width: 2px;
  color: #0050bd;
}

.nav-dropdown-link-2[data-wf-focus-visible] {
  border-radius: 5px;
  outline-color: #0050bd;
  outline-offset: 0px;
  outline-style: solid;
  outline-width: 2px;
  color: #0050bd;
}

.nav-button-wrapper-2 {
  margin-left: 120px;
}

.button-primary-3 {
  padding: 12px 25px;
  background-color: #1a1b1f;
  transition: all 200ms ease;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.button-primary-3:hover {
  background-color: #32343a;
  color: #fff;
}

.button-primary-3:active {
  background-color: #43464d;
}

.body-2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-position: 0px 0px;
  background-size: cover;
}

.nav-link-3 {
  color: #fff;
}

.heading-4 {
  font-family: 'Fontspring demo nekst', sans-serif;
  color: #fff;
  font-size: 40px;
  text-align: left;
}

.paragraph {
  margin-top: 15px;
  font-family: Inter, sans-serif;
  color: #fff;
  font-size: 16px;
}

.paragraph-2 {
  margin-top: 30px;
  font-family: 'Fontspring demo nekst', sans-serif;
  color: #03e287;
  font-size: 16px;
  font-weight: 700;
}

.paragraph-3 {
  font-family: Inter, sans-serif;
  color: #fff;
  font-size: 16px;
}

.paragraph-4 {
  font-family: Inter, sans-serif;
  color: #fff;
  font-size: 16px;
}

.paragraph-5 {
  margin-top: 20px;
  padding-top: 0px;
  font-family: Inter, sans-serif;
  color: #fff;
  font-size: 40px;
}

.paragraph-6 {
  padding-bottom: 10px;
  font-family: Inter, sans-serif;
  color: #fff;
}

.image-7 {
  padding-left: 0px;
}

.image-8 {
  padding-left: 25px;
}

.section {
  margin-bottom: 100px;
}

.footer {
  display: flex;
  flex-direction: row;
}

.paragraph-7 {
  display: flex;
  flex: 0 1 auto;
  font-family: Inter, sans-serif;
  color: #fff;
  font-size: 16px;
}

.section-2 {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.image-9 {
  margin-left: -1398px;
}

.image-10 {
  min-height: 40px;
  min-width: 119px;
  margin-left: -530px;
}

.heading-5 {
  position: sticky;
  max-width: 84%;
  min-width: 84%;
  margin-top: 100px;
  margin-left: -203px;
  font-family: 'Fontspring demo nekst', sans-serif;
  color: #fff;
  font-size: 56px;
  line-height: 60px;
}

.paragraph-8 {
  max-width: 84%;
  min-width: 21%;
  margin-top: -150px;
  margin-left: -204px;
  padding-top: 0px;
  font-family: Inter, sans-serif;
  color: #fff;
  font-size: 16px;
  line-height: 35px;
}

.image-11 {
  position: sticky;
  max-height: none;
  max-width: 71.42%;
  min-height: 83%;
  min-width: 71.42%;
  margin-top: -386px;
  margin-left: 577px;
  padding-top: 0px;
  padding-left: 100px;
}

.container-3 {
  margin-top: 0px;
}


.heading-6 {
  margin-left: -207px;
}

.heading-7 {
  width: 60%;
  min-height: 94%;
  min-width: 0%;
  margin-top: 0px;
  margin-left: 150px;
  font-family: 'Fontspring demo nekst', sans-serif;
  color: #fff;
  font-size: 44px;
  line-height: 136.5%;
}

.image-12 {
  min-height: 100%;
  min-width: 100%;
  margin-top: 50px;
}

.container-4 {
  margin-top: -170px;
}

.footer-light {
  position: relative;
  margin-top: 50px;
  padding: 80px 30px 40px;
  border-bottom: 1px solid #e4ebf3;
}

.container-5 {
  width: 100%;
  max-width: 940px;
  margin-right: auto;
  margin-left: auto;
}

.footer-wrapper-two {
  display: flex;
  margin-top: -85px;
  justify-content: space-between;
  align-items: flex-start;
  color: #fff;
}

.footer-block-two {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.footer-title {
  font-size: 18px;
  line-height: 32px;
  font-weight: 500;
}

.footer-link-two {
  margin-top: 20px;
  color: #fff;
  text-decoration: none;
}

.footer-link-two:hover {
  color: rgba(26, 27, 31, 0.75);
}

.footer-form {
  width: 315px;
  max-width: 100%;
  margin-bottom: 0px;
}

.footer-form-block {
  display: flex;
  margin-top: 24px;
  justify-content: center;
  align-items: center;
}

.footer-form-field {
  height: 48px;
  margin-bottom: 0px;
  padding: 12px 16px;
  border-style: solid;
  border-width: 1px;
  border-color: #a6b1bf;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  transition: all 200ms ease;
  font-size: 14px;
  line-height: 22px;
}

.footer-form-field:hover {
  border-color: #76879d;
}

.footer-form-field:focus {
  border-color: #76879d;
}

.footer-form-field::placeholder {
  color: rgba(26, 27, 31, 0.8);
  font-size: 14px;
  line-height: 22px;
}

.footer-form-submit {
  width: 50px;
  height: 48px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  background-color: #1a1b1f;
  background-position: 50% 50%;
  background-size: auto;
  background-repeat: no-repeat;
  transition: all 200ms ease;
}

.footer-form-submit:hover {
  background-color: #3a4554;
}

.footer-divider-two {
  width: 100%;
  height: 1px;
  margin-top: 40px;
  margin-bottom: 40px;
  background-color: #e4ebf3;
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer-copyright {
  margin-top: 21px;
  margin-right: -50px;
  color: #fff;
}

.footer-social-block-two {
  display: flex;
  margin-top: 0px;
  margin-left: -12px;
  justify-content: flex-start;
  align-items: center;
}

.footer-social-link {
  margin-left: 12px;
}

.image-13 {
  min-width: 100px;
  margin-top: 10px;
  margin-left: -195px;
}

.text-span {
  color: #03e287;
}

.text-span-2 {
  color: #03e287;
}

.text-span-3 {
  color: #03e287;
}

.section-4 {
  width: 100%;
  height: 100%;
  margin-top: 200px;
}

.column {
  padding-right: 0px;
  padding-left: 0px;
}

.text-span-4 {
  font-family: 'Fontspring demo nekst', sans-serif;
  color: #03e287;
}

.heading-8 {
  margin-bottom: 0px;
  padding-top: 15px;
  padding-bottom: 50px;
  font-family: 'Fontspring demo nekst', sans-serif;
  font-size: 75px;
}

.text-span-5 {
  color: #ff6161;
}

.text-block-6 {
  font-family: Inter, sans-serif;
  font-size: 16px;
}

.field-label {
  margin-bottom: 10px;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 400;
}

.field-label-2 {
  margin-bottom: 10px;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 400;
}

.text-span-6 {
  color: #ff6161;
}

.text-span-7 {
  color: #ff6161;
}

.text-field {
  width: 590px;
  height: 60px;
  min-height: 100%;
  min-width: 100%;
  margin-bottom: 30px;
  border: 1px none #000;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: 0px 0px;
  background-size: auto;
  font-family: Inter, sans-serif;
  object-fit: none;
}

.text-field-2 {
  position: static;
  width: 128%;
  height: 60px;
  margin-bottom: 30px;
  border: 1px none #000;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: 0px 0px;
  background-size: auto;
  font-family: Inter, sans-serif;
  object-fit: fill;
}

.text-span-8 {
  font-family: Inter, sans-serif;
  color: #ff6161;
  font-weight: 400;
}

.field-label-3 {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 400;
}

.text-field-3 {
  width: 590px;
  height: 60px;
  margin-bottom: 30px;
  border: 1px none #000;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: 0px 0px;
  background-size: auto;
}

.field-label-4 {
  margin-bottom: 10px;
  font-family: Inter, sans-serif;
  color: #fff;
  font-size: 16px;
  font-weight: 400;
}

.text-span-9 {
  color: #ff6161;
}

.textarea {
  width: 590px;
  height: 211px;
}

.text-field-4 {
  width: 590px;
  height: 211px;
  border: 1px none #000;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-position: 0px 0px;
  background-size: auto;
}

.submit-button {
  width: 590px;
  height: 60px;
  margin-top: 200px;
  border: 1px none #000;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-position: 0px 0px;
  background-size: auto;
  font-family: Inter, sans-serif;
  text-align: center;
}

.textarea-2 {
  width: 590px;
  height: 211px;
  min-height: 211px;
  border: 1px none #000;
  border-radius: 0px;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-position: 0px 0px;
  background-size: auto;
}

.column-2 {
  display: flex;
  padding-right: 0px;
  padding-left: 0px;
  flex-direction: column;
  align-items: flex-start;
}

.image-14 {
  margin-top: 100px;
}

.text-block-7 {
  align-self: auto;
  order: 0;
}

.select-field {
  min-height: 60px;
  min-width: 590px;
  border: 1px none #000;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: 0px 0px;
  background-size: auto;
  font-family: Inter, sans-serif;
}

.heading-9 {
  padding-top: 50px;
  font-family: 'Fontspring demo nekst', sans-serif;
  font-size: 36px;
  text-align: center;
  overflow-wrap: break-word;
}

.text-block-8 {
  padding-top: 20px;
  font-family: Inter, sans-serif;
  color: #949494;
  font-size: 16px;
  text-align: center;
}

.search-button {
  padding-bottom: 0px;
  padding-left: 817px;
  background-color: transparent;
}

.search-input {
  width: 794px;
  height: 60px;
  min-height: 56%;
  min-width: 84.466%;
  margin-top: 60px;
  margin-left: 80px;
  padding-left: 0px;
  border-style: solid;
  border-width: 1px;
  border-color: #c8ffe8;
  border-radius: 10px;
  background-color: transparent;
  text-align: left;
}

.search-input::placeholder {
  font-family: Inter, sans-serif;
}

.search {
  width: 794px;
  height: 60px;
  min-height: 44%;
  min-width: 84.466%;
}

.image-15 {
  position: static;
  margin-top: 15px;
  margin-left: 53px;
  float: left;
  clear: both;
}

.html-embed {
  margin-top: 0px;
}

.html-embed-2 {
  margin-top: 70px;
  margin-bottom: 20px;
}

.heading-10 {
  overflow-wrap: break-word;
  position: static;
  width: 49%;
  height: 68%;
  min-width: 0px;
  margin-left: 210px;
  font-family: 'Fontspring demo nekst', sans-serif;
  font-size: 80px;
  line-height: 91.2px;
}

.text-block-9 {
  width: 41%;
  height: 30%;
  min-width: 0px;
  margin-left: 210px;
  font-family: Inter, sans-serif;
  color: #a19e9e;
  font-size: 16px;
  line-height: 38.32px;
}

.image-16 {
  display: inline-block;
  width: 100%;
  max-width: none;
  min-height: 837px;
  min-width: 1200px;
  margin-top: 120px;
}

.section-5 {
  margin-top: 100px;
  margin-bottom: 100px;
}

.image-17 {
  position: relative;
  left: 591px;
  top: -274px;
  margin-left: 0px;
  padding-left: 0px;
  float: left;
}

.image-18 {
  position: relative;
  left: -95px;
  top: -373px;
}

.image-19 {
  position: relative;
  left: 500px;
  top: -670px;
}

.container-6 {
  display: block;
  height: auto;
  min-height: auto;
  grid-auto-columns: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto;
}

.image-20 {
  position: relative;
  left: 414px;
  top: 12px;
}

.image-21 {
  position: relative;
  left: auto;
  top: 12px;
}

.heading-12 {
  width: 55%;
  margin-top: 100px;
  margin-left: 150px;
  font-family: 'Fontspring demo nekst', sans-serif;
  font-size: 56px;
  line-height: 130%;
}

.text-block-10 {
  width: 55%;
  margin-top: 20px;
  margin-left: 150px;
  font-family: Inter, sans-serif;
  line-height: 236.52%;
}

.image-22 {
  position: absolute;
  left: auto;
  top: 0%;
  right: 0%;
  bottom: auto;
  max-height: 100%;
  padding-top: 90px;
  opacity: 0.6;
  z-index: -10;
}

.image-23 {
  padding-top: 10px;
}

.navbar-2 {
  width: 100%;
  height: 56px;
  background-color: transparent;
}

.nav-menu-3 {
  width: 70%;
  margin-top: -40px;
  padding-right: 20px;
  padding-left: 20px;
  color: #fff;
}

.nav-link-4 {
  color: #fff;
}

.nav-link-5 {
  color: #fff;
}

.nav-link-6 {
  color: #fff;
}

.nav-link-7 {
  color: #fff;
}

.nav-link-8 {
  color: #fff;
}

.nav-link-9 {
  color: #fff;
}

.image-24 {
  position: relative;
  left: 70px;
  width: 4%;
  max-width: none;
  padding-left: 0px;
}

.text-block-11 {
  color: #fff;
}

.icon {
  color: #fff;
}

.dropdown-link {
  margin-top: -15px;
  padding-top: 0px;
  color: #fff;
}

.dropdown-list.w--open {
  background-color: transparent;
}

.dropdown-link-2 {
  color: #fff;
}

.dropdown-link-3 {
  color: #fff;
}

.section-7 {
  width: 100%;
  height: 27%;
  margin-top: 200px;
  margin-bottom: 100px;
}

.columns {
  width: 100%;
}

.heading-13 {
  margin-left: 210px;
}

.text-block-12 {
  margin-left: 210px;
}

.heading-14 {
  margin-left: 210px;
}

.text-block-13 {
  margin-left: 210px;
}

.text-block-14 {
  margin-left: 210px;
}

.section-8 {
  margin-top: 60px;
}

.navbar-3 {
  width: 100%;
  height: 56px;
  background-color: transparent;
}

.nav-menu-4 {
  padding-top: 0px;
}

.image-26 {
  padding-top: 10px;
}

.nav-link-11 {
  font-family: Inter, sans-serif;
  color: #fff;
}

.nav-link-12 {
  font-family: Inter, sans-serif;
  color: #fff;
}

.nav-link-13 {
  font-family: Inter, sans-serif;
  color: #fff;
}

.text-block-15 {
  color: #fff;
}

.icon-2 {
  font-family: Inter, sans-serif;
  color: #fff;
}

.nav-link-14 {
  font-family: Inter, sans-serif;
  color: #fff;
}

.nav-link-15 {
  font-family: Inter, sans-serif;
  color: #fff;
}

.dropdown-list-2.w--open {
  background-color: transparent;
  color: #fff;
}

.dropdown-link-4 {
  color: #fff;
}

.dropdown-link-5 {
  color: #fff;
}

.dropdown-toggle-2 {
  top: -42px;
}

.image-27 {
  position: relative;
  left: -180px;
  padding-top: 10px;
}

.navbar-4 {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}

.nav-link-16 {
  color: #fff;
}

.nav-link-16.w--current {
  position: relative;
}

.nav-link-17 {
  color: #fff;
}

.nav-link-18 {
  color: #fff;
}

.nav-menu-5 {
  padding-left: 0px;
}

.section-9 {
  display: flex;
  margin-bottom: 25px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.section-10 {
  display: flex;
  flex-wrap: wrap;
  padding-top: 20px;
  justify-content: center;
  align-items: center;
}
.image-30 {
  padding-right: 10px;
  padding-left: 20px;
}

.image-31 {
  padding-right: 10px;
  padding-left: 10px;
}

.image-32 {
  padding-right: 20px;
  padding-left: 10px;
}

.grid-3 {
  display: flex;
  justify-items: center;
  align-items: center;
}

.section-17 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.section-18 {
  display: flex;
  padding-top: 25px;
  padding-bottom: 100px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.heading-19 {
  margin-bottom: 25px;
}

.text-block-30 {
  padding-top: 25px;
  padding-bottom: 25px;
}

.grid-6 {
  display: flex;
  justify-content: center;
  justify-items: center;
  align-items: center;
  align-self: center;
}

.text-block-32 {
  position: relative;
  left: 250px;
  display: inline-block;
  padding: 20px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.image-41 {
  margin-top: 0px;
  margin-left: 0px;
}

.div-block-2 {
  margin: 100px 100px 100px 0px;
  background-color: transparent;
}

.div-block-3 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.heading-20 {
  margin-top: 50px;
  font-size: 32px;
  font-weight: 400;
}

.image-42 {
  width: 35%;
  height: 58.526924%;
  min-height: 146px;
  min-width: 501px;
}

.div-block-4 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: justify;
}

.text-block-38 {
  padding-bottom: 25px;
}

.text-block-39 {
  align-self: flex-start;
}

.text-block-40 {
  align-self: flex-start;
}

.button-3 {
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-position: 0px 0px;
  background-size: auto;
  
}

.button-4 {
  position: relative;
  left: 150px;
  width: 180px;
  height: 56px;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: 0px 0px;
  background-size: auto;
}

.div-block-5 {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.button-5 {
  position: relative;
  left: -116px;
  width: 119px;
  height: 40px;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position: 0px 0px;
  background-size: auto;
}

.button-5.w--current {
  position: relative;
  left: -80px;
  width: 119px;
  height: 40px;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position: 0px 0px;
  background-size: auto;
}

.div-block-6 {
  display: flex;
  padding-top: 25px;
  padding-bottom: 25px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.div-block-7 {
  display: flex;
  width: 100%;
  padding-top: 100px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-self: center;
  flex: 0 1 auto;
}

.heading-22 {
  align-self: flex-start;
}

.heading-23 {
  align-self: flex-start;
}

.heading-24 {
  align-self: flex-start;
}

.heading-25 {
  align-self: flex-start;
}

.heading-26 {
  align-self: flex-start;
}

.heading-27 {
  align-self: flex-start;
}

.text-block-47 {
  padding-bottom: 50px;
}

.section-21 {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  overflow-wrap: anywhere;
}

.image-60 {
  position: relative;
  left: -211px;
}

.heading-28 {
  align-self: flex-start;
}

.heading-29 {
  align-self: flex-start;
}

.heading-30 {
  align-self: flex-start;
}

.heading-31 {
  align-self: flex-start;
}

.heading-32 {
  align-self: flex-start;
}

.heading-33 {
  align-self: flex-start;
}

.heading-34 {
  align-self: flex-start;
}

.heading-35 {
  align-self: flex-start;
}

.grid-7 {
  justify-content: center;
  align-content: center;
  grid-auto-flow: row;
  grid-template-rows: auto auto auto;
}

.column-7 {
  position: relative;
  display: flex;
  clear: none;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.text-block-48 {
  padding-left: 25px;
  font-family: 'Fontspring demo nekst', sans-serif;
  font-size: 20px;
  line-height: 275%;
  font-weight: 700;
}

.image-61 {
  padding-bottom: 15px;
}

.image-62 {
  padding-bottom: 15px;
}

@media screen and (min-width: 1440px) {
  .body {
    height: 100%;
  }

  .image-2 {
    position: static;
    margin-top: 90px;
    margin-left: 0px;
    align-self: center;
  }

  .image-11 {
    width: 71.42%;
    height: 91.021953%;
  }

  .heading-7 {
    height: 83%;
    min-height: 0px;
    min-width: 0px;
    margin-left: 210px;
    padding: 10px 20px;
  }

  .heading-10 {
    width: 49%;
  }

  .text-block-9 {
    width: 36%;
  }

  .container-6 {
    display: flex;
    height: auto;
    min-height: auto;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    grid-auto-columns: 1fr;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
  }

  .image-20 {
    left: 0px;
    max-width: 0%;
  }

  .image-21 {
    position: relative;
    left: 0px;
    top: 10px;
  }

  .html-embed-3 {
    height: auto;
  }

  .heading-11 {
    font-size: 48px;
  }

  .heading-12 {
    width: 55%;
    margin-left: 210px;
    padding: 10px 20px;
    font-size: 56px;
    line-height: 136%;
  }

  .text-block-10 {
    width: 55%;
    margin-left: 210px;
    padding: 10px 20px;
    opacity: 0.6;
    font-size: 16px;
    line-height: 239.52%;
  }

  .image-22 {
    position: absolute;
    left: auto;
    top: 0%;
    right: 0%;
    bottom: auto;
  }

  .navbar {
    background-color: transparent;
  }

  .container-7 {
    width: 1196px;
    height: 56px;
    margin-top: -40px;
    margin-left: 210px;
  }

  .image-23 {
    margin-top: 80px;
  }

  .navbar-2 {
    width: 100%;
    height: 56px;
    margin-top: 0px;
    background-color: transparent;
  }

  .nav-menu-3 {
    width: 70%;
    margin-top: 35px;
    padding-right: 20px;
    padding-left: 20px;
    flex-direction: row;
    background-color: transparent;
    color: #fff;
  }

  .nav-link-4 {
    background-color: transparent;
    font-family: Inter, sans-serif;
    color: #fff;
  }

  .nav-link-5 {
    color: #fff;
  }

  .nav-link-6 {
    font-family: Inter, sans-serif;
    color: #fff;
  }

  .nav-link-7 {
    font-family: Inter, sans-serif;
    color: #fff;
  }

  .nav-link-8 {
    font-family: Inter, sans-serif;
    color: #fff;
  }

  .nav-link-9 {
    font-family: Inter, sans-serif;
    color: #fff;
  }

  .image-24 {
    position: relative;
    left: 133px;
  }

  .button {
    position: relative;
    left: 1049px;
    top: -44px;
    float: right;
  }

  .text-block-11 {
    font-family: Inter, sans-serif;
    color: #fff;
  }

  .icon {
    color: #fff;
  }

  .dropdown-toggle {
    font-family: Inter, sans-serif;
  }

  .dropdown-link {
    margin-top: -30px;
    font-family: Inter, sans-serif;
    color: #fff;
  }

  .dropdown-list {
    background-color: #d5bebe;
  }

  .dropdown-list.w--open {
    background-color: transparent;
    font-family: Inter, sans-serif;
  }

  .dropdown-link-2 {
    font-family: Inter, sans-serif;
    color: #fff;
  }

  .dropdown-link-3 {
    font-family: Inter, sans-serif;
    color: #fff;
  }

  .columns {
    margin-top: 20px;
    margin-right: 0px;
    margin-left: 0px;
    padding-right: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
  }

  .nav-link-10 {
    font-family: Inter, sans-serif;
    color: #fff;
  }

  .heading-13 {
    width: 44%;
    height: 100%;
    margin-left: 210px;
    font-family: 'Fontspring demo nekst', sans-serif;
    font-size: 80px;
    line-height: 106%;
  }

  .text-block-12 {
    width: 61%;
    height: 29%;
    margin-left: 210px;
    font-family: Inter, sans-serif;
    font-size: 16px;
    line-height: 123%;
  }

  .heading-14 {
    margin-top: 20px;
    margin-left: 210px;
    font-family: Inter, sans-serif;
    font-size: 20px;
    line-height: 123%;
  }

  .text-block-13 {
    margin-left: 210px;
    opacity: 0.6;
    font-family: Inter, sans-serif;
    line-height: 175%;
  }

  .text-block-14 {
    margin-left: 210px;
    font-family: Inter, sans-serif;
    font-size: 16px;
    line-height: 175%;
    text-align: left;
  }

  .line {
    display: block;
    width: 50%;
    margin-left: 194px;
    padding-top: 20px;
    flex-direction: row;
    border-style: solid;
    border-width: 2px 1px 1px;
    border-color: #fff;
    border-radius: 2px;
  }

  .div-block {
    width: 61%;
    margin-left: 210px;
    border-style: solid;
    border-width: 1px;
    border-color: #fff;
    border-radius: 2px;
    opacity: 0.3;
  }

  .section-8 {
    margin-top: 50px;
  }

  .navbar-3 {
    height: 56px;
    background-color: transparent;
  }

  .nav-menu-4 {
    top: auto;
    padding-top: 0px;
  }

  .image-26 {
    display: inline-block;
    padding-top: 10px;
  }

  .nav-link-11 {
    font-family: Inter, sans-serif;
    color: #fff;
  }

  .nav-link-11:hover {
    color: #03e287;
  }

  .nav-link-12 {
    font-family: Inter, sans-serif;
    color: #fff;
  }

  .nav-link-12:hover {
    color: #03e287;
  }

  .nav-link-13 {
    color: #fff;
  }

  .nav-link-13:hover {
    color: #03e287;
  }

  .text-block-15 {
    font-family: Inter, sans-serif;
    color: #fff;
  }

  .icon-2 {
    color: #fff;
  }

  .nav-link-14 {
    color: #fff;
  }

  .nav-link-14:hover {
    color: #03e287;
  }

  .nav-link-15 {
    color: #fff;
  }

  .nav-link-15:hover {
    color: #03e287;
  }

  .dropdown-list-2 {
    color: #d3b8b8;
  }

  .dropdown-list-2.w--open {
    background-color: transparent;
    font-family: Inter, sans-serif;
    color: #fff;
  }

  .dropdown-link-4 {
    margin-top: -30px;
    color: #fff;
  }

  .dropdown-link-5 {
    color: #fff;
  }

  .dropdown-link-6 {
    color: #fff;
  }

  .dropdown-toggle-2 {
    top: -39px;
  }

  .container-9 {
    margin-top: 200px;
    margin-bottom: 800px;
  }

  .image-27 {
    padding-top: 10px;
  }

  .navbar-4 {
    width: 100%;
    background-color: transparent;
  }

  .nav-link-16 {
    padding-right: 50px;
    color: #fff;
  }

  .nav-link-17 {
    padding-right: 50px;
    color: #fff;
  }

  .nav-link-18 {
    padding-right: 50px;
    color: #fff;
  }

  .nav-menu-5 {
    position: relative;
    display: flex;
    width: 100%;
    padding-right: 250px;
    padding-left: 250px;
    float: left;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-family: Inter, sans-serif;
    text-align: left;
  }

  .text-block-16 {
    margin-top: 19px;
    margin-left: 566px;
    font-family: Inter, sans-serif;
  }

  .container-10 {
    display: flex;
  }

  .section-9 {
    display: flex;
    flex-direction: column;
  }

  .container-11 {
    display: flex;
    flex-direction: column;
  }

  .section-10 {
    display: flex;
    padding-top: 20px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .image-30 {
    padding-right: 20px;
    padding-left: 20px;
  }

  .image-31 {
    padding-right: 20px;
    padding-left: 20px;
  }

  .image-32 {
    padding-right: 20px;
    padding-left: 20px;
  }

  .container-12 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .section-11 {
    display: flex;
    margin-top: 50px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .heading-15 {
    align-self: flex-end;
    font-family: Inter, sans-serif;
    color: #03e287;
    font-size: 24px;
    font-weight: 700;
  }

  .text-block-17 {
    padding-bottom: 18px;
    align-self: flex-end;
    font-family: Inter, sans-serif;
    font-size: 16px;
    font-weight: 700;
  }

  .text-block-18 {
    padding-bottom: 18px;
    align-self: flex-end;
    font-size: 16px;
    font-weight: 700;
  }

  .text-block-19 {
    padding-bottom: 18px;
    align-self: flex-end;
    opacity: 0.6;
    font-family: Inter, sans-serif;
    font-size: 16px;
  }

  .text-block-20 {
    font-size: 16px;
    font-weight: 700;
  }

  .text-block-21 {
    align-self: flex-end;
    font-family: Inter, sans-serif;
    font-size: 16px;
    font-weight: 700;
  }

  .container-14 {
    position: absolute;
    left: 27%;
    top: 2425px;
    right: auto;
    bottom: 0%;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
  }

  .heading-16 {
    font-family: Inter, sans-serif;
    color: #03e287;
    font-size: 24px;
  }

  .text-block-22 {
    padding-bottom: 18px;
    font-family: Inter, sans-serif;
    font-size: 16px;
  }

  .text-block-23 {
    padding-bottom: 18px;
    font-family: Inter, sans-serif;
    font-size: 16px;
  }

  .container-15 {
    position: absolute;
    left: 1123px;
    top: 2795px;
    display: flex;
    flex-direction: column;
    align-self: flex-start;
  }

  .text-block-24 {
    font-family: Inter, sans-serif;
    font-size: 16px;
  }

  .heading-17 {
    font-family: Inter, sans-serif;
    color: #03e287;
    font-size: 24px;
  }

  .image-33 {
    margin-top: 50px;
  }

  .text-block-25 {
    padding-bottom: 18px;
    opacity: 0.6;
    font-family: Inter, sans-serif;
    font-size: 16px;
  }

  .text-block-26 {
    padding-bottom: 18px;
    font-family: Inter, sans-serif;
    font-size: 16px;
  }

  .container-16 {
    position: absolute;
    left: 244.609px;
    top: 2897.81px;
    text-align: right;
  }

  .heading-18 {
    font-family: Inter, sans-serif;
    color: #03e287;
    font-size: 24px;
  }

  .text-block-27 {
    font-family: Inter, sans-serif;
    font-size: 16px;
  }

  .container-17 {
    position: absolute;
    left: 901.094px;
    top: 3225.81px;
  }

  .text-block-28 {
    padding-bottom: 18px;
    font-family: Inter, sans-serif;
    font-size: 16px;
  }

  .text-block-29 {
    font-family: Inter, sans-serif;
    font-size: 16px;
  }

  .image-34 {
    position: absolute;
    left: 302.5px;
    top: 855.312px;
  }

  .image-35 {
    position: absolute;
    left: 849px;
    top: 935.312px;
  }

  .section-13 {
    height: 85%;
  }

  .image-36 {
    position: absolute;
    left: 145.5px;
    top: 1174.312px;
  }

  .image-37 {
    position: absolute;
    left: 730.5px;
    top: 1226.312px;
  }

  .grid-3 {
    display: flex;
    flex-direction: row;
    justify-content: center;
    justify-items: center;
    align-items: center;
  }

  .section-14 {
    display: flex;
    padding-bottom: 100px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    grid-auto-columns: 1fr;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
  }

  .grid-5 {
    grid-template-columns: 1fr 1fr 1fr;
  }

  .section-15 {
    margin-bottom: 200px;
    padding-bottom: 20px;
  }

  .section-17 {
    display: flex;
    justify-content: center;
    align-items: center;
    grid-auto-columns: 1fr;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
  }

  .section-18 {
    display: flex;
    margin-bottom: 100px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .heading-19 {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Fontspring demo nekst', sans-serif;
    text-align: center;
  }

  .grid-6 {
    display: grid;
    margin-top: 50px;
    justify-content: center;
    align-items: center;
    grid-auto-columns: 1fr;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-template-rows: auto;
  }

  .text-block-32 {
    left: auto;
    display: block;
    max-width: none;
    flex-direction: row;
    align-self: auto;
    flex: 0 0 auto;
  }

  .div-block-2 {
    width: 86%;
  }

  .div-block-3 {
    margin-top: 0px;
    padding-top: 100px;
  }

  .image-42 {
    min-height: 58%;
    min-width: 35%;
  }

  .heading-21 {
    margin-top: 50px;
  }

  .div-block-4 {
    display: flex;
    padding-top: 100px;
    padding-right: 100px;
    padding-left: 100px;
    flex-direction: column;
    font-family: Inter, sans-serif;
  }

  .text-block-33 {
    padding-bottom: 25px;
  }

  .text-block-34 {
    padding-bottom: 0px;
  }

  .image-43 {
    width: 25%;
    align-self: center;
  }

  .text-block-35 {
    padding-bottom: 25px;
  }

  .text-block-36 {
    padding-bottom: 25px;
  }

  .image-44 {
    width: 25%;
    align-self: center;
  }

  .text-span-10 {
    color: red;
  }

  .image-45 {
    width: 75%;
    align-self: center;
  }

  .image-46 {
    width: 75%;
    align-self: center;
  }

  .text-block-37 {
    padding-top: 100px;
    padding-bottom: 25px;
  }

  .text-block-38 {
    padding-bottom: 25px;
  }

  .column-5 {
    display: flex;
    padding-right: 0px;
    padding-left: 0px;
    justify-content: center;
    align-items: center;
  }

  .column-6 {
    display: flex;
    padding-right: 0px;
    padding-left: 0px;
    justify-content: center;
  }

  .text-block-39 {
    padding-bottom: 25px;
  }

  .columns-2 {
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    align-self: flex-start;
    grid-column-gap: 0px;
    grid-row-gap: 0px;
  }

  .image-47 {
    width: 75%;
  }

  .image-48 {
    width: 75%;
  }

  .text-block-40 {
    padding-top: 25px;
    padding-bottom: 25px;
  }

  .image-49 {
    width: 75%;
    align-self: center;
  }

  .image-50 {
    width: 75%;
    padding-bottom: 25px;
    align-self: center;
  }

  .image-51 {
    width: 75%;
    padding-bottom: 25px;
    align-self: center;
  }

  .text-block-41 {
    padding-bottom: 25px;
  }

  .image-52 {
    width: 75%;
    padding-bottom: 25px;
    align-self: center;
  }

  .text-block-42 {
    padding-bottom: 25px;
  }

  .image-53 {
    width: 75%;
    align-self: center;
  }

  .image-54 {
    width: 75%;
    align-self: center;
  }

  .text-block-43 {
    padding-bottom: 25px;
  }

  .image-55 {
    width: 75%;
    align-self: center;
  }

  .text-block-44 {
    padding-bottom: 25px;
  }

  .image-56 {
    width: 75%;
    align-self: center;
    margin-bottom: 2rem;
  }

  .image-57 {
    width: 75%;
    align-self: center;
  }

  .image-58 {
    width: 75%;
    align-self: center;
  }

  .text-block-45 {
    padding-bottom: 25px;
  }

  .image-59 {
    width: 75%;
    align-self: center;
  }

  .button-2 {
    width: 2%;
    border: 1px none #000;
    background-color: transparent;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    background-position: 0px 0px;
    background-size: auto;
  }

  .button-3 {
    width: 40px;
    height: 40px;
    border: 1px none #000;
    background-color: transparent;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    background-position: 0px 0px;
    background-size: cover;
  }

  .button-4 {
    position: relative;
    left: 220px;
    width: 180px;
    height: 56px;
    padding-top: 20px;
    border: 1px none #000;
    background-color: transparent;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: 0px 0px;
    background-size: auto;
  }

  .div-block-5 {
    display: flex;
    margin-right: auto;
    margin-left: auto;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    grid-auto-columns: 1fr;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
  }

  .button-5 {
    position: relative;
    left: -101px;
    display: flex;
    width: 119px;
    height: 40px;
    padding-top: 0px;
    justify-content: center;
    align-items: center;
    align-self: center;
    border: 1px none #000;
    background-color: transparent;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-position: 0px 0px;
    background-size: auto;
  }

  .div-block-6 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-self: center;
  }

  .div-block-7 {
    margin-top: 100px;
  }

  .image-60 {
    position: relative;
    left: 98px;
  }

  .column-7 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }

  .text-block-48 {
    position: relative;
    top: -15px;
    width: 100%;
    height: 100%;
    padding-left: 25px;
    font-family: 'Fontspring demo nekst', sans-serif;
    font-size: 20px;
    line-height: 300%;
    font-weight: 700;
  }

  .text-block-49 {
    font-family: 'Fontspring demo nekst', sans-serif;
    font-size: 20px;
    font-weight: 700;
  }

  .text-block-50 {
    font-family: 'Fontspring demo nekst', sans-serif;
    font-size: 20px;
    font-weight: 700;
  }

  .columns-3 {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    align-self: auto;
    order: 1;
    object-fit: cover;
  }

  .image-61 {
    padding-bottom: 20px;
  }

  .image-62 {
    padding-bottom: 20px;
  }

  .image-63 {
    padding-bottom: 2px;
  }
}

@media screen and (min-width: 1920px) {
  .body {
    height: auto;
    max-height: none;
    max-width: none;
    min-height: auto;
  }

  .heading-7 {
    margin-left: 210px;
  }

  .image-12 {
    margin-bottom: 100px;
  }

  .text-field {
    color: #fff;
  }

  .text-field-2 {
    color: #fff;
  }

  .textarea-2 {
    color: #fff;
  }

  .column-2 {
    padding-left: 0px;
  }

  .select-field {
    color: #fff;
  }

  .html-embed {
    margin-top: 100px;
    margin-bottom: 100px;
  }

  .image-21 {
    align-self: center;
  }

  .heading-12 {
    margin-left: 210px;
  }

  .text-block-10 {
    margin-left: 210px;
    opacity: 0.6;
  }

  .image-22 {
    left: auto;
    top: 0%;
    right: 0%;
    bottom: auto;
  }

  .section-7 {
    margin-bottom: 300px;
  }

  .navbar-3 {
    position: static;
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    margin-right: auto;
    margin-left: auto;
  }

  .nav-menu-4 {
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
  }

  .image-26 {
    position: relative;
    left: -310px;
    padding-left: 0px;
    align-self: center;
    order: 0;
  }

  .text-block-15 {
    padding-top: 20px;
  }

  .icon-2 {
    position: absolute;
    top: 21px;
  }

  .dropdown-list-2.w--open {
    top: 50px;
  }

  .dropdown-link-4 {
    margin-top: 20px;
  }

  .dropdown-toggle-2 {
    top: -11px;
    padding-top: 25px;
  }

  .image-27 {
    left: auto;
    padding-left: 0px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-position: 0px 0px;
    background-size: auto;
  }

  .navbar-4 {
    display: block;
    margin-right: auto;
    margin-left: auto;
    justify-content: center;
    align-items: center;
  }

  .nav-link-16 {
    padding-left: 270px;
  }

  .nav-menu-5 {
    display: flex;
    width: 100%;
    height: auto;
    margin-bottom: 100px;
    padding-right: 0px;
    padding-left: 0px;
    flex-direction: row;
  }

  .section-9 {
    margin-top: -70px;
    padding-top: 0px;
    padding-bottom: 20px;
  }

  .container-14 {
    position: relative;
    left: -19%;
    top: -1007px;
  }

  .container-15 {
    left: 1137px;
    top: 2794px;
  }

  .container-16 {
    left: 470.609px;
    top: 2570.81px;
  }

  .container-17 {
    left: 1131.094px;
    top: 3372.81px;
  }

  .section-13 {
    height: 75%;
    margin-bottom: 50px;
  }

  .grid-2 {
    display: grid;
    grid-auto-flow: row;
    grid-auto-columns: 1fr;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr;
  }

  .grid-3 {
    display: flex;
    justify-content: center;
    align-items: center;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr;
  }

  .section-14 {
    display: flex;
    margin-top: 300px;
    margin-bottom: 0px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .grid-4 {
    grid-template-columns: 1fr 1fr 1fr;
  }

  .grid-5 {
    grid-template-columns: 1fr 1fr 1fr;
  }

  .section-15 {
    margin-top: 0px;
    margin-bottom: 100px;
  }

  .section-16 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    grid-auto-columns: 1fr;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
  }

  .image-39 {
    align-self: center;
  }

  .container-19 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .section-17 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .image-40 {
    position: relative;
    margin-bottom: 100px;
  }

  .section-18 {
    margin-bottom: 200px;
  }

  .heading-19 {
    font-family: 'Fontspring demo nekst', sans-serif;
    font-size: 44px;
  }

  .text-block-30 {
    margin-bottom: 0px;
    padding-bottom: 10px;
    opacity: 0.6;
    font-family: Inter, sans-serif;
    font-size: 16px;
  }

  .grid-6 {
    margin-top: 5px;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-template-rows: auto;
  }

  .html-embed-4 {
    margin-top: 100px;
  }

  .text-block-31 {
    width: 100%;
    font-family: Inter, sans-serif;
    text-align: left;
  }

  .text-block-32 {
    left: auto;
    top: -45px;
    width: 40%;
    padding-left: 0px;
    font-size: 14px;
  }

  .section-19 {
    margin-bottom: 300px;
  }

  .div-block-3 {
    width: 100%;
    height: 100.000042%;
  }

  .text-block-35 {
    align-self: flex-start;
  }

  .button-3 {
    position: relative;
    left: 101px;
  }

  .button-4 {
    position: relative;
    left: 380px;
    width: 180px;
    height: 56px;
    padding-top: 20px;
    border: 1px none #000;
    background-color: transparent;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: 0px 0px;
    background-size: auto;
  }

  .div-block-5 {
    display: flex;
    max-width: 1920px;
    margin-right: auto;
    margin-left: auto;
    justify-content: center;
    align-items: center;
  }

  .button-5 {
    position: relative;
    left: -255px;
    width: 119px;
    height: 40px;
    padding-top: 20px;
    border: 1px none #000;
    background-color: transparent;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-position: 0px 0px;
    background-size: auto;
  }

  .button-5.w--current {
    left: -270px;
  }

  .image-60 {
    position: relative;
    top: -51px;
  }
}

@media screen and (max-width: 991px) {
  .nav-menu-wrapper {
    background-color: transparent;
  }

  .nav-menu {
    display: flex;
    padding-left: 0px;
    justify-content: space-around;
    flex-wrap: wrap;
    align-items: center;
    background-color: #fff;
  }

  .nav-link {
    padding-right: 5px;
    padding-left: 5px;
  }

  .nav-dropdown-list.shadow-three.w--open {
    position: absolute;
  }

  .nav-button-wrapper {
    width: 100%;
    margin-left: 0px;
  }

  .menu-button {
    padding: 12px;
  }

  .menu-button.w--open {
    background-color: #a6b1bf;
    color: #fff;
  }

  .body {
    padding-right: 25px;
    padding-left: 25px;
    font-family: Inter, sans-serif;
  }

  .container-2 {
    max-width: 728px;
  }

  .hero-wrapper {
    margin-bottom: -40px;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .hero-split {
    max-width: 100%;
    margin-bottom: 40px;
  }

  .text-block-5 {
    margin-right: 0px;
    margin-left: 0px;
  }

  .image-2 {
    position: relative;
    margin-top: 90px;
    margin-left: 0px;
  }

  .image-3 {
    margin-bottom: 20px;
  }

  .nav-menu-wrapper-2 {
    background-color: transparent;
  }

  .nav-menu-2 {
    display: flex;
    padding-left: 0px;
    justify-content: space-around;
    flex-wrap: wrap;
    align-items: center;
    background-color: #fff;
  }

  .nav-link-2 {
    padding-right: 5px;
    padding-left: 5px;
  }

  .nav-dropdown-list-2.shadow-three.w--open {
    position: absolute;
  }

  .nav-button-wrapper-2 {
    width: 100%;
    margin-left: 0px;
  }

  .menu-button-2 {
    padding: 12px;
  }

  .menu-button-2.w--open {
    background-color: #a6b1bf;
    color: #fff;
  }

  .paragraph-2 {
    margin-top: 25px;
  }

  

  .heading-7 {
    width: 100%;
    margin-left: 0px;
    padding-left: 20px;
    font-size: 24px;
  }

  .container-5 {
    max-width: 728px;
  }

  .footer-wrapper-two {
    flex-wrap: wrap;
  }

  .footer-form {
    width: 100%;
    margin-top: 40px;
  }

  .footer-form-container {
    max-width: 350px;
  }

  .text-field {
    width: 82.1%;
    min-height: auto;
    min-width: 590px;
  }

  .text-field-2 {
    width: 82.1%;
    min-width: 590px;
  }

  .select-field {
    width: 82.1%;
  }

  .heading-10 {
    width: 85%;
    margin-top: 0px;
    margin-bottom: 0px;
    margin-left: 0px;
    padding: 20px;
  }

  .text-block-9 {
    width: 85%;
    margin-left: 0px;
    padding-right: 20px;
    padding-left: 20px;
  }

  .image-21 {
    left: auto;
  }

  .heading-12 {
    width: 95%;
    margin-left: 0px;
    padding-left: 20px;
  }

  .text-block-10 {
    margin-left: 0px;
    padding-left: 20px;
    opacity: 0.6;
  }

  .image-22 {
    left: auto;
    top: 0%;
    right: 0%;
    bottom: auto;
    max-height: 70%;
    opacity: 0.2;
  }

  .image-23 {
    margin-top: 15px;
  }

  .navbar-2 {
    background-color: transparent;
    font-family: Lato, sans-serif;
    color: #fff;
  }

  .image-27 {
    position: relative;
    left: auto;
  }

  .nav-menu-5 {
    left: auto;
    display: flex;
    margin-left: 0px;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    align-self: auto;
  }

  .section-10 {
    flex-direction: column;
  }

  .container-12 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-self: center;
  }

  .section-12 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .grid-3 {
    display: grid;
    grid-auto-columns: 1fr;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
  }

  .image-38 {
    position: relative;
    left: 110px;
  }

  .section-18 {
    display: flex;
    padding-top: 25px;
    padding-bottom: 25px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .text-block-32 {
    left: auto;
    padding-right: 0px;
    padding-left: 0px;
  }

  .div-block-2 {
    margin-left: 0px;
  }

  .div-block-4 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .image-43 {
    display: inline-block;
  }

  .text-block-37 {
    padding-top: 25px;
    padding-bottom: 25px;
    align-self: flex-start;
  }

  .text-block-38 {
    padding-bottom: 25px;
  }

  .text-block-39 {
    padding-bottom: 25px;
    align-self: flex-start;
  }

  .columns-2 {
    padding-bottom: 25px;
  }

  .text-block-40 {
    padding-bottom: 25px;
    align-self: flex-start;
  }

  .image-50 {
    padding-bottom: 25px;
  }

  .image-52 {
    padding-bottom: 25px;
  }

  .image-53 {
    padding-bottom: 25px;
  }

  .text-block-43 {
    padding-bottom: 25px;
  }

  .text-block-44 {
    padding-bottom: 25px;
  }

  .text-block-45 {
    padding-top: 25px;
    padding-bottom: 25px;
  }

  .button-3 {
    width: 40px;
    height: 40px;
    padding: 0px;
    background-color: transparent;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    background-position: 0px 0px;
    background-size: auto;
  }

  .button-4 {
    left: 207px;
  }

  .button-5 {
    left: 4px;
  }

  .button-5.w--current {
    left: 100px;
    align-self: center;
  }

  .div-block-6 {
    display: flex;
    padding-top: 25px;
    padding-bottom: 25px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .div-block-7 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-family: Inter, sans-serif;
  }

  .heading-22 {
    align-self: flex-start;
  }

  .heading-23 {
    align-self: flex-start;
  }

  .heading-24 {
    align-self: flex-start;
  }

  .heading-25 {
    align-self: flex-start;
  }

  .heading-26 {
    align-self: flex-start;
  }

  .heading-27 {
    align-self: flex-start;
  }

  .text-block-46 {
    padding-bottom: 25px;
  }

  .text-block-47 {
    padding-bottom: 25px;
  }

  .image-60 {
    left: auto;
  }

  .text-block-48 {
    line-height: 300%;
  }

  .form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }

  .menu-button-6 {
    left: -390px;
  }
}

@media screen and (max-width: 767px) {
  .navbar-brand {
    padding-left: 0px;
  }

  .nav-menu {
    padding-bottom: 30px;
    padding-left: 0px;
    flex-direction: column;
  }

  .nav-link {
    display: inline-block;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .nav-dropdown {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .nav-dropdown-toggle {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .nav-dropdown-list.shadow-three {
    box-shadow: 0 8px 50px 0 rgba(0, 0, 0, 0.05);
  }

  .nav-dropdown-list.shadow-three.w--open {
    position: relative;
  }

  .nav-dropdown-list.shadow-three.mobile-shadow-hide {
    box-shadow: none;
  }

  .mobile-margin-top-10 {
    margin-top: 10px;
  }

  .hero-heading-center {
    padding: 60px 15px;
  }

  .heading-2 {
    margin-top: 10px;
    padding-left: 10px;
  }

  .text-block-5 {
    display: flex;
    margin-right: 0px;
    margin-left: 0px;
    padding-right: 20px;
    padding-left: 20px;
    justify-content: center;
    align-items: center;
  }

  .image-2 {
    margin-left: 0px;
  }

  .navbar-brand-2 {
    padding-left: 0px;
  }

  .nav-menu-2 {
    padding-bottom: 30px;
    padding-left: 0px;
    flex-direction: column;
  }

  .nav-link-2 {
    display: inline-block;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .nav-dropdown-2 {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .nav-dropdown-toggle-2 {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .nav-dropdown-list-2.shadow-three {
    box-shadow: 0 8px 50px 0 rgba(0, 0, 0, 0.05);
  }

  .nav-dropdown-list-2.shadow-three.w--open {
    position: relative;
  }

  .nav-dropdown-list-2.shadow-three.mobile-shadow-hide {
    box-shadow: none;
  }

  .mobile-margin-top-11 {
    margin-top: 10px;
  }

  .footer-light {
    padding-right: 15px;
    padding-left: 15px;
  }

  .footer-bottom {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .footer-copyright {
    font-size: 14px;
    line-height: 20px;
  }

  .footer-social-block-two {
    margin-top: 20px;
  }

  .footer-social-link {
    margin-left: 20px;
  }

  .heading-10 {
    width: 100%;
    height: 72.3224%;
    min-height: 63%;
  }

  .text-block-9 {
    width: 70%;
    border-radius: 0px;
    opacity: 0.6;
    color: #fff;
  }

  .image-18 {
    display: block;
    align-self: center;
  }

  .image-19 {
    display: block;
    align-self: center;
  }

  .container-6 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .image-20 {
    position: static;
    left: 0px;
    top: auto;
    margin-top: 20px;
  }

  .image-21 {
    left: 0px;
    top: 10px;
  }

  .image-25 {
    align-self: center;
  }

  .heading-13 {
    margin-left: 0px;
    padding-right: 20px;
    padding-left: 20px;
  }

  .text-block-12 {
    margin-left: 0px;
    padding-right: 20px;
    padding-left: 20px;
  }

  .heading-14 {
    margin-left: 0px;
    padding-left: 20px;
  }

  .text-block-13 {
    margin-left: 0px;
    padding-bottom: 20px;
    padding-left: 20px;
  }

  .text-block-14 {
    margin-left: 0px;
    padding-right: 20px;
    padding-left: 20px;
  }

  .div-block {
    margin-right: 20px;
    margin-left: 20px;
    padding-right: 20px;
    padding-left: 20px;
    border-top: 1px solid #fff;
    border-radius: 2px;
    opacity: 0.6;
  }

  .section-9 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .container-11 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .section-10 {
    flex-direction: column;
  }

  .container-12 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .section-12 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .button-5.w--current {
    left: 27px;
  }

  .columns-3 {
    display: flex;
  }

  .menu-button-6 {
    left: -277px;
  }
}

@media screen and (max-width: 479px) {
  .nav-menu {
    flex-direction: column;
  }

  .nav-button-wrapper {
    width: auto;
  }

  .body {
    max-height: none;
    max-width: none;
    min-width: 100%;
  }

  .container-2 {
    max-width: none;
  }

  .centered-heading {
    margin-bottom: 24px;
  }

  .heading-2 {
    padding-right: 10px;
    padding-left: 10px;
    font-size: 24px;
  }

  .text-block-5 {
    margin: 0px;
    padding: 20px;
    opacity: 0.6;
    color: #fff;
    text-align: center;
  }

  .image-2 {
    position: relative;
    left: 0%;
    top: 0%;
    right: 0%;
    bottom: 0%;
    margin-top: 0px;
    margin-left: 0px;
    padding-top: 20px;
    float: none;
  }

  .nav-menu-2 {
    flex-direction: column;
  }

  .nav-button-wrapper-2 {
    width: auto;
  }

  .heading-4 {
    padding-left: 0px;
  }

  .paragraph-2 {
    margin-top: 218px;
  }

  .paragraph-3 {
    width: 100%;
    font-size: 14px;
  }

  .paragraph-5 {
    margin-top: 21px;
  }

  .paragraph-6 {
    margin-top: 250px;
  }

 

  .heading-7 {
    min-height: 0px;
    min-width: 0px;
    margin-left: 0px;
    padding: 165px 20px 0px;
    font-size: 24px;
    line-height: 136.5%;
  }

  .image-12 {
    max-width: 95%;
    min-height: auto;
    min-width: auto;
    padding-top: 100px;
  }

  .container-5 {
    max-width: none;
  }

  .footer-wrapper-two {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .footer-block-two {
    margin-top: 40px;
  }

  .footer-bottom {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .footer-social-block-two {
    margin-top: 20px;
  }

  .heading-8 {
    width: 100%;
    padding-bottom: 25px;
    line-height: 80px;
  }

  .field-label-2 {
    margin-bottom: 0px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .text-field {
    width: 80%;
    height: 40px;
    min-width: auto;
    margin-bottom: 0px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
    background-size: auto;
    color: #fff;
  }

  .text-field-2 {
    width: 91%;
    height: 43px;
    min-width: auto;
    margin-bottom: 0px;
    padding-bottom: 30px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___}), url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-position: 0px 0px, 0px 0px;
    background-size: auto, auto;
    color: #fff;
  }

  .field-label-3 {
    margin-bottom: 0px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .field-label-4 {
    margin-bottom: 0px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .submit-button {
    width: 97%;
    height: 60px;
    min-height: auto;
    min-width: auto;
    margin-left: 0px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
    color: transparent;
  }

  .textarea-2 {
    width: 100%;
    color: #fff;
  }

  .column-2 {
    margin-top: 0px;
  }

  .select-field {
    width: 100%;
    min-width: auto;
    color: #fff;
  }

  .heading-10 {
    min-height: 184px;
    margin-top: -60px;
    margin-left: 0px;
    padding: 20px 20px;
    font-size: 40px;
    line-height: 136%;
  }

  .text-block-9 {
    min-height: 129px;
    width: 100%;
    margin-left: 0px;
    padding-right: 20px;
    padding-left: 20px;
    font-size: 14px;
    line-height: 210%;
  }

  .image-17 {
    position: static;
    left: 0px;
    top: auto;
    margin-top: 0px;
    padding-right: 20px;
    padding-left: 20px;
  }

  .image-18 {
    position: static;
    left: -8px;
    top: auto;
    margin-top: auto;
    padding-right: 20px;
    padding-left: 20px;
  }

  .image-19 {
    position: static;
    padding-right: 20px;
    padding-left: 20px;
  }

  .container-6 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .image-20 {
    left: 0px;
  }

  .image-21 {
    left: 0px;
    top: 10px;
  }

  .heading-12 {
    width: 100%;
    height: 100%;
    min-height: 378px;
    margin-top: 50px;
    margin-left: 0px;
    padding-right: 20px;
    padding-left: 20px;
    font-size: 32px;
  }

  .text-block-10 {
    width: 100%;
    height: 100%;
    margin-bottom: 100px;
    margin-left: 0px;
    padding: 10px 20px;
    opacity: 0.6;
  }

  .image-22 {
    width: 100%;
    right: auto;
    bottom: auto;
    margin-bottom: -29px;
    opacity: 0.2;
    object-fit: fill;
  }

  

  .container-7 {
    background-color: transparent;
  }

  .image-23 {
    margin-top: 15px;
  }

  .navbar-2 {
    background-color: transparent;
  }

  .nav-menu-3 {
    background-color: transparent;
  }

  .image-25 {
    position: static;
    left: -8px;
    padding-right: 20px;
    padding-left: 20px;
    float: left;
  }

  .text-block-11 {
    margin-left: -60px;
    color: #fff;
  }

  .icon {
    color: #fff;
  }

  .dropdown-link {
    margin-top: -40px;
    color: #fff;
  }

  .dropdown-list.w--open {
    background-color: transparent;
  }

  .dropdown-link-2 {
    color: #fff;
  }

  .dropdown-link-3 {
    color: #fff;
  }

  .menu-button-3 {
    background-color: transparent;
  }

  .menu-button-3.w--open {
    background-color: transparent;
  }

  .heading-13 {
    margin-left: 0px;
    padding-right: 20px;
    padding-left: 20px;
  }

  .text-block-12 {
    margin-left: 0px;
    padding-right: 20px;
    padding-left: 20px;
  }

  .heading-14 {
    margin-top: 50px;
    margin-left: 0px;
    padding-right: 20px;
    padding-left: 20px;
  }

  .text-block-13 {
    margin-left: 0px;
    padding-left: 20px;
    opacity: 0.6;
  }

  .text-block-14 {
    margin-left: 0px;
    padding-top: 20px;
    padding-right: 20px;
    padding-left: 20px;
  }

  .div-block {
    border-top: 1px solid #fff;
    border-radius: 2px;
  }

  .navbar-3 {
    background-color: transparent;
  }

  .nav-menu-4 {
    width: 80%;
    padding-top: 97px;
    background-color: #002730;
  }

  .image-26 {
    margin-top: 10px;
    padding-top: 0px;
  }

  .nav-link-11 {
    margin-top: -20px;
    color: #fff;
  }

  .nav-link-12 {
    color: #fff;
  }

  .nav-link-13 {
    color: #fff;
  }

  .text-block-15 {
    color: #fff;
  }

  .icon-2 {
    color: #fff;
  }

  .nav-link-14 {
    color: #fff;
  }

  .nav-link-15 {
    color: #fff;
  }

  .dropdown-list-2.w--open {
    background-color: transparent;
    color: #fff;
  }

  .dropdown-link-4 {
    color: #fff;
  }

  .dropdown-link-5 {
    color: #fff;
  }

  .dropdown-link-6 {
    color: #fff;
  }

  .container-8 {
    background-color: transparent;
  }

  .dropdown-toggle-2 {
    left: -90px;
    margin-left: 0px;
    padding-left: 20px;
  }

  .menu-button-4 {
    background-color: transparent;
  }

  .menu-button-4.w--open {
    background-color: transparent;
  }

  .nav-link-16 {
    padding-right: 0px;
    padding-left: 0px;
    font-size: 12px;
  }

  .nav-link-17 {
    padding-right: 10px;
    padding-left: 10px;
    font-size: 12px;
  }

  .nav-link-18 {
    padding-left: 0px;
    font-size: 12px;
  }

  .nav-menu-5 {
    margin-right: auto;
    margin-left: auto;
    padding-right: 0px;
    padding-bottom: 10px;
    padding-left: 0px;
    background-color: transparent;
  }

  .menu-button-5 {
    background-color: transparent;
  }

  .menu-button-5.w--open {
    background-color: transparent;
  }

  .image-28 {
    position: relative;
    left: -77px;
    top: -85px;
  }

  .image-29 {
    position: relative;
    left: -70px;
    top: -85px;
    padding-left: 20px;
  }

  .section-9 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .container-11 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .section-10 {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .image-30 {
    width: 80%;
    max-width: none;
    padding-bottom: 20px;
    padding-left: 10px;
  }

  .image-31 {
    max-width: 80%;
    padding-bottom: 20px;
  }

  .image-32 {
    max-width: 80%;
    padding-top: 20px;
    padding-right: 10px;
  }

  .container-12 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .heading-15 {
    font-family: Inter, sans-serif;
    color: #03e287;
    font-size: 24px;
  }

  .text-block-17 {
    padding-bottom: 16px;
  }

  .text-block-18 {
    padding-bottom: 16px;
  }

  .text-block-19 {
    padding-bottom: 16px;
    opacity: 0.6;
  }

  .container-14 {
    position: absolute;
    left: 65px;
    top: 2911px;
    max-height: 100%;
    max-width: 100%;
    padding-right: 20px;
    font-family: Inter, sans-serif;
  }

  .heading-16 {
    color: #03e287;
    font-size: 24px;
  }

  .text-block-22 {
    padding-bottom: 16px;
  }

  .text-block-23 {
    padding-bottom: 16px;
  }

  .container-15 {
    position: absolute;
    left: 59px;
    top: 3178px;
    font-family: Inter, sans-serif;
  }

  .heading-17 {
    font-family: Inter, sans-serif;
    color: #03e287;
    font-size: 24px;
  }

  .text-block-25 {
    padding-bottom: 16px;
    opacity: 0.6;
    font-family: Inter, sans-serif;
  }

  .text-block-26 {
    padding-bottom: 16px;
    font-family: Inter, sans-serif;
  }

  .container-16 {
    position: absolute;
    left: 58px;
    top: 3404px;
  }

  .heading-18 {
    font-family: Inter, sans-serif;
    color: #03e287;
    font-size: 24px;
  }

  .text-block-27 {
    font-family: Inter, sans-serif;
  }

  .container-17 {
    position: absolute;
    left: 53px;
    top: 3624px;
  }

  .text-block-28 {
    padding-bottom: 16px;
    font-family: Inter, sans-serif;
  }

  .text-block-29 {
    font-family: Inter, sans-serif;
  }

  .container-18 {
    padding-top: 20px;
    padding-bottom: 50px;
    padding-left: 10px;
  }

  .section-12 {
    align-items: center;
  }

  .grid-3 {
    display: grid;
    padding: 20px;
    grid-auto-columns: 1fr;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
  }

  .image-38 {
    left: 80px;
    display: block;
    margin-left: 0px;
  }

  .grid-5 {
    padding-right: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
  }

  .image-40 {
    margin-bottom: 20px;
  }

  .section-18 {
    display: flex;
    padding-right: 20px;
    padding-left: 20px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .heading-19 {
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
  }

  .text-block-30 {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .grid-6 {
    display: grid;
    width: 100%;
    height: 100%;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    align-self: auto;
    grid-auto-flow: row;
    grid-auto-columns: 1fr;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-template-rows: 72px auto;
  }

  .text-block-32 {
    left: auto;
    display: block;
    flex-direction: row;
    align-self: center;
    order: 0;
    font-size: 12px;
  }

  .column-3 {
    margin-top: 75px;
    padding-left: 20px;
  }

  .column-4 {
    padding-left: 20px;
  }

  .div-block-2 {
    margin-top: 50px;
    margin-left: 0px;
  }

  .div-block-4 {
    display: flex;
    padding-right: 0px;
    justify-content: center;
    font-family: Inter, sans-serif;
  }

  .text-block-33 {
    display: block;
    padding-left: 0px;
    justify-content: center;
    align-items: center;
    align-self: flex-start;
    font-size: 12px;
  }

  .text-block-34 {
    align-self: flex-start;
    order: 0;
    font-size: 12px;
  }

  .image-43 {
    max-width: 80%;
    align-self: center;
  }

  .text-block-35 {
    align-self: flex-start;
    font-size: 12px;
  }

  .text-block-36 {
    align-self: flex-start;
    font-size: 12px;
  }

  .image-44 {
    max-width: 80%;
  }

  .image-45 {
    max-width: 80%;
  }

  .image-46 {
    max-width: 80%;
  }

  .text-block-37 {
    font-size: 12px;
  }

  .text-block-38 {
    align-self: flex-start;
    font-size: 12px;
  }

  .text-block-39 {
    font-size: 12px;
  }

  .image-47 {
    max-width: 80%;
  }

  .image-48 {
    max-width: 80%;
  }

  .text-block-40 {
    font-size: 12px;
  }

  .image-49 {
    display: block;
    max-width: 80%;
    align-self: flex-start;
  }

  .image-50 {
    max-width: 80%;
  }

  .image-51 {
    max-width: 80%;
    padding-bottom: 20px;
  }

  .text-block-41 {
    padding-bottom: 20px;
    align-self: flex-start;
    font-size: 12px;
  }

  .image-52 {
    align-self: flex-start;
  }

  .text-block-42 {
    padding-bottom: 25px;
    align-self: flex-start;
    font-size: 12px;
  }

  .image-54 {
    max-width: 80%;
  }

  .text-block-43 {
    align-self: flex-start;
    font-size: 12px;
  }

  .image-55 {
    max-width: 80%;
  }

  .text-block-44 {
    align-self: flex-start;
    font-size: 12px;
  }

  .image-57 {
    max-width: 80%;
  }

  .image-58 {
    max-width: 80%;
  }

  .text-block-45 {
    align-self: flex-start;
    font-size: 12px;
  }

  .image-59 {
    max-width: 80%;
  }

  .button-3 {
    width: 40px;
    height: 40px;
    background-color: transparent;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    background-position: 0px 0px;
    background-size: auto;
  }

  .button-5 {
    left: 10px;
    width: 32%;
  }

  .button-5.w--current {
    left: 86px;
    width: 30%;
    padding-right: 0px;
  }

  .section-20 {
    margin-top: -60px;
  }

  .heading-22 {
    font-size: 20px;
  }

  .heading-23 {
    font-size: 20px;
  }

  .heading-24 {
    width: 50%;
    font-size: 20px;
  }

  .heading-25 {
    width: 80%;
    padding-left: 0px;
    font-size: 20px;
  }

  .heading-26 {
    font-size: 20px;
  }

  .heading-27 {
    font-size: 20px;
  }

  .text-block-46 {
    align-self: flex-start;
    font-size: 12px;
  }

  .text-block-47 {
    align-self: flex-start;
    font-size: 12px;
  }

  .heading-28 {
    max-width: 80%;
    font-size: 20px;
  }

  .heading-29 {
    max-width: 80%;
    font-size: 20px;
  }

  .heading-30 {
    font-size: 20px;
  }

  .heading-31 {
    max-width: 80%;
    font-size: 20px;
  }

  .heading-32 {
    font-size: 20px;
    font-weight: 700;
  }

  .heading-33 {
    font-size: 20px;
  }

  .heading-34 {
    font-size: 20px;
  }

  .heading-35 {
    width: 80%;
    font-size: 20px;
  }

  .column-7 {
    display: flex;
    flex-direction: column;
  }

  .text-block-48 {
    padding-left: 25px;
    line-height: 250%;
  }

  .columns-3 {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .image-61 {
    padding-bottom: 10px;
  }

  .image-62 {
    padding-bottom: 10px;
  }

  .menu-button-6 {
    left: -234px;
    background-color: transparent;
  }

  .image-64 {
    width: 90%;
    max-width: none;
  }

  .container-20 {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .section-22 {
    display: inline-block;
  }

  .image-65 {
    max-width: 80%;
  }

  .text-block-51 {
    align-self: flex-start;
    font-size: 12px;
  }

  .text-block-52 {
    align-self: flex-start;
    font-size: 12px;
  }

  .text-block-53 {
    align-self: flex-start;
    font-size: 12px;
  }

  .text-block-54 {
    align-self: flex-start;
    font-size: 12px;
  }

  .text-block-55 {
    max-width: 80%;
    align-self: flex-start;
    font-size: 12px;
  }

  .text-block-56 {
    align-self: flex-start;
  }

  .text-block-57 {
    align-self: flex-start;
    font-size: 12px;
  }

  .heading-36 {
    max-width: 80%;
    align-self: flex-start;
    font-size: 12px;
  }

  .heading-37 {
    max-width: 80%;
    align-self: flex-start;
    font-size: 20px;
  }
}

@media screen and (min-width: 1920px) {
  #w-node-_0a7a8c99-ea77-4198-995e-5a9c886ab140-b508944f {
    grid-column-start: span 1;
    -ms-grid-column-span: 1;
    grid-column-end: span 1;
    grid-row-start: span 1;
    -ms-grid-row-span: 1;
    grid-row-end: span 1;
  }

  #w-node-_49e540cd-072e-b366-bc18-cc663cef7cba-b508944f {
    grid-column-start: span 1;
    -ms-grid-column-span: 1;
    grid-column-end: span 1;
    grid-row-start: span 1;
    -ms-grid-row-span: 1;
    grid-row-end: span 1;
  }

  #w-node-c82dcc88-eba5-1491-e2f6-a52d47293a8d-b508944f {
    grid-column-start: span 1;
    -ms-grid-column-span: 1;
    grid-column-end: span 1;
    grid-row-start: span 1;
    -ms-grid-row-span: 1;
    grid-row-end: span 1;
  }

  #w-node-cfa57362-1001-5e3f-623e-bfaa4393e68d-b508944f {
    grid-column-start: span 1;
    -ms-grid-column-span: 1;
    grid-column-end: span 1;
    grid-row-start: span 1;
    -ms-grid-row-span: 1;
    grid-row-end: span 1;
  }

  #w-node-_010cbedd-6fb8-3014-299a-74b500317e23-b508944f {
    grid-column-start: span 1;
    -ms-grid-column-span: 1;
    grid-column-end: span 1;
    grid-row-start: span 1;
    -ms-grid-row-span: 1;
    grid-row-end: span 1;
  }

  #w-node-b12b6411-2875-daad-7590-22e0aee6a84a-b508944f {
    grid-column-start: span 1;
    -ms-grid-column-span: 1;
    grid-column-end: span 1;
    grid-row-start: span 1;
    -ms-grid-row-span: 1;
    grid-row-end: span 1;
  }

  #w-node-_8cdaead8-6806-eaa6-0e7f-adf391103dcc-b508944f {
    grid-column-start: span 1;
    -ms-grid-column-span: 1;
    grid-column-end: span 1;
    grid-row-start: span 1;
    -ms-grid-row-span: 1;
    grid-row-end: span 1;
  }

  #w-node-_8d34484b-5af1-0196-3545-2efacb059d52-b508944f {
    grid-column-start: span 1;
    -ms-grid-column-span: 1;
    grid-column-end: span 1;
    grid-row-start: span 1;
    -ms-grid-row-span: 1;
    grid-row-end: span 1;
  }

  #w-node-_65d39dd0-7a4b-de21-c29e-2a231b55d495-b508944f {
    grid-column-start: span 1;
    -ms-grid-column-span: 1;
    grid-column-end: span 1;
    grid-row-start: span 1;
    -ms-grid-row-span: 1;
    grid-row-end: span 1;
  }

  #w-node-_0e11f50c-4447-db37-8817-c599062737e9-b508944f {
    grid-column-start: span 1;
    -ms-grid-column-span: 1;
    grid-column-end: span 1;
    grid-row-start: span 1;
    -ms-grid-row-span: 1;
    grid-row-end: span 1;
  }

  #w-node-_0776ad76-4161-a92d-5968-9059a2dd937c-b508944f {
    grid-column-start: span 1;
    -ms-grid-column-span: 1;
    grid-column-end: span 1;
    grid-row-start: span 1;
    -ms-grid-row-span: 1;
    grid-row-end: span 1;
  }
}

@media screen and (max-width: 479px) {
  #w-node-_0776ad76-4161-a92d-5968-9059a2dd937c-b508944f {
    justify-self: auto;
    align-self: auto;
    -ms-grid-column-span: 1;
    grid-column-end: span 1;
    grid-column-start: span 1;
    -ms-grid-row-span: 1;
    grid-row-end: span 1;
    grid-row-start: span 1;
  }
}

@font-face {
  font-family: 'Fontspring demo nekst';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('opentype');
  font-weight: 100;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Fontspring demo nekst';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('opentype');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Fontspring demo nekst';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('opentype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Fontspring demo nekst';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('opentype');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Fontspring demo nekst';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('opentype');
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Fontspring demo nekst';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('opentype');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Fontspring demo nekst';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('opentype');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}
.partners{
  display: flex;
  justify-content: space-between;
}
.partners img{
  object-fit: contain;
}
@media screen and (max-width: 1440px) {
  .partners img{
    max-width: 135px;
    max-height: 40px;
  }
}
@media screen and (max-width: 834px) {
  .partners{
    justify-content: center;
    flex-wrap: wrap;
  }
}
@media screen and (max-width: 834px) {
  .partners img{
    max-width: 100px;
  }
}
.team img{
  margin-right: auto;
  margin-left: auto;
}
@media screen and (min-width: 834px) {
  .div-block-4{
    width: 80%;
  }
}
.section-3{
  margin-top: 5rem;
}
@media screen and (min-width: 1440px) {
  .section-3{
    margin-top: 10rem;
  }
}


.price-ticker {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px solid #ccc;
  border-radius: 10px;
  padding: 20px;
  margin: 20px;
  width: 300px;
  text-align: center;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
}

.price-ticker h2 {
  margin-bottom: 15px;
  font-size: 22px;
  color: #333;
}

.price-ticker p {
  font-size: 18px;
  color: #2b9348;
}

.price-ticker p.error {
  color: red;
}
`, "",{"version":3,"sources":["webpack://./src/styles/kwe-website.webflow.css"],"names":[],"mappings":";AACA;EAEE,aAAa;EACb,sBAAsB;EAEtB,8BAA8B;EAE9B,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EAIE,aAAa;EAIb,8BAA8B;EAI9B,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EAIE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EAIjB,8BAA8B;EAI9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,yDAAyD;EACzD,4BAA4B;EAC5B,qBAAqB;EACrB,6BAA6B;EAE7B,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,yDAA+C;EAC/C,4BAA4B;EAC5B,sBAAsB;EACtB,WAAW;EACX,2BAA2B;EAC3B,gCAAgC;EAEhC,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yDAA6C;EAC7C,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gDAAgD;EAChD,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EAIE,aAAa;EAIb,8BAA8B;EAI9B,mBAAmB;AACrB;;AAEA;EAIE,aAAa;EACb,cAAc;EAKd,sBAAsB;EAItB,2BAA2B;EAI3B,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EAEzB,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;EAChD,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAE3B,kCAAkC;AACpC;;AAEA;EACE,yDAA2C;EAC3C,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EAIE,aAAa;EAIb,8BAA8B;EAI9B,mBAAmB;AACrB;;AAEA;EAIE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EAIjB,8BAA8B;EAI9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EAEzB,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yDAA2C;EAC3C,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gDAAgD;EAChD,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;EAChD,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EAIE,aAAa;EAKb,mBAAmB;AACrB;;AAEA;EAIE,aAAa;EAIb,cAAY;EACZ,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA;EAIE,aAAa;EAKb,mBAAmB;EAInB,uBAAuB;EAIvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EAEE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gDAAgD;EAChD,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,gDAAgD;EAChD,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EAIE,aAAa;EACb,iBAAiB;EAIjB,8BAA8B;EAI9B,uBAAuB;EACvB,WAAW;AACb;;AAEA;EAIE,aAAa;EAKb,sBAAsB;EAItB,2BAA2B;EAI3B,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EAIE,aAAa;EACb,gBAAgB;EAIhB,uBAAuB;EAIvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,2BAA2B;EAC3B,8BAA8B;EAE9B,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAoBA;EACE,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,+BAA+B;EAC/B,yBAAyB;EACzB,4BAA4B;EAC5B,qBAAqB;EACrB,4BAA4B;EAE5B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EAIE,aAAa;EAIb,8BAA8B;EAI9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EAIE,aAAa;EACb,eAAe;EACf,kBAAkB;EAIlB,2BAA2B;EAI3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;EAC7B,yDAAuD;EACvD,4BAA4B;EAC5B,qBAAqB;EACrB,8BAA8B;EAE9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;EAC7B,yDAAuD;EACvD,4BAA4B;EAC5B,qBAAqB;EACrB,8BAA8B;EAE9B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;EAC7B,yDAAuD;EACvD,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,6BAA6B;EAC7B,yDAAyD;EACzD,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,6BAA6B;EAC7B,yDAAuD;EACvD,4BAA4B;EAC5B,qBAAqB;EACrB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,6BAA6B;EAC7B,yDAAyD;EACzD,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EAIE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EAKjB,sBAAsB;EAItB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EAIE,gBAAgB;EAIhB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;EAC7B,yDAAuD;EACvD,4BAA4B;EAC5B,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gDAAgD;EAChD,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAcA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,gDAAgD;EAChD,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAElB,8BAA8B;EAE9B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,gDAAgD;EAChD,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EAIE,aAAa;EACb,WAAW;EAKX,mBAAmB;EAInB,uBAAuB;EAIvB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EAIE,aAAa;EACb,mBAAmB;EAKnB,sBAAsB;EAItB,uBAAuB;EAIvB,mBAAmB;AACrB;;AAEA;EAIE,aAAa;EACb,eAAe;EACf,iBAAiB;EAIjB,uBAAuB;EAIvB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EAIE,aAAa;EACb,qBAAqB;EAIrB,mBAAmB;AACrB;;AAEA;EAIE,aAAa;EAIb,uBAAuB;EAIvB,mBAAmB;AACrB;;AAEA;EAIE,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EAKrB,sBAAsB;EAItB,uBAAuB;EAIvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EAIE,aAAa;EAIb,uBAAuB;EACvB,qBAAqB;EAIrB,mBAAmB;EAGnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,aAAa;EAKb,mBAAmB;EAInB,uBAAuB;EAIvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EAIE,aAAa;EAKb,sBAAsB;EAItB,uBAAuB;EAIvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EAIE,aAAa;EAKb,sBAAsB;EAItB,uBAAuB;EAIvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EAGE,sBAAsB;AACxB;;AAEA;EAGE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,yDAA8D;EAC9D,4BAA4B;EAC5B,qBAAqB;;AAEvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,yDAAyD;EACzD,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EAIE,aAAa;EACb,WAAW;EAIX,uBAAuB;EAIvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,yDAA6C;EAC7C,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,yDAA6C;EAC7C,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EAIE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EAKpB,sBAAsB;EAItB,uBAAuB;EAIvB,mBAAmB;AACrB;;AAEA;EAIE,aAAa;EACb,WAAW;EACX,kBAAkB;EAKlB,mBAAmB;EAInB,uBAAuB;EAIvB,mBAAmB;EAGnB,kBAAkB;EAIlB,cAAY;AACd;;AAEA;EAGE,sBAAsB;AACxB;;AAEA;EAGE,sBAAsB;AACxB;;AAEA;EAGE,sBAAsB;AACxB;;AAEA;EAGE,sBAAsB;AACxB;;AAEA;EAGE,sBAAsB;AACxB;;AAEA;EAGE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EAIE,aAAa;EAKb,mBAAmB;EAInB,uBAAuB;EAIvB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EAGE,sBAAsB;AACxB;;AAEA;EAGE,sBAAsB;AACxB;;AAEA;EAGE,sBAAsB;AACxB;;AAEA;EAGE,sBAAsB;AACxB;;AAEA;EAGE,sBAAsB;AACxB;;AAEA;EAGE,sBAAsB;AACxB;;AAEA;EAGE,sBAAsB;AACxB;;AAEA;EAGE,sBAAsB;AACxB;;AAEA;EAIE,uBAAuB;EAGvB,qBAAqB;EACrB,mBAAmB;EAEnB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAIlB,aAAa;EACb,WAAW;EAKX,sBAAsB;EAItB,uBAAuB;EAIvB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gDAAgD;EAChD,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAIhB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IAIE,aAAa;IACb,YAAY;IACZ,gBAAgB;IAKhB,sBAAsB;IAItB,uBAAuB;IAIvB,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAElB,8BAA8B;IAE9B,6BAA6B;EAC/B;;EAEA;IACE,SAAS;IACT,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,SAAS;IACT,YAAY;EACd;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAKlB,mBAAmB;IACnB,6BAA6B;IAC7B,WAAW;EACb;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,YAAY;EACd;;EAEA;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,gDAAgD;IAChD,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,8BAA8B;IAC9B,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;IAC9B,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;IAC9B,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IAKjB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,6BAA6B;EAC/B;;EAEA;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAIlB,aAAa;IACb,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IAKX,mBAAmB;IAInB,uBAAuB;IAIvB,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IAIE,aAAa;EACf;;EAEA;IAIE,aAAa;IAKb,sBAAsB;EACxB;;EAEA;IAIE,aAAa;IAKb,sBAAsB;EACxB;;EAEA;IAIE,aAAa;IACb,iBAAiB;IAKjB,mBAAmB;IAInB,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IAIE,aAAa;IAKb,sBAAsB;IAItB,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IAIE,aAAa;IACb,gBAAgB;IAKhB,sBAAsB;IAItB,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IAGE,oBAAoB;IACpB,8BAA8B;IAC9B,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IAGpB,oBAAoB;IACpB,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IAGpB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IAGpB,oBAAoB;IACpB,YAAY;IACZ,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IAGE,oBAAoB;IACpB,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,UAAU;IAIV,aAAa;IAKb,sBAAsB;IAGtB,iBAAiB;EACnB;;EAEA;IACE,8BAA8B;IAC9B,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IAIX,aAAa;IAKb,sBAAsB;IAGtB,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,8BAA8B;IAC9B,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,YAAY;IACZ,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,8BAA8B;IAC9B,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,oBAAoB;IACpB,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,eAAe;EACjB;;EAEA;IAIE,aAAa;IAKb,mBAAmB;IAInB,uBAAuB;IACvB,qBAAqB;IAIrB,mBAAmB;EACrB;;EAEA;IAIE,aAAa;IACb,qBAAqB;IAKrB,mBAAmB;IAInB,uBAAuB;IAIvB,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAElB,8BAA8B;IAE9B,6BAA6B;EAC/B;;EAEA;IAEE,kCAAkC;EACpC;;EAEA;IACE,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IAIE,aAAa;IAIb,uBAAuB;IAIvB,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAElB,8BAA8B;IAE9B,6BAA6B;EAC/B;;EAEA;IAIE,aAAa;IACb,oBAAoB;IAKpB,sBAAsB;IAItB,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IAIE,aAAa;IAIb,uBAAuB;IAIvB,mBAAmB;IACnB,gDAAgD;IAChD,kBAAkB;EACpB;;EAEA;IAEE,aAAa;IACb,gBAAgB;IAIhB,uBAAuB;IAIvB,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAElB,0CAA0C;IAE1C,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,cAAc;IACd,eAAe;IAKf,mBAAmB;IAInB,gBAAgB;IAIhB,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IAIE,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IAKnB,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;IAIV,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,UAAU;IAIV,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IAIV,kBAAkB;EACpB;;EAEA;IACE,UAAU;IAIV,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IAIE,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IAIjB,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IAIE,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IAIjB,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IAIE,aAAa;IACb,WAAW;IAKX,mBAAmB;IAInB,2BAA2B;IAI3B,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,UAAU;IAIV,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,oBAAoB;IAIpB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,oBAAoB;IAIpB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,oBAAoB;IAIpB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,UAAU;IAIV,kBAAkB;EACpB;;EAEA;IACE,UAAU;IAIV,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,UAAU;IAIV,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,UAAU;IAIV,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IAIV,kBAAkB;EACpB;;EAEA;IACE,UAAU;IAIV,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,UAAU;IAIV,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,qBAAqB;IACrB,6BAA6B;IAC7B,yDAA8D;IAC9D,4BAA4B;IAC5B,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,6BAA6B;IAC7B,yDAA8D;IAC9D,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,6BAA6B;IAC7B,yDAAyD;IACzD,4BAA4B;IAC5B,qBAAqB;EACvB;;EAEA;IAIE,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IAKjB,mBAAmB;IAInB,uBAAuB;IAIvB,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAElB,8BAA8B;IAE9B,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,YAAY;IAIZ,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAIhB,uBAAuB;IAIvB,mBAAmB;IAGnB,kBAAkB;IAClB,qBAAqB;IACrB,6BAA6B;IAC7B,yDAA6C;IAC7C,4BAA4B;IAC5B,qBAAqB;EACvB;;EAEA;IAIE,aAAa;IAKb,sBAAsB;IAItB,uBAAuB;IAIvB,mBAAmB;IAGnB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IAIE,aAAa;IAKb,sBAAsB;IAItB,uBAAuB;IAIvB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gDAAgD;IAChD,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,gDAAgD;IAChD,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gDAAgD;IAChD,eAAe;IACf,gBAAgB;EAClB;;EAEA;IAIE,aAAa;IAKb,mBAAmB;IAInB,uBAAuB;IAIvB,uBAAuB;IAGvB,gBAAgB;IAIhB,QAAQ;IAER,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IAIE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,UAAU;IACV,OAAO;IACP,SAAS;IACT,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IAIE,aAAa;IAIb,uBAAuB;IAIvB,mBAAmB;IAGnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IAIjB,kBAAkB;IAIlB,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,yDAA6C;IAC7C,4BAA4B;IAC5B,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IAIjB,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IAIE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IAKjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IAEE,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAElB,0CAA0C;IAE1C,uBAAuB;EACzB;;EAEA;IAIE,aAAa;IAIb,uBAAuB;IAIvB,mBAAmB;IAEnB,0CAA0C;IAE1C,uBAAuB;EACzB;;EAEA;IAIE,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAKlB,mBAAmB;IAInB,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IAEE,kCAAkC;EACpC;;EAEA;IAEE,kCAAkC;EACpC;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IAIE,aAAa;IAKb,sBAAsB;IAItB,uBAAuB;IAIvB,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAElB,8BAA8B;IAE9B,6BAA6B;EAC/B;;EAEA;IAIE,kBAAkB;EACpB;;EAEA;IAIE,aAAa;IAKb,sBAAsB;IAItB,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IAIE,aAAa;IAKb,sBAAsB;IAItB,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gDAAgD;IAChD,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,eAAe;IAEf,0CAA0C;IAE1C,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,UAAU;IACV,UAAU;IACV,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IAGE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,6BAA6B;IAC7B,yDAAyD;IACzD,4BAA4B;IAC5B,qBAAqB;EACvB;;EAEA;IAIE,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IAIjB,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,6BAA6B;IAC7B,yDAA6C;IAC7C,4BAA4B;IAC5B,qBAAqB;EACvB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IAIE,aAAa;IACb,iBAAiB;IAGjB,6BAA6B;IAG7B,eAAe;IAIf,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IAKpB,sBAAsB;IAItB,2BAA2B;IAI3B,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IAIE,aAAa;IACb,iBAAiB;IAGjB,6BAA6B;IAG7B,eAAe;IAIf,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;;;EAIA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IAGE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,UAAU;IACV,OAAO;IACP,SAAS;IACT,YAAY;IACZ,eAAe;IACf,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;IAC7B,6BAA6B;IAC7B,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,UAAU;IAIV,aAAa;IACb,gBAAgB;IAKhB,mBAAmB;IAInB,2BAA2B;IAI3B,mBAAmB;IAGnB,gBAAgB;EAClB;;EAEA;IAKE,sBAAsB;EACxB;;EAEA;IAIE,aAAa;IAKb,sBAAsB;IAItB,uBAAuB;IAIvB,mBAAmB;IAGnB,kBAAkB;EACpB;;EAEA;IAIE,aAAa;IAKb,sBAAsB;IAItB,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IAEE,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAElB,8BAA8B;IAE9B,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IAIE,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IAKpB,sBAAsB;IAItB,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IAIE,aAAa;IAKb,sBAAsB;IAItB,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IAGpB,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IAGpB,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IAGpB,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,yDAA8D;IAC9D,4BAA4B;IAC5B,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IAIX,kBAAkB;EACpB;;EAEA;IAIE,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IAKpB,sBAAsB;IAItB,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IAIE,aAAa;IAKb,sBAAsB;IAItB,uBAAuB;IAIvB,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IAGE,sBAAsB;EACxB;;EAEA;IAGE,sBAAsB;EACxB;;EAEA;IAGE,sBAAsB;EACxB;;EAEA;IAGE,sBAAsB;EACxB;;EAEA;IAGE,sBAAsB;EACxB;;EAEA;IAGE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IAIE,aAAa;IAKb,sBAAsB;IAItB,uBAAuB;IAIvB,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;IAKjB,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IAIE,aAAa;IAKb,sBAAsB;IAItB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IAIE,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAIlB,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;IAKjB,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IAIE,aAAa;IAKb,sBAAsB;IAItB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IAKE,sBAAsB;IAItB,2BAA2B;IAI3B,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,cAAc;IAId,kBAAkB;EACpB;;EAEA;IACE,cAAc;IAId,kBAAkB;EACpB;;EAEA;IAIE,aAAa;IAKb,sBAAsB;IAItB,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,SAAS;EACX;;EAEA;IAIE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;IAClB,YAAY;EACd;;EAEA;IAIE,aAAa;IAKb,sBAAsB;IAItB,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IAIE,aAAa;IAKb,sBAAsB;IAItB,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IAKE,sBAAsB;EACxB;;EAEA;IAIE,aAAa;IAKb,sBAAsB;IAItB,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IAIE,aAAa;IAKb,sBAAsB;IAItB,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IAIE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IAKE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,YAAY;IACZ,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,SAAS;IACT,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IAKE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;;;EAIA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IAKE,sBAAsB;IAItB,2BAA2B;IAI3B,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IAKE,sBAAsB;IAItB,2BAA2B;IAI3B,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,yDAAyD;IACzD,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,kGAAgG;IAChG,qCAAqC;IACrC,2BAA2B;IAC3B,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,yDAAsD;IACtD,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IAIE,aAAa;IAKb,sBAAsB;IAItB,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;IACT,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,YAAY;IAEZ,gBAAgB;EAClB;;;;EAIA;IACE,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,6BAA6B;IAC7B,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,kBAAkB;EACpB;;EAEA;IAIE,aAAa;IAKb,sBAAsB;IAItB,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IAIE,aAAa;IAKb,sBAAsB;IAItB,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IAKE,sBAAsB;IAItB,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IAIE,aAAa;IAKb,sBAAsB;IAItB,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;IAC9B,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,YAAY;IACZ,8BAA8B;EAChC;;EAEA;IACE,oBAAoB;IACpB,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IAIE,mBAAmB;EACrB;;EAEA;IAEE,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAElB,8BAA8B;IAE9B,6BAA6B;EAC/B;;EAEA;IACE,UAAU;IACV,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IAIE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAKlB,sBAAsB;IAItB,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IAIE,aAAa;IAIb,uBAAuB;IAIvB,mBAAmB;IAGnB,kBAAkB;EACpB;;EAEA;IAIE,aAAa;IAKb,mBAAmB;IAInB,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IAEE,aAAa;IACb,WAAW;IACX,YAAY;IAKZ,mBAAmB;IAInB,uBAAuB;IAIvB,mBAAmB;IAEnB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAElB,0CAA0C;IAE1C,6BAA6B;EAC/B;;EAEA;IACE,UAAU;IACV,cAAc;IAKd,mBAAmB;IAInB,kBAAkB;IAIlB,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IAIE,aAAa;IACb,kBAAkB;IAIlB,uBAAuB;IACvB,8BAA8B;EAChC;;EAEA;IACE,cAAc;IACd,iBAAiB;IAIjB,uBAAuB;IAIvB,mBAAmB;IAGnB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IAGE,sBAAsB;IAItB,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,cAAc;IAId,kBAAkB;EACpB;;EAEA;IAGE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IAGE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IAGE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,cAAc;IAGd,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IAGpB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IAGE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;IAGpB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IAGE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IAGE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IAGE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,yDAA8D;IAC9D,4BAA4B;IAC5B,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IAGE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IAGE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IAIE,aAAa;IAKb,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IAIE,aAAa;IAKb,mBAAmB;IAInB,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,6BAA6B;EAC/B;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IAIE,aAAa;IAIb,uBAAuB;IAIvB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IAGE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IAGE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IAGE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IAGE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,cAAc;IAGd,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IAGE,sBAAsB;EACxB;;EAEA;IAGE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,cAAc;IAGd,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,cAAc;IAGd,sBAAsB;IACtB,eAAe;EACjB;AACF;;AAEA;EACE;IAEE,yBAAyB;IACzB,uBAAuB;IACvB,uBAAuB;IAEvB,sBAAsB;IACtB,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IAEE,yBAAyB;IACzB,uBAAuB;IACvB,uBAAuB;IAEvB,sBAAsB;IACtB,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IAEE,yBAAyB;IACzB,uBAAuB;IACvB,uBAAuB;IAEvB,sBAAsB;IACtB,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IAEE,yBAAyB;IACzB,uBAAuB;IACvB,uBAAuB;IAEvB,sBAAsB;IACtB,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IAEE,yBAAyB;IACzB,uBAAuB;IACvB,uBAAuB;IAEvB,sBAAsB;IACtB,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IAEE,yBAAyB;IACzB,uBAAuB;IACvB,uBAAuB;IAEvB,sBAAsB;IACtB,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IAEE,yBAAyB;IACzB,uBAAuB;IACvB,uBAAuB;IAEvB,sBAAsB;IACtB,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IAEE,yBAAyB;IACzB,uBAAuB;IACvB,uBAAuB;IAEvB,sBAAsB;IACtB,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IAEE,yBAAyB;IACzB,uBAAuB;IACvB,uBAAuB;IAEvB,sBAAsB;IACtB,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IAEE,yBAAyB;IACzB,uBAAuB;IACvB,uBAAuB;IAEvB,sBAAsB;IACtB,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IAEE,yBAAyB;IACzB,uBAAuB;IACvB,uBAAuB;IAEvB,sBAAsB;IACtB,oBAAoB;IACpB,oBAAoB;EACtB;AACF;;AAEA;EACE;IAEE,kBAAkB;IAElB,gBAAgB;IAChB,uBAAuB;IACvB,uBAAuB;IAEvB,yBAAyB;IACzB,oBAAoB;IACpB,oBAAoB;IAEpB,sBAAsB;EACxB;AACF;;AAEA;EACE,oCAAoC;EACpC,gEAAwE;EACxE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,gEAA0E;EAC1E,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,gEAA2E;EAC3E,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,gEAAyE;EACzE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,gEAAyE;EACzE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,gEAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,gEAAwE;EACxE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,uBAAuB;IACvB,eAAe;EACjB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ","sourcesContent":["\r\n.w-layout-grid {\r\n  display: -ms-grid;\r\n  display: grid;\r\n  grid-auto-columns: 1fr;\r\n  -ms-grid-columns: 1fr 1fr;\r\n  grid-template-columns: 1fr 1fr;\r\n  -ms-grid-rows: auto auto;\r\n  grid-template-rows: auto auto;\r\n  grid-row-gap: 16px;\r\n  grid-column-gap: 16px;\r\n}\r\n\r\n.navbar-no-shadow {\r\n  width: 100%;\r\n  height: 8.7467967%;\r\n  min-width: 100%;\r\n}\r\n\r\n.navbar-no-shadow-container {\r\n  z-index: 5;\r\n  width: 100%;\r\n  max-width: 1140px;\r\n  margin-right: auto;\r\n  margin-left: auto;\r\n  padding: 20px;\r\n  background-color: transparent;\r\n}\r\n\r\n.container-regular {\r\n  width: 100%;\r\n  max-width: 1260px;\r\n  min-height: 30px;\r\n  margin-right: auto;\r\n  margin-left: auto;\r\n}\r\n\r\n.navbar-wrapper {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: justify;\r\n  -webkit-justify-content: space-between;\r\n  -ms-flex-pack: justify;\r\n  justify-content: space-between;\r\n  -webkit-box-align: center;\r\n  -webkit-align-items: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  font-family: Inter, sans-serif;\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n}\r\n\r\n.nav-menu {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  margin-bottom: 0px;\r\n  padding-bottom: 0px;\r\n  padding-left: 0px;\r\n  -webkit-box-pack: justify;\r\n  -webkit-justify-content: space-between;\r\n  -ms-flex-pack: justify;\r\n  justify-content: space-between;\r\n  -webkit-box-align: center;\r\n  -webkit-align-items: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.nav-link {\r\n  margin-right: 5px;\r\n  margin-left: 5px;\r\n  padding: 5px 10px;\r\n  color: #fff;\r\n  font-size: 14px;\r\n  line-height: 20px;\r\n  letter-spacing: 0.25px;\r\n  text-decoration: none;\r\n}\r\n\r\n.nav-link:hover {\r\n  color: rgba(26, 27, 31, 0.75);\r\n}\r\n\r\n.nav-link:focus-visible {\r\n  border-radius: 4px;\r\n  outline-color: #0050bd;\r\n  outline-offset: 0px;\r\n  outline-style: solid;\r\n  outline-width: 2px;\r\n  color: #0050bd;\r\n}\r\n\r\n.nav-link[data-wf-focus-visible] {\r\n  border-radius: 4px;\r\n  outline-color: #0050bd;\r\n  outline-offset: 0px;\r\n  outline-style: solid;\r\n  outline-width: 2px;\r\n  color: #0050bd;\r\n}\r\n\r\n.nav-dropdown {\r\n  margin-right: 5px;\r\n  margin-left: 5px;\r\n}\r\n\r\n.nav-dropdown-toggle {\r\n  padding: 5px 30px 5px 10px;\r\n  font-size: 14px;\r\n  line-height: 20px;\r\n  letter-spacing: 0.25px;\r\n}\r\n\r\n.nav-dropdown-toggle:hover {\r\n  color: rgba(26, 27, 31, 0.75);\r\n}\r\n\r\n.nav-dropdown-toggle:focus-visible {\r\n  border-radius: 5px;\r\n  outline-color: #0050bd;\r\n  outline-offset: 0px;\r\n  outline-style: solid;\r\n  outline-width: 2px;\r\n  color: #0050bd;\r\n}\r\n\r\n.nav-dropdown-toggle[data-wf-focus-visible] {\r\n  border-radius: 5px;\r\n  outline-color: #0050bd;\r\n  outline-offset: 0px;\r\n  outline-style: solid;\r\n  outline-width: 2px;\r\n  color: #0050bd;\r\n}\r\n\r\n.nav-dropdown-icon {\r\n  margin-right: 10px;\r\n}\r\n\r\n.nav-dropdown-list {\r\n  border-radius: 12px;\r\n  background-color: #fff;\r\n}\r\n\r\n.nav-dropdown-list.w--open {\r\n  padding-top: 10px;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.nav-dropdown-link {\r\n  padding-top: 5px;\r\n  padding-bottom: 5px;\r\n  font-size: 14px;\r\n}\r\n\r\n.nav-dropdown-link:focus-visible {\r\n  border-radius: 5px;\r\n  outline-color: #0050bd;\r\n  outline-offset: 0px;\r\n  outline-style: solid;\r\n  outline-width: 2px;\r\n  color: #0050bd;\r\n}\r\n\r\n.nav-dropdown-link[data-wf-focus-visible] {\r\n  border-radius: 5px;\r\n  outline-color: #0050bd;\r\n  outline-offset: 0px;\r\n  outline-style: solid;\r\n  outline-width: 2px;\r\n  color: #0050bd;\r\n}\r\n\r\n.nav-button-wrapper {\r\n  margin-left: 120px;\r\n}\r\n\r\n.button-primary {\r\n  overflow: visible;\r\n  width: 180px;\r\n  height: 56px;\r\n  padding: 12px 25px;\r\n  border: 1px none #000;\r\n  background-color: transparent;\r\n  background-image: url('./../images/Frame-1261152715.png');\r\n  background-position: 0px 0px;\r\n  background-size: auto;\r\n  background-attachment: scroll;\r\n  -webkit-transition: all 200ms ease;\r\n  transition: all 200ms ease;\r\n  color: transparent;\r\n  font-size: 17px;\r\n  line-height: 33px;\r\n  letter-spacing: 2px;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.button-primary:hover {\r\n  background-color: #32343a;\r\n  color: #fff;\r\n}\r\n\r\n.button-primary:active {\r\n  background-color: #43464d;\r\n}\r\n\r\n.body {\r\n  max-height: 100%;\r\n  max-width: 100%;\r\n  min-height: 100%;\r\n  min-width: 100%;\r\n  background-color: transparent;\r\n  background-image: url('./../images/BG-FAQ.png');\r\n  background-position: 0px 0px;\r\n  background-size: cover;\r\n  color: #fff;\r\n  background-clip: border-box;\r\n  -webkit-text-fill-color: inherit;\r\n  -o-object-fit: fill;\r\n  object-fit: fill;\r\n  padding-right: 25px;\r\n  padding-left:25px;\r\n}\r\n\r\n.image {\r\n  width: 100%;\r\n  height: 100%;\r\n  max-height: 40px;\r\n  max-width: 119px;\r\n  min-height: 40px;\r\n  min-width: 119px;\r\n  margin-left: -124px;\r\n  background-image: url('./../images/LOGO.svg');\r\n  background-position: 0px 0px;\r\n  background-size: auto;\r\n}\r\n\r\n.text-block {\r\n  color: #fff;\r\n}\r\n\r\n.heading {\r\n  margin-top: 69px;\r\n  margin-left: -72px;\r\n  font-family: 'Fontspring demo nekst', sans-serif;\r\n  color: #fff;\r\n  font-size: 80px;\r\n  line-height: 90px;\r\n}\r\n\r\n.container {\r\n  font-size: 80px;\r\n}\r\n\r\n.text-block-2 {\r\n  font-size: 12px;\r\n}\r\n\r\n.text-block-3 {\r\n  font-size: 12px;\r\n}\r\n\r\n.text-block-4 {\r\n  width: 591px;\r\n  height: 118px;\r\n  margin-bottom: 80px;\r\n  margin-left: -72px;\r\n  font-family: Inter, sans-serif;\r\n  color: #5f5f5f;\r\n  font-size: 16px;\r\n  line-height: 35px;\r\n}\r\n\r\n.hero-heading-center {\r\n  position: relative;\r\n  padding: 80px 30px;\r\n  border-bottom: 1px solid #e4ebf3;\r\n  background-color: #f5f7fa;\r\n}\r\n\r\n.container-2 {\r\n  width: 100%;\r\n  max-width: 940px;\r\n  margin-right: auto;\r\n  margin-left: auto;\r\n}\r\n\r\n.centered-heading {\r\n  margin-bottom: 16px;\r\n  text-align: center;\r\n}\r\n\r\n.centered-heading.margin-bottom-32px {\r\n  margin-bottom: 32px;\r\n}\r\n\r\n.hero-wrapper {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: justify;\r\n  -webkit-justify-content: space-between;\r\n  -ms-flex-pack: justify;\r\n  justify-content: space-between;\r\n  -webkit-box-align: center;\r\n  -webkit-align-items: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.hero-split {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  max-width: 46%;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -webkit-flex-direction: column;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  -webkit-box-pack: start;\r\n  -webkit-justify-content: flex-start;\r\n  -ms-flex-pack: start;\r\n  justify-content: flex-start;\r\n  -webkit-box-align: start;\r\n  -webkit-align-items: flex-start;\r\n  -ms-flex-align: start;\r\n  align-items: flex-start;\r\n}\r\n\r\n.margin-bottom-24px {\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.button-primary-2 {\r\n  padding: 12px 25px;\r\n  background-color: #1a1b1f;\r\n  -webkit-transition: all 200ms ease;\r\n  transition: all 200ms ease;\r\n  color: #fff;\r\n  font-size: 12px;\r\n  line-height: 20px;\r\n  letter-spacing: 2px;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.button-primary-2:hover {\r\n  background-color: #32343a;\r\n  color: #fff;\r\n}\r\n\r\n.button-primary-2:active {\r\n  background-color: #43464d;\r\n}\r\n\r\n.shadow-two {\r\n  box-shadow: 0 4px 24px 0 rgba(150, 163, 181, 0.08);\r\n}\r\n\r\n.heading-2 {\r\n  margin-top: 20px;\r\n  font-family: 'Fontspring demo nekst', sans-serif;\r\n  color: #fff;\r\n  font-size: 44px;\r\n  text-align: center;\r\n}\r\n\r\n.text-block-5 {\r\n  margin: 20px 200px 20px 230px;\r\n  padding-right: 70px;\r\n  padding-left: 70px;\r\n  font-family: Inter, sans-serif;\r\n  color: #5f5f5f;\r\n  font-size: 16px;\r\n  line-height: 25px;\r\n  text-align: center;\r\n}\r\n\r\n.image-2 {\r\n  margin-top: 97px;\r\n  margin-left: 413px;\r\n  text-align: center;\r\n}\r\n\r\n.image-3 {\r\n  position: static;\r\n  margin-top: 20px;\r\n  margin-bottom: -20px;\r\n  margin-left: 0px;\r\n  padding-left: 0px;\r\n}\r\n\r\n.image-4 {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n  max-height: 240px;\r\n  max-width: 1201px;\r\n  min-height: 240px;\r\n  min-width: 1201px;\r\n  margin-left: 244px;\r\n  text-align: center;\r\n}\r\n\r\n.image-5 {\r\n  display: inline;\r\n  text-align: left;\r\n}\r\n\r\n.heading-3 {\r\n  font-family: 'Fontspring demo nekst', sans-serif;\r\n  color: #fff;\r\n  text-align: center;\r\n}\r\n\r\n.grid {\r\n  grid-template-areas: \"Area\";\r\n  -ms-grid-columns: 1fr 1fr 1fr;\r\n  grid-template-columns: 1fr 1fr 1fr;\r\n}\r\n\r\n.image-6 {\r\n  background-image: url('./../images/BG.png');\r\n  background-position: 0px 0px;\r\n  background-size: cover;\r\n  background-repeat: repeat;\r\n  background-attachment: fixed;\r\n}\r\n\r\n.navbar-no-shadow-container-2 {\r\n  z-index: 5;\r\n  width: 100%;\r\n  max-width: 1140px;\r\n  margin-right: auto;\r\n  margin-left: auto;\r\n  padding: 20px;\r\n  background-color: transparent;\r\n}\r\n\r\n.container-regular-2 {\r\n  width: 100%;\r\n  max-width: 1260px;\r\n  min-height: 30px;\r\n  margin-right: auto;\r\n  margin-left: auto;\r\n}\r\n\r\n.navbar-wrapper-2 {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: justify;\r\n  -webkit-justify-content: space-between;\r\n  -ms-flex-pack: justify;\r\n  justify-content: space-between;\r\n  -webkit-box-align: center;\r\n  -webkit-align-items: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.nav-menu-2 {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  margin-bottom: 0px;\r\n  padding-bottom: 0px;\r\n  padding-left: 0px;\r\n  -webkit-box-pack: justify;\r\n  -webkit-justify-content: space-between;\r\n  -ms-flex-pack: justify;\r\n  justify-content: space-between;\r\n  -webkit-box-align: center;\r\n  -webkit-align-items: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.nav-link-2 {\r\n  margin-right: 5px;\r\n  margin-left: 5px;\r\n  padding: 5px 10px;\r\n  color: #1a1b1f;\r\n  font-size: 14px;\r\n  line-height: 20px;\r\n  letter-spacing: 0.25px;\r\n  text-decoration: none;\r\n}\r\n\r\n.nav-link-2:hover {\r\n  color: rgba(26, 27, 31, 0.75);\r\n}\r\n\r\n.nav-link-2:focus-visible {\r\n  border-radius: 4px;\r\n  outline-color: #0050bd;\r\n  outline-offset: 0px;\r\n  outline-style: solid;\r\n  outline-width: 2px;\r\n  color: #0050bd;\r\n}\r\n\r\n.nav-link-2[data-wf-focus-visible] {\r\n  border-radius: 4px;\r\n  outline-color: #0050bd;\r\n  outline-offset: 0px;\r\n  outline-style: solid;\r\n  outline-width: 2px;\r\n  color: #0050bd;\r\n}\r\n\r\n.nav-dropdown-2 {\r\n  margin-right: 5px;\r\n  margin-left: 5px;\r\n}\r\n\r\n.nav-dropdown-toggle-2 {\r\n  padding: 5px 30px 5px 10px;\r\n  font-size: 14px;\r\n  line-height: 20px;\r\n  letter-spacing: 0.25px;\r\n}\r\n\r\n.nav-dropdown-toggle-2:hover {\r\n  color: rgba(26, 27, 31, 0.75);\r\n}\r\n\r\n.nav-dropdown-toggle-2:focus-visible {\r\n  border-radius: 5px;\r\n  outline-color: #0050bd;\r\n  outline-offset: 0px;\r\n  outline-style: solid;\r\n  outline-width: 2px;\r\n  color: #0050bd;\r\n}\r\n\r\n.nav-dropdown-toggle-2[data-wf-focus-visible] {\r\n  border-radius: 5px;\r\n  outline-color: #0050bd;\r\n  outline-offset: 0px;\r\n  outline-style: solid;\r\n  outline-width: 2px;\r\n  color: #0050bd;\r\n}\r\n\r\n.nav-dropdown-icon-2 {\r\n  margin-right: 10px;\r\n}\r\n\r\n.nav-dropdown-list-2 {\r\n  border-radius: 12px;\r\n  background-color: #fff;\r\n}\r\n\r\n.nav-dropdown-list-2.w--open {\r\n  padding-top: 10px;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.nav-dropdown-link-2 {\r\n  padding-top: 5px;\r\n  padding-bottom: 5px;\r\n  font-size: 14px;\r\n}\r\n\r\n.nav-dropdown-link-2:focus-visible {\r\n  border-radius: 5px;\r\n  outline-color: #0050bd;\r\n  outline-offset: 0px;\r\n  outline-style: solid;\r\n  outline-width: 2px;\r\n  color: #0050bd;\r\n}\r\n\r\n.nav-dropdown-link-2[data-wf-focus-visible] {\r\n  border-radius: 5px;\r\n  outline-color: #0050bd;\r\n  outline-offset: 0px;\r\n  outline-style: solid;\r\n  outline-width: 2px;\r\n  color: #0050bd;\r\n}\r\n\r\n.nav-button-wrapper-2 {\r\n  margin-left: 120px;\r\n}\r\n\r\n.button-primary-3 {\r\n  padding: 12px 25px;\r\n  background-color: #1a1b1f;\r\n  -webkit-transition: all 200ms ease;\r\n  transition: all 200ms ease;\r\n  color: #fff;\r\n  font-size: 12px;\r\n  line-height: 20px;\r\n  letter-spacing: 2px;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.button-primary-3:hover {\r\n  background-color: #32343a;\r\n  color: #fff;\r\n}\r\n\r\n.button-primary-3:active {\r\n  background-color: #43464d;\r\n}\r\n\r\n.body-2 {\r\n  background-image: url('./../images/BG.png');\r\n  background-position: 0px 0px;\r\n  background-size: cover;\r\n}\r\n\r\n.nav-link-3 {\r\n  color: #fff;\r\n}\r\n\r\n.heading-4 {\r\n  font-family: 'Fontspring demo nekst', sans-serif;\r\n  color: #fff;\r\n  font-size: 40px;\r\n  text-align: left;\r\n}\r\n\r\n.paragraph {\r\n  margin-top: 15px;\r\n  font-family: Inter, sans-serif;\r\n  color: #fff;\r\n  font-size: 16px;\r\n}\r\n\r\n.paragraph-2 {\r\n  margin-top: 30px;\r\n  font-family: 'Fontspring demo nekst', sans-serif;\r\n  color: #03e287;\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n}\r\n\r\n.paragraph-3 {\r\n  font-family: Inter, sans-serif;\r\n  color: #fff;\r\n  font-size: 16px;\r\n}\r\n\r\n.paragraph-4 {\r\n  font-family: Inter, sans-serif;\r\n  color: #fff;\r\n  font-size: 16px;\r\n}\r\n\r\n.paragraph-5 {\r\n  margin-top: 20px;\r\n  padding-top: 0px;\r\n  font-family: Inter, sans-serif;\r\n  color: #fff;\r\n  font-size: 40px;\r\n}\r\n\r\n.paragraph-6 {\r\n  padding-bottom: 10px;\r\n  font-family: Inter, sans-serif;\r\n  color: #fff;\r\n}\r\n\r\n.image-7 {\r\n  padding-left: 0px;\r\n}\r\n\r\n.image-8 {\r\n  padding-left: 25px;\r\n}\r\n\r\n.section {\r\n  margin-bottom: 100px;\r\n}\r\n\r\n.footer {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: horizontal;\r\n  -webkit-box-direction: normal;\r\n  -webkit-flex-direction: row;\r\n  -ms-flex-direction: row;\r\n  flex-direction: row;\r\n}\r\n\r\n.paragraph-7 {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-flex: 0;\r\n  -webkit-flex: 0 auto;\r\n  -ms-flex: 0 auto;\r\n  flex: 0 auto;\r\n  font-family: Inter, sans-serif;\r\n  color: #fff;\r\n  font-size: 16px;\r\n}\r\n\r\n.section-2 {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: horizontal;\r\n  -webkit-box-direction: normal;\r\n  -webkit-flex-direction: row;\r\n  -ms-flex-direction: row;\r\n  flex-direction: row;\r\n  -webkit-box-pack: center;\r\n  -webkit-justify-content: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  -webkit-box-align: center;\r\n  -webkit-align-items: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.image-9 {\r\n  margin-left: -1398px;\r\n}\r\n\r\n.image-10 {\r\n  min-height: 40px;\r\n  min-width: 119px;\r\n  margin-left: -530px;\r\n}\r\n\r\n.heading-5 {\r\n  position: -webkit-sticky;\r\n  position: sticky;\r\n  max-width: 84%;\r\n  min-width: 84%;\r\n  margin-top: 100px;\r\n  margin-left: -203px;\r\n  font-family: 'Fontspring demo nekst', sans-serif;\r\n  color: #fff;\r\n  font-size: 56px;\r\n  line-height: 60px;\r\n}\r\n\r\n.paragraph-8 {\r\n  max-width: 84%;\r\n  min-width: 21%;\r\n  margin-top: -150px;\r\n  margin-left: -204px;\r\n  padding-top: 0px;\r\n  font-family: Inter, sans-serif;\r\n  color: #fff;\r\n  font-size: 16px;\r\n  line-height: 35px;\r\n}\r\n\r\n.image-11 {\r\n  position: -webkit-sticky;\r\n  position: sticky;\r\n  max-height: none;\r\n  max-width: 71.42%;\r\n  min-height: 83%;\r\n  min-width: 71.42%;\r\n  margin-top: -386px;\r\n  margin-left: 577px;\r\n  padding-top: 0px;\r\n  padding-left: 100px;\r\n}\r\n\r\n.container-3 {\r\n  margin-top: 0px;\r\n}\r\n\r\n\r\n.heading-6 {\r\n  margin-left: -207px;\r\n}\r\n\r\n.heading-7 {\r\n  width: 60%;\r\n  min-height: 94%;\r\n  min-width: 0%;\r\n  margin-top: 0px;\r\n  margin-left: 150px;\r\n  font-family: 'Fontspring demo nekst', sans-serif;\r\n  color: #fff;\r\n  font-size: 44px;\r\n  line-height: 136.5%;\r\n}\r\n\r\n.image-12 {\r\n  min-height: 100%;\r\n  min-width: 100%;\r\n  margin-top: 50px;\r\n}\r\n\r\n.container-4 {\r\n  margin-top: -170px;\r\n}\r\n\r\n.footer-light {\r\n  position: relative;\r\n  margin-top: 50px;\r\n  padding: 80px 30px 40px;\r\n  border-bottom: 1px solid #e4ebf3;\r\n}\r\n\r\n.container-5 {\r\n  width: 100%;\r\n  max-width: 940px;\r\n  margin-right: auto;\r\n  margin-left: auto;\r\n}\r\n\r\n.footer-wrapper-two {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  margin-top: -85px;\r\n  -webkit-box-pack: justify;\r\n  -webkit-justify-content: space-between;\r\n  -ms-flex-pack: justify;\r\n  justify-content: space-between;\r\n  -webkit-box-align: start;\r\n  -webkit-align-items: flex-start;\r\n  -ms-flex-align: start;\r\n  align-items: flex-start;\r\n  color: #fff;\r\n}\r\n\r\n.footer-block-two {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -webkit-flex-direction: column;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  -webkit-box-pack: start;\r\n  -webkit-justify-content: flex-start;\r\n  -ms-flex-pack: start;\r\n  justify-content: flex-start;\r\n  -webkit-box-align: start;\r\n  -webkit-align-items: flex-start;\r\n  -ms-flex-align: start;\r\n  align-items: flex-start;\r\n}\r\n\r\n.footer-title {\r\n  font-size: 18px;\r\n  line-height: 32px;\r\n  font-weight: 500;\r\n}\r\n\r\n.footer-link-two {\r\n  margin-top: 20px;\r\n  color: #fff;\r\n  text-decoration: none;\r\n}\r\n\r\n.footer-link-two:hover {\r\n  color: rgba(26, 27, 31, 0.75);\r\n}\r\n\r\n.footer-form {\r\n  width: 315px;\r\n  max-width: 100%;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.footer-form-block {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  margin-top: 24px;\r\n  -webkit-box-pack: center;\r\n  -webkit-justify-content: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  -webkit-box-align: center;\r\n  -webkit-align-items: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.footer-form-field {\r\n  height: 48px;\r\n  margin-bottom: 0px;\r\n  padding: 12px 16px;\r\n  border-style: solid;\r\n  border-width: 1px;\r\n  border-color: #a6b1bf;\r\n  border-top-left-radius: 4px;\r\n  border-bottom-left-radius: 4px;\r\n  -webkit-transition: all 200ms ease;\r\n  transition: all 200ms ease;\r\n  font-size: 14px;\r\n  line-height: 22px;\r\n}\r\n\r\n.footer-form-field:hover {\r\n  border-color: #76879d;\r\n}\r\n\r\n.footer-form-field:focus {\r\n  border-color: #76879d;\r\n}\r\n\r\n.footer-form-field::-webkit-input-placeholder {\r\n  color: rgba(26, 27, 31, 0.8);\r\n  font-size: 14px;\r\n  line-height: 22px;\r\n}\r\n\r\n.footer-form-field:-ms-input-placeholder {\r\n  color: rgba(26, 27, 31, 0.8);\r\n  font-size: 14px;\r\n  line-height: 22px;\r\n}\r\n\r\n.footer-form-field::-ms-input-placeholder {\r\n  color: rgba(26, 27, 31, 0.8);\r\n  font-size: 14px;\r\n  line-height: 22px;\r\n}\r\n\r\n.footer-form-field::placeholder {\r\n  color: rgba(26, 27, 31, 0.8);\r\n  font-size: 14px;\r\n  line-height: 22px;\r\n}\r\n\r\n.footer-form-submit {\r\n  width: 50px;\r\n  height: 48px;\r\n  border-top-right-radius: 4px;\r\n  border-bottom-right-radius: 4px;\r\n  background-color: #1a1b1f;\r\n  background-position: 50% 50%;\r\n  background-size: auto;\r\n  background-repeat: no-repeat;\r\n  -webkit-transition: all 200ms ease;\r\n  transition: all 200ms ease;\r\n}\r\n\r\n.footer-form-submit:hover {\r\n  background-color: #3a4554;\r\n}\r\n\r\n.footer-divider-two {\r\n  width: 100%;\r\n  height: 1px;\r\n  margin-top: 40px;\r\n  margin-bottom: 40px;\r\n  background-color: #e4ebf3;\r\n}\r\n\r\n.footer-bottom {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: justify;\r\n  -webkit-justify-content: space-between;\r\n  -ms-flex-pack: justify;\r\n  justify-content: space-between;\r\n  -webkit-box-align: center;\r\n  -webkit-align-items: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.footer-copyright {\r\n  margin-top: 21px;\r\n  margin-right: -50px;\r\n  color: #fff;\r\n}\r\n\r\n.footer-social-block-two {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  margin-top: 0px;\r\n  margin-left: -12px;\r\n  -webkit-box-pack: start;\r\n  -webkit-justify-content: flex-start;\r\n  -ms-flex-pack: start;\r\n  justify-content: flex-start;\r\n  -webkit-box-align: center;\r\n  -webkit-align-items: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.footer-social-link {\r\n  margin-left: 12px;\r\n}\r\n\r\n.image-13 {\r\n  min-width: 100px;\r\n  margin-top: 10px;\r\n  margin-left: -195px;\r\n}\r\n\r\n.text-span {\r\n  color: #03e287;\r\n}\r\n\r\n.text-span-2 {\r\n  color: #03e287;\r\n}\r\n\r\n.text-span-3 {\r\n  color: #03e287;\r\n}\r\n\r\n.section-4 {\r\n  width: 100%;\r\n  height: 100%;\r\n  margin-top: 200px;\r\n}\r\n\r\n.column {\r\n  padding-right: 0px;\r\n  padding-left: 0px;\r\n}\r\n\r\n.text-span-4 {\r\n  font-family: 'Fontspring demo nekst', sans-serif;\r\n  color: #03e287;\r\n}\r\n\r\n.heading-8 {\r\n  margin-bottom: 0px;\r\n  padding-top: 15px;\r\n  padding-bottom: 50px;\r\n  font-family: 'Fontspring demo nekst', sans-serif;\r\n  font-size: 75px;\r\n}\r\n\r\n.text-span-5 {\r\n  color: #ff6161;\r\n}\r\n\r\n.text-block-6 {\r\n  font-family: Inter, sans-serif;\r\n  font-size: 16px;\r\n}\r\n\r\n.field-label {\r\n  margin-bottom: 10px;\r\n  font-family: Inter, sans-serif;\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n}\r\n\r\n.field-label-2 {\r\n  margin-bottom: 10px;\r\n  font-family: Inter, sans-serif;\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n}\r\n\r\n.text-span-6 {\r\n  color: #ff6161;\r\n}\r\n\r\n.text-span-7 {\r\n  color: #ff6161;\r\n}\r\n\r\n.text-field {\r\n  width: 590px;\r\n  height: 60px;\r\n  min-height: 100%;\r\n  min-width: 100%;\r\n  margin-bottom: 30px;\r\n  border: 1px none #000;\r\n  background-color: transparent;\r\n  background-image: url('./../images/Rectangle-9397.png');\r\n  background-position: 0px 0px;\r\n  background-size: auto;\r\n  font-family: Inter, sans-serif;\r\n  -o-object-fit: none;\r\n  object-fit: none;\r\n}\r\n\r\n.text-field-2 {\r\n  position: static;\r\n  width: 128%;\r\n  height: 60px;\r\n  margin-bottom: 30px;\r\n  border: 1px none #000;\r\n  background-color: transparent;\r\n  background-image: url('./../images/Rectangle-9397.png');\r\n  background-position: 0px 0px;\r\n  background-size: auto;\r\n  font-family: Inter, sans-serif;\r\n  -o-object-fit: fill;\r\n  object-fit: fill;\r\n}\r\n\r\n.text-span-8 {\r\n  font-family: Inter, sans-serif;\r\n  color: #ff6161;\r\n  font-weight: 400;\r\n}\r\n\r\n.field-label-3 {\r\n  margin-bottom: 10px;\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n}\r\n\r\n.text-field-3 {\r\n  width: 590px;\r\n  height: 60px;\r\n  margin-bottom: 30px;\r\n  border: 1px none #000;\r\n  background-color: transparent;\r\n  background-image: url('./../images/Rectangle-9397.png');\r\n  background-position: 0px 0px;\r\n  background-size: auto;\r\n}\r\n\r\n.field-label-4 {\r\n  margin-bottom: 10px;\r\n  font-family: Inter, sans-serif;\r\n  color: #fff;\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n}\r\n\r\n.text-span-9 {\r\n  color: #ff6161;\r\n}\r\n\r\n.textarea {\r\n  width: 590px;\r\n  height: 211px;\r\n}\r\n\r\n.text-field-4 {\r\n  width: 590px;\r\n  height: 211px;\r\n  border: 1px none #000;\r\n  background-color: transparent;\r\n  background-image: url('./../images/Rectangle-9397-1.png');\r\n  background-position: 0px 0px;\r\n  background-size: auto;\r\n}\r\n\r\n.submit-button {\r\n  width: 590px;\r\n  height: 60px;\r\n  margin-top: 200px;\r\n  border: 1px none #000;\r\n  background-color: transparent;\r\n  background-image: url('./../images/Rectangle-9398.png');\r\n  background-position: 0px 0px;\r\n  background-size: auto;\r\n  font-family: Inter, sans-serif;\r\n  text-align: center;\r\n}\r\n\r\n.textarea-2 {\r\n  width: 590px;\r\n  height: 211px;\r\n  min-height: 211px;\r\n  border: 1px none #000;\r\n  border-radius: 0px;\r\n  background-color: transparent;\r\n  background-image: url('./../images/Rectangle-9397-1.png');\r\n  background-position: 0px 0px;\r\n  background-size: auto;\r\n}\r\n\r\n.column-2 {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  padding-right: 0px;\r\n  padding-left: 0px;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -webkit-flex-direction: column;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  -webkit-box-align: start;\r\n  -webkit-align-items: flex-start;\r\n  -ms-flex-align: start;\r\n  align-items: flex-start;\r\n}\r\n\r\n.image-14 {\r\n  margin-top: 100px;\r\n}\r\n\r\n.text-block-7 {\r\n  -webkit-align-self: auto;\r\n  -ms-flex-item-align: auto;\r\n  -ms-grid-row-align: auto;\r\n  align-self: auto;\r\n  -webkit-box-ordinal-group: 1;\r\n  -webkit-order: 0;\r\n  -ms-flex-order: 0;\r\n  order: 0;\r\n}\r\n\r\n.select-field {\r\n  min-height: 60px;\r\n  min-width: 590px;\r\n  border: 1px none #000;\r\n  background-color: transparent;\r\n  background-image: url('./../images/Rectangle-9397.png');\r\n  background-position: 0px 0px;\r\n  background-size: auto;\r\n  font-family: Inter, sans-serif;\r\n}\r\n\r\n.heading-9 {\r\n  padding-top: 50px;\r\n  font-family: 'Fontspring demo nekst', sans-serif;\r\n  font-size: 36px;\r\n  text-align: center;\r\n  overflow-wrap: break-word;\r\n}\r\n\r\n.text-block-8 {\r\n  padding-top: 20px;\r\n  font-family: Inter, sans-serif;\r\n  color: #949494;\r\n  font-size: 16px;\r\n  text-align: center;\r\n}\r\n\r\n.search-button {\r\n  padding-bottom: 0px;\r\n  padding-left: 817px;\r\n  background-color: transparent;\r\n}\r\n\r\n.search-input {\r\n  width: 794px;\r\n  height: 60px;\r\n  min-height: 56%;\r\n  min-width: 84.466%;\r\n  margin-top: 60px;\r\n  margin-left: 80px;\r\n  padding-left: 0px;\r\n  border-style: solid;\r\n  border-width: 1px;\r\n  border-color: #c8ffe8;\r\n  border-radius: 10px;\r\n  background-color: transparent;\r\n  text-align: left;\r\n}\r\n\r\n.search-input::-webkit-input-placeholder {\r\n  font-family: Inter, sans-serif;\r\n}\r\n\r\n.search-input:-ms-input-placeholder {\r\n  font-family: Inter, sans-serif;\r\n}\r\n\r\n.search-input::-ms-input-placeholder {\r\n  font-family: Inter, sans-serif;\r\n}\r\n\r\n.search-input::placeholder {\r\n  font-family: Inter, sans-serif;\r\n}\r\n\r\n.search {\r\n  width: 794px;\r\n  height: 60px;\r\n  min-height: 44%;\r\n  min-width: 84.466%;\r\n}\r\n\r\n.image-15 {\r\n  position: static;\r\n  margin-top: 15px;\r\n  margin-left: 53px;\r\n  float: left;\r\n  clear: both;\r\n}\r\n\r\n.html-embed {\r\n  margin-top: 0px;\r\n}\r\n\r\n.html-embed-2 {\r\n  margin-top: 70px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.heading-10 {\r\n  overflow-wrap: break-word;\r\n  position: static;\r\n  width: 49%;\r\n  height: 68%;\r\n  min-width: 0px;\r\n  margin-left: 210px;\r\n  font-family: 'Fontspring demo nekst', sans-serif;\r\n  font-size: 80px;\r\n  line-height: 91.2px;\r\n}\r\n\r\n.text-block-9 {\r\n  width: 41%;\r\n  height: 30%;\r\n  min-width: 0px;\r\n  margin-left: 210px;\r\n  font-family: Inter, sans-serif;\r\n  color: #a19e9e;\r\n  font-size: 16px;\r\n  line-height: 38.32px;\r\n}\r\n\r\n.image-16 {\r\n  display: inline-block;\r\n  width: 100%;\r\n  max-width: none;\r\n  min-height: 837px;\r\n  min-width: 1200px;\r\n  margin-top: 120px;\r\n}\r\n\r\n.section-5 {\r\n  margin-top: 100px;\r\n  margin-bottom: 100px;\r\n}\r\n\r\n.image-17 {\r\n  position: relative;\r\n  left: 591px;\r\n  top: -274px;\r\n  margin-left: 0px;\r\n  padding-left: 0px;\r\n  float: left;\r\n}\r\n\r\n.image-18 {\r\n  position: relative;\r\n  left: -95px;\r\n  top: -373px;\r\n}\r\n\r\n.image-19 {\r\n  position: relative;\r\n  left: 500px;\r\n  top: -670px;\r\n}\r\n\r\n.container-6 {\r\n  display: block;\r\n  height: auto;\r\n  min-height: auto;\r\n  grid-auto-columns: 1fr;\r\n  grid-column-gap: 16px;\r\n  grid-row-gap: 16px;\r\n  -ms-grid-columns: 1fr 1fr;\r\n  grid-template-columns: 1fr 1fr;\r\n  -ms-grid-rows: auto auto;\r\n  grid-template-rows: auto auto;\r\n}\r\n\r\n.image-20 {\r\n  position: relative;\r\n  left: 414px;\r\n  top: 12px;\r\n}\r\n\r\n.image-21 {\r\n  position: relative;\r\n  left: auto;\r\n  top: 12px;\r\n}\r\n\r\n.heading-12 {\r\n  width: 55%;\r\n  margin-top: 100px;\r\n  margin-left: 150px;\r\n  font-family: 'Fontspring demo nekst', sans-serif;\r\n  font-size: 56px;\r\n  line-height: 130%;\r\n}\r\n\r\n.text-block-10 {\r\n  width: 55%;\r\n  margin-top: 20px;\r\n  margin-left: 150px;\r\n  font-family: Inter, sans-serif;\r\n  line-height: 236.52%;\r\n}\r\n\r\n.image-22 {\r\n  position: absolute;\r\n  left: auto;\r\n  top: 0%;\r\n  right: 0%;\r\n  bottom: auto;\r\n  max-height: 100%;\r\n  padding-top: 90px;\r\n  opacity: 0.6;\r\n  z-index: -10;\r\n}\r\n\r\n.image-23 {\r\n  padding-top: 10px;\r\n}\r\n\r\n.navbar-2 {\r\n  width: 100%;\r\n  height: 56px;\r\n  background-color: transparent;\r\n}\r\n\r\n.nav-menu-3 {\r\n  width: 70%;\r\n  margin-top: -40px;\r\n  padding-right: 20px;\r\n  padding-left: 20px;\r\n  color: #fff;\r\n}\r\n\r\n.nav-link-4 {\r\n  color: #fff;\r\n}\r\n\r\n.nav-link-5 {\r\n  color: #fff;\r\n}\r\n\r\n.nav-link-6 {\r\n  color: #fff;\r\n}\r\n\r\n.nav-link-7 {\r\n  color: #fff;\r\n}\r\n\r\n.nav-link-8 {\r\n  color: #fff;\r\n}\r\n\r\n.nav-link-9 {\r\n  color: #fff;\r\n}\r\n\r\n.image-24 {\r\n  position: relative;\r\n  left: 70px;\r\n  width: 4%;\r\n  max-width: none;\r\n  padding-left: 0px;\r\n}\r\n\r\n.text-block-11 {\r\n  color: #fff;\r\n}\r\n\r\n.icon {\r\n  color: #fff;\r\n}\r\n\r\n.dropdown-link {\r\n  margin-top: -15px;\r\n  padding-top: 0px;\r\n  color: #fff;\r\n}\r\n\r\n.dropdown-list.w--open {\r\n  background-color: transparent;\r\n}\r\n\r\n.dropdown-link-2 {\r\n  color: #fff;\r\n}\r\n\r\n.dropdown-link-3 {\r\n  color: #fff;\r\n}\r\n\r\n.section-7 {\r\n  width: 100%;\r\n  height: 27%;\r\n  margin-top: 200px;\r\n  margin-bottom: 100px;\r\n}\r\n\r\n.columns {\r\n  width: 100%;\r\n}\r\n\r\n.heading-13 {\r\n  margin-left: 210px;\r\n}\r\n\r\n.text-block-12 {\r\n  margin-left: 210px;\r\n}\r\n\r\n.heading-14 {\r\n  margin-left: 210px;\r\n}\r\n\r\n.text-block-13 {\r\n  margin-left: 210px;\r\n}\r\n\r\n.text-block-14 {\r\n  margin-left: 210px;\r\n}\r\n\r\n.section-8 {\r\n  margin-top: 60px;\r\n}\r\n\r\n.navbar-3 {\r\n  width: 100%;\r\n  height: 56px;\r\n  background-color: transparent;\r\n}\r\n\r\n.nav-menu-4 {\r\n  padding-top: 0px;\r\n}\r\n\r\n.image-26 {\r\n  padding-top: 10px;\r\n}\r\n\r\n.nav-link-11 {\r\n  font-family: Inter, sans-serif;\r\n  color: #fff;\r\n}\r\n\r\n.nav-link-12 {\r\n  font-family: Inter, sans-serif;\r\n  color: #fff;\r\n}\r\n\r\n.nav-link-13 {\r\n  font-family: Inter, sans-serif;\r\n  color: #fff;\r\n}\r\n\r\n.text-block-15 {\r\n  color: #fff;\r\n}\r\n\r\n.icon-2 {\r\n  font-family: Inter, sans-serif;\r\n  color: #fff;\r\n}\r\n\r\n.nav-link-14 {\r\n  font-family: Inter, sans-serif;\r\n  color: #fff;\r\n}\r\n\r\n.nav-link-15 {\r\n  font-family: Inter, sans-serif;\r\n  color: #fff;\r\n}\r\n\r\n.dropdown-list-2.w--open {\r\n  background-color: transparent;\r\n  color: #fff;\r\n}\r\n\r\n.dropdown-link-4 {\r\n  color: #fff;\r\n}\r\n\r\n.dropdown-link-5 {\r\n  color: #fff;\r\n}\r\n\r\n.dropdown-toggle-2 {\r\n  top: -42px;\r\n}\r\n\r\n.image-27 {\r\n  position: relative;\r\n  left: -180px;\r\n  padding-top: 10px;\r\n}\r\n\r\n.navbar-4 {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  width: 100%;\r\n  -webkit-box-orient: horizontal;\r\n  -webkit-box-direction: normal;\r\n  -webkit-flex-direction: row;\r\n  -ms-flex-direction: row;\r\n  flex-direction: row;\r\n  -webkit-box-pack: center;\r\n  -webkit-justify-content: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  -webkit-box-align: center;\r\n  -webkit-align-items: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  background-color: transparent;\r\n}\r\n\r\n.nav-link-16 {\r\n  color: #fff;\r\n}\r\n\r\n.nav-link-16.w--current {\r\n  position: relative;\r\n}\r\n\r\n.nav-link-17 {\r\n  color: #fff;\r\n}\r\n\r\n.nav-link-18 {\r\n  color: #fff;\r\n}\r\n\r\n.nav-menu-5 {\r\n  padding-left: 0px;\r\n}\r\n\r\n.section-9 {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  margin-bottom: 25px;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -webkit-flex-direction: column;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  -webkit-box-pack: center;\r\n  -webkit-justify-content: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  -webkit-box-align: center;\r\n  -webkit-align-items: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.section-10 {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  padding-top: 20px;\r\n  -webkit-box-pack: center;\r\n  -webkit-justify-content: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  -webkit-box-align: center;\r\n  -webkit-align-items: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n.image-30 {\r\n  padding-right: 10px;\r\n  padding-left: 20px;\r\n}\r\n\r\n.image-31 {\r\n  padding-right: 10px;\r\n  padding-left: 10px;\r\n}\r\n\r\n.image-32 {\r\n  padding-right: 20px;\r\n  padding-left: 10px;\r\n}\r\n\r\n.grid-3 {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  justify-items: center;\r\n  -webkit-box-align: center;\r\n  -webkit-align-items: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.section-17 {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: center;\r\n  -webkit-justify-content: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  -webkit-box-align: center;\r\n  -webkit-align-items: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.section-18 {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  padding-top: 25px;\r\n  padding-bottom: 100px;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -webkit-flex-direction: column;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  -webkit-box-pack: center;\r\n  -webkit-justify-content: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  -webkit-box-align: center;\r\n  -webkit-align-items: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.heading-19 {\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.text-block-30 {\r\n  padding-top: 25px;\r\n  padding-bottom: 25px;\r\n}\r\n\r\n.grid-6 {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: center;\r\n  -webkit-justify-content: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  justify-items: center;\r\n  -webkit-box-align: center;\r\n  -webkit-align-items: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  -webkit-align-self: center;\r\n  -ms-flex-item-align: center;\r\n  align-self: center;\r\n}\r\n\r\n.text-block-32 {\r\n  position: relative;\r\n  left: 250px;\r\n  display: inline-block;\r\n  padding: 20px;\r\n  -webkit-box-orient: horizontal;\r\n  -webkit-box-direction: normal;\r\n  -webkit-flex-direction: row;\r\n  -ms-flex-direction: row;\r\n  flex-direction: row;\r\n  -webkit-box-pack: center;\r\n  -webkit-justify-content: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  -webkit-box-align: center;\r\n  -webkit-align-items: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.image-41 {\r\n  margin-top: 0px;\r\n  margin-left: 0px;\r\n}\r\n\r\n.div-block-2 {\r\n  margin: 100px 100px 100px 0px;\r\n  background-color: transparent;\r\n}\r\n\r\n.div-block-3 {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -webkit-flex-direction: column;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  -webkit-box-pack: center;\r\n  -webkit-justify-content: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  -webkit-box-align: center;\r\n  -webkit-align-items: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.heading-20 {\r\n  margin-top: 50px;\r\n  font-size: 32px;\r\n  font-weight: 400;\r\n}\r\n\r\n.image-42 {\r\n  width: 35%;\r\n  height: 58.526924%;\r\n  min-height: 146px;\r\n  min-width: 501px;\r\n}\r\n\r\n.div-block-4 {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -webkit-flex-direction: column;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  -webkit-box-pack: center;\r\n  -webkit-justify-content: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  -webkit-box-align: center;\r\n  -webkit-align-items: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  text-align: justify;\r\n}\r\n\r\n.text-block-38 {\r\n  padding-bottom: 25px;\r\n}\r\n\r\n.text-block-39 {\r\n  -webkit-align-self: flex-start;\r\n  -ms-flex-item-align: start;\r\n  align-self: flex-start;\r\n}\r\n\r\n.text-block-40 {\r\n  -webkit-align-self: flex-start;\r\n  -ms-flex-item-align: start;\r\n  align-self: flex-start;\r\n}\r\n\r\n.button-3 {\r\n  background-color: transparent;\r\n  background-image: url('./../images/li_arrow-right-circle.png');\r\n  background-position: 0px 0px;\r\n  background-size: auto;\r\n  \r\n}\r\n\r\n.button-4 {\r\n  position: relative;\r\n  left: 150px;\r\n  width: 180px;\r\n  height: 56px;\r\n  background-color: transparent;\r\n  background-image: url('./../images/Frame-1261152715.png');\r\n  background-position: 0px 0px;\r\n  background-size: auto;\r\n}\r\n\r\n.div-block-5 {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  width: 100%;\r\n  -webkit-box-pack: center;\r\n  -webkit-justify-content: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  -webkit-box-align: center;\r\n  -webkit-align-items: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.button-5 {\r\n  position: relative;\r\n  left: -116px;\r\n  width: 119px;\r\n  height: 40px;\r\n  background-color: transparent;\r\n  background-image: url('./../images/LOGO.svg');\r\n  background-position: 0px 0px;\r\n  background-size: auto;\r\n}\r\n\r\n.button-5.w--current {\r\n  position: relative;\r\n  left: -80px;\r\n  width: 119px;\r\n  height: 40px;\r\n  background-color: transparent;\r\n  background-image: url('./../images/LOGO.svg');\r\n  background-position: 0px 0px;\r\n  background-size: auto;\r\n}\r\n\r\n.div-block-6 {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  padding-top: 25px;\r\n  padding-bottom: 25px;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -webkit-flex-direction: column;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  -webkit-box-pack: center;\r\n  -webkit-justify-content: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  -webkit-box-align: center;\r\n  -webkit-align-items: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.div-block-7 {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  width: 100%;\r\n  padding-top: 100px;\r\n  -webkit-box-orient: horizontal;\r\n  -webkit-box-direction: normal;\r\n  -webkit-flex-direction: row;\r\n  -ms-flex-direction: row;\r\n  flex-direction: row;\r\n  -webkit-box-pack: center;\r\n  -webkit-justify-content: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  -webkit-box-align: center;\r\n  -webkit-align-items: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  -webkit-align-self: center;\r\n  -ms-flex-item-align: center;\r\n  align-self: center;\r\n  -webkit-box-flex: 0;\r\n  -webkit-flex: 0 auto;\r\n  -ms-flex: 0 auto;\r\n  flex: 0 auto;\r\n}\r\n\r\n.heading-22 {\r\n  -webkit-align-self: flex-start;\r\n  -ms-flex-item-align: start;\r\n  align-self: flex-start;\r\n}\r\n\r\n.heading-23 {\r\n  -webkit-align-self: flex-start;\r\n  -ms-flex-item-align: start;\r\n  align-self: flex-start;\r\n}\r\n\r\n.heading-24 {\r\n  -webkit-align-self: flex-start;\r\n  -ms-flex-item-align: start;\r\n  align-self: flex-start;\r\n}\r\n\r\n.heading-25 {\r\n  -webkit-align-self: flex-start;\r\n  -ms-flex-item-align: start;\r\n  align-self: flex-start;\r\n}\r\n\r\n.heading-26 {\r\n  -webkit-align-self: flex-start;\r\n  -ms-flex-item-align: start;\r\n  align-self: flex-start;\r\n}\r\n\r\n.heading-27 {\r\n  -webkit-align-self: flex-start;\r\n  -ms-flex-item-align: start;\r\n  align-self: flex-start;\r\n}\r\n\r\n.text-block-47 {\r\n  padding-bottom: 50px;\r\n}\r\n\r\n.section-21 {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: horizontal;\r\n  -webkit-box-direction: normal;\r\n  -webkit-flex-direction: row;\r\n  -ms-flex-direction: row;\r\n  flex-direction: row;\r\n  -webkit-box-pack: center;\r\n  -webkit-justify-content: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  -webkit-box-align: center;\r\n  -webkit-align-items: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n.image-60 {\r\n  position: relative;\r\n  left: -211px;\r\n}\r\n\r\n.heading-28 {\r\n  -webkit-align-self: flex-start;\r\n  -ms-flex-item-align: start;\r\n  align-self: flex-start;\r\n}\r\n\r\n.heading-29 {\r\n  -webkit-align-self: flex-start;\r\n  -ms-flex-item-align: start;\r\n  align-self: flex-start;\r\n}\r\n\r\n.heading-30 {\r\n  -webkit-align-self: flex-start;\r\n  -ms-flex-item-align: start;\r\n  align-self: flex-start;\r\n}\r\n\r\n.heading-31 {\r\n  -webkit-align-self: flex-start;\r\n  -ms-flex-item-align: start;\r\n  align-self: flex-start;\r\n}\r\n\r\n.heading-32 {\r\n  -webkit-align-self: flex-start;\r\n  -ms-flex-item-align: start;\r\n  align-self: flex-start;\r\n}\r\n\r\n.heading-33 {\r\n  -webkit-align-self: flex-start;\r\n  -ms-flex-item-align: start;\r\n  align-self: flex-start;\r\n}\r\n\r\n.heading-34 {\r\n  -webkit-align-self: flex-start;\r\n  -ms-flex-item-align: start;\r\n  align-self: flex-start;\r\n}\r\n\r\n.heading-35 {\r\n  -webkit-align-self: flex-start;\r\n  -ms-flex-item-align: start;\r\n  align-self: flex-start;\r\n}\r\n\r\n.grid-7 {\r\n  -webkit-box-pack: center;\r\n  -webkit-justify-content: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  -webkit-align-content: center;\r\n  -ms-flex-line-pack: center;\r\n  align-content: center;\r\n  grid-auto-flow: row;\r\n  -ms-grid-rows: auto auto auto;\r\n  grid-template-rows: auto auto auto;\r\n}\r\n\r\n.column-7 {\r\n  position: relative;\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  clear: none;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -webkit-flex-direction: column;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  -webkit-box-pack: center;\r\n  -webkit-justify-content: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  -webkit-box-align: start;\r\n  -webkit-align-items: flex-start;\r\n  -ms-flex-align: start;\r\n  align-items: flex-start;\r\n}\r\n\r\n.text-block-48 {\r\n  padding-left: 25px;\r\n  font-family: 'Fontspring demo nekst', sans-serif;\r\n  font-size: 20px;\r\n  line-height: 275%;\r\n  font-weight: 700;\r\n}\r\n\r\n.image-61 {\r\n  padding-bottom: 15px;\r\n}\r\n\r\n.image-62 {\r\n  padding-bottom: 15px;\r\n}\r\n\r\n@media screen and (min-width: 1440px) {\r\n  .body {\r\n    height: 100%;\r\n  }\r\n\r\n  .image-2 {\r\n    position: static;\r\n    margin-top: 90px;\r\n    margin-left: 0px;\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    -ms-grid-row-align: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .image-11 {\r\n    width: 71.42%;\r\n    height: 91.021953%;\r\n  }\r\n\r\n  .heading-7 {\r\n    height: 83%;\r\n    min-height: 0px;\r\n    min-width: 0px;\r\n    margin-left: 210px;\r\n    padding: 10px 20px;\r\n  }\r\n\r\n  .heading-10 {\r\n    width: 49%;\r\n  }\r\n\r\n  .text-block-9 {\r\n    width: 36%;\r\n  }\r\n\r\n  .container-6 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    height: auto;\r\n    min-height: auto;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    grid-auto-columns: 1fr;\r\n    grid-column-gap: 16px;\r\n    grid-row-gap: 16px;\r\n    -ms-grid-columns: 1fr 1fr;\r\n    grid-template-columns: 1fr 1fr;\r\n    -ms-grid-rows: auto auto;\r\n    grid-template-rows: auto auto;\r\n  }\r\n\r\n  .image-20 {\r\n    left: 0px;\r\n    max-width: 0%;\r\n  }\r\n\r\n  .image-21 {\r\n    position: relative;\r\n    left: 0px;\r\n    top: 10px;\r\n  }\r\n\r\n  .html-embed-3 {\r\n    height: auto;\r\n  }\r\n\r\n  .heading-11 {\r\n    font-size: 48px;\r\n  }\r\n\r\n  .heading-12 {\r\n    width: 55%;\r\n    margin-left: 210px;\r\n    padding: 10px 20px;\r\n    font-size: 56px;\r\n    line-height: 136%;\r\n  }\r\n\r\n  .text-block-10 {\r\n    width: 55%;\r\n    margin-left: 210px;\r\n    padding: 10px 20px;\r\n    opacity: 0.6;\r\n    font-size: 16px;\r\n    line-height: 239.52%;\r\n  }\r\n\r\n  .image-22 {\r\n    position: absolute;\r\n    left: auto;\r\n    top: 0%;\r\n    right: 0%;\r\n    bottom: auto;\r\n  }\r\n\r\n  .navbar {\r\n    background-color: transparent;\r\n  }\r\n\r\n  .container-7 {\r\n    width: 1196px;\r\n    height: 56px;\r\n    margin-top: -40px;\r\n    margin-left: 210px;\r\n  }\r\n\r\n  .image-23 {\r\n    margin-top: 80px;\r\n  }\r\n\r\n  .navbar-2 {\r\n    width: 100%;\r\n    height: 56px;\r\n    margin-top: 0px;\r\n    background-color: transparent;\r\n  }\r\n\r\n  .nav-menu-3 {\r\n    width: 70%;\r\n    margin-top: 35px;\r\n    padding-right: 20px;\r\n    padding-left: 20px;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: row;\r\n    -ms-flex-direction: row;\r\n    flex-direction: row;\r\n    background-color: transparent;\r\n    color: #fff;\r\n  }\r\n\r\n  .nav-link-4 {\r\n    background-color: transparent;\r\n    font-family: Inter, sans-serif;\r\n    color: #fff;\r\n  }\r\n\r\n  .nav-link-5 {\r\n    color: #fff;\r\n  }\r\n\r\n  .nav-link-6 {\r\n    font-family: Inter, sans-serif;\r\n    color: #fff;\r\n  }\r\n\r\n  .nav-link-7 {\r\n    font-family: Inter, sans-serif;\r\n    color: #fff;\r\n  }\r\n\r\n  .nav-link-8 {\r\n    font-family: Inter, sans-serif;\r\n    color: #fff;\r\n  }\r\n\r\n  .nav-link-9 {\r\n    font-family: Inter, sans-serif;\r\n    color: #fff;\r\n  }\r\n\r\n  .image-24 {\r\n    position: relative;\r\n    left: 133px;\r\n  }\r\n\r\n  .button {\r\n    position: relative;\r\n    left: 1049px;\r\n    top: -44px;\r\n    float: right;\r\n  }\r\n\r\n  .text-block-11 {\r\n    font-family: Inter, sans-serif;\r\n    color: #fff;\r\n  }\r\n\r\n  .icon {\r\n    color: #fff;\r\n  }\r\n\r\n  .dropdown-toggle {\r\n    font-family: Inter, sans-serif;\r\n  }\r\n\r\n  .dropdown-link {\r\n    margin-top: -30px;\r\n    font-family: Inter, sans-serif;\r\n    color: #fff;\r\n  }\r\n\r\n  .dropdown-list {\r\n    background-color: #d5bebe;\r\n  }\r\n\r\n  .dropdown-list.w--open {\r\n    background-color: transparent;\r\n    font-family: Inter, sans-serif;\r\n  }\r\n\r\n  .dropdown-link-2 {\r\n    font-family: Inter, sans-serif;\r\n    color: #fff;\r\n  }\r\n\r\n  .dropdown-link-3 {\r\n    font-family: Inter, sans-serif;\r\n    color: #fff;\r\n  }\r\n\r\n  .columns {\r\n    margin-top: 20px;\r\n    margin-right: 0px;\r\n    margin-left: 0px;\r\n    padding-right: 20px;\r\n    padding-bottom: 20px;\r\n    padding-left: 20px;\r\n  }\r\n\r\n  .nav-link-10 {\r\n    font-family: Inter, sans-serif;\r\n    color: #fff;\r\n  }\r\n\r\n  .heading-13 {\r\n    width: 44%;\r\n    height: 100%;\r\n    margin-left: 210px;\r\n    font-family: 'Fontspring demo nekst', sans-serif;\r\n    font-size: 80px;\r\n    line-height: 106%;\r\n  }\r\n\r\n  .text-block-12 {\r\n    width: 61%;\r\n    height: 29%;\r\n    margin-left: 210px;\r\n    font-family: Inter, sans-serif;\r\n    font-size: 16px;\r\n    line-height: 123%;\r\n  }\r\n\r\n  .heading-14 {\r\n    margin-top: 20px;\r\n    margin-left: 210px;\r\n    font-family: Inter, sans-serif;\r\n    font-size: 20px;\r\n    line-height: 123%;\r\n  }\r\n\r\n  .text-block-13 {\r\n    margin-left: 210px;\r\n    opacity: 0.6;\r\n    font-family: Inter, sans-serif;\r\n    line-height: 175%;\r\n  }\r\n\r\n  .text-block-14 {\r\n    margin-left: 210px;\r\n    font-family: Inter, sans-serif;\r\n    font-size: 16px;\r\n    line-height: 175%;\r\n    text-align: left;\r\n  }\r\n\r\n  .line {\r\n    display: block;\r\n    width: 50%;\r\n    margin-left: 194px;\r\n    padding-top: 20px;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: row;\r\n    -ms-flex-direction: row;\r\n    flex-direction: row;\r\n    border-style: solid;\r\n    border-width: 2px 1px 1px;\r\n    border-color: #fff;\r\n    border-radius: 2px;\r\n  }\r\n\r\n  .div-block {\r\n    width: 61%;\r\n    margin-left: 210px;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: #fff;\r\n    border-radius: 2px;\r\n    opacity: 0.3;\r\n  }\r\n\r\n  .section-8 {\r\n    margin-top: 50px;\r\n  }\r\n\r\n  .navbar-3 {\r\n    height: 56px;\r\n    background-color: transparent;\r\n  }\r\n\r\n  .nav-menu-4 {\r\n    top: auto;\r\n    padding-top: 0px;\r\n  }\r\n\r\n  .image-26 {\r\n    display: inline-block;\r\n    padding-top: 10px;\r\n  }\r\n\r\n  .nav-link-11 {\r\n    font-family: Inter, sans-serif;\r\n    color: #fff;\r\n  }\r\n\r\n  .nav-link-11:hover {\r\n    color: #03e287;\r\n  }\r\n\r\n  .nav-link-12 {\r\n    font-family: Inter, sans-serif;\r\n    color: #fff;\r\n  }\r\n\r\n  .nav-link-12:hover {\r\n    color: #03e287;\r\n  }\r\n\r\n  .nav-link-13 {\r\n    color: #fff;\r\n  }\r\n\r\n  .nav-link-13:hover {\r\n    color: #03e287;\r\n  }\r\n\r\n  .text-block-15 {\r\n    font-family: Inter, sans-serif;\r\n    color: #fff;\r\n  }\r\n\r\n  .icon-2 {\r\n    color: #fff;\r\n  }\r\n\r\n  .nav-link-14 {\r\n    color: #fff;\r\n  }\r\n\r\n  .nav-link-14:hover {\r\n    color: #03e287;\r\n  }\r\n\r\n  .nav-link-15 {\r\n    color: #fff;\r\n  }\r\n\r\n  .nav-link-15:hover {\r\n    color: #03e287;\r\n  }\r\n\r\n  .dropdown-list-2 {\r\n    color: #d3b8b8;\r\n  }\r\n\r\n  .dropdown-list-2.w--open {\r\n    background-color: transparent;\r\n    font-family: Inter, sans-serif;\r\n    color: #fff;\r\n  }\r\n\r\n  .dropdown-link-4 {\r\n    margin-top: -30px;\r\n    color: #fff;\r\n  }\r\n\r\n  .dropdown-link-5 {\r\n    color: #fff;\r\n  }\r\n\r\n  .dropdown-link-6 {\r\n    color: #fff;\r\n  }\r\n\r\n  .dropdown-toggle-2 {\r\n    top: -39px;\r\n  }\r\n\r\n  .container-9 {\r\n    margin-top: 200px;\r\n    margin-bottom: 800px;\r\n  }\r\n\r\n  .image-27 {\r\n    padding-top: 10px;\r\n  }\r\n\r\n  .navbar-4 {\r\n    width: 100%;\r\n    background-color: transparent;\r\n  }\r\n\r\n  .nav-link-16 {\r\n    padding-right: 50px;\r\n    color: #fff;\r\n  }\r\n\r\n  .nav-link-17 {\r\n    padding-right: 50px;\r\n    color: #fff;\r\n  }\r\n\r\n  .nav-link-18 {\r\n    padding-right: 50px;\r\n    color: #fff;\r\n  }\r\n\r\n  .nav-menu-5 {\r\n    position: relative;\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    width: 100%;\r\n    padding-right: 250px;\r\n    padding-left: 250px;\r\n    float: left;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: row;\r\n    -ms-flex-direction: row;\r\n    flex-direction: row;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    font-family: Inter, sans-serif;\r\n    text-align: left;\r\n  }\r\n\r\n  .text-block-16 {\r\n    margin-top: 19px;\r\n    margin-left: 566px;\r\n    font-family: Inter, sans-serif;\r\n  }\r\n\r\n  .container-10 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n  }\r\n\r\n  .section-9 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .container-11 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .section-10 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    padding-top: 20px;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: row;\r\n    -ms-flex-direction: row;\r\n    flex-direction: row;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .image-30 {\r\n    padding-right: 20px;\r\n    padding-left: 20px;\r\n  }\r\n\r\n  .image-31 {\r\n    padding-right: 20px;\r\n    padding-left: 20px;\r\n  }\r\n\r\n  .image-32 {\r\n    padding-right: 20px;\r\n    padding-left: 20px;\r\n  }\r\n\r\n  .container-12 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .section-11 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    margin-top: 50px;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .heading-15 {\r\n    -webkit-align-self: flex-end;\r\n    -ms-flex-item-align: end;\r\n    align-self: flex-end;\r\n    font-family: Inter, sans-serif;\r\n    color: #03e287;\r\n    font-size: 24px;\r\n    font-weight: 700;\r\n  }\r\n\r\n  .text-block-17 {\r\n    padding-bottom: 18px;\r\n    -webkit-align-self: flex-end;\r\n    -ms-flex-item-align: end;\r\n    align-self: flex-end;\r\n    font-family: Inter, sans-serif;\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n  }\r\n\r\n  .text-block-18 {\r\n    padding-bottom: 18px;\r\n    -webkit-align-self: flex-end;\r\n    -ms-flex-item-align: end;\r\n    align-self: flex-end;\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n  }\r\n\r\n  .text-block-19 {\r\n    padding-bottom: 18px;\r\n    -webkit-align-self: flex-end;\r\n    -ms-flex-item-align: end;\r\n    align-self: flex-end;\r\n    opacity: 0.6;\r\n    font-family: Inter, sans-serif;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .text-block-20 {\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n  }\r\n\r\n  .text-block-21 {\r\n    -webkit-align-self: flex-end;\r\n    -ms-flex-item-align: end;\r\n    align-self: flex-end;\r\n    font-family: Inter, sans-serif;\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n  }\r\n\r\n  .container-14 {\r\n    position: absolute;\r\n    left: 27%;\r\n    top: 2425px;\r\n    right: auto;\r\n    bottom: 0%;\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-flex-wrap: nowrap;\r\n    -ms-flex-wrap: nowrap;\r\n    flex-wrap: nowrap;\r\n  }\r\n\r\n  .heading-16 {\r\n    font-family: Inter, sans-serif;\r\n    color: #03e287;\r\n    font-size: 24px;\r\n  }\r\n\r\n  .text-block-22 {\r\n    padding-bottom: 18px;\r\n    font-family: Inter, sans-serif;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .text-block-23 {\r\n    padding-bottom: 18px;\r\n    font-family: Inter, sans-serif;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .container-15 {\r\n    position: absolute;\r\n    left: 1123px;\r\n    top: 2795px;\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n  }\r\n\r\n  .text-block-24 {\r\n    font-family: Inter, sans-serif;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .heading-17 {\r\n    font-family: Inter, sans-serif;\r\n    color: #03e287;\r\n    font-size: 24px;\r\n  }\r\n\r\n  .image-33 {\r\n    margin-top: 50px;\r\n  }\r\n\r\n  .text-block-25 {\r\n    padding-bottom: 18px;\r\n    opacity: 0.6;\r\n    font-family: Inter, sans-serif;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .text-block-26 {\r\n    padding-bottom: 18px;\r\n    font-family: Inter, sans-serif;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .container-16 {\r\n    position: absolute;\r\n    left: 244.609px;\r\n    top: 2897.81px;\r\n    text-align: right;\r\n  }\r\n\r\n  .heading-18 {\r\n    font-family: Inter, sans-serif;\r\n    color: #03e287;\r\n    font-size: 24px;\r\n  }\r\n\r\n  .text-block-27 {\r\n    font-family: Inter, sans-serif;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .container-17 {\r\n    position: absolute;\r\n    left: 901.094px;\r\n    top: 3225.81px;\r\n  }\r\n\r\n  .text-block-28 {\r\n    padding-bottom: 18px;\r\n    font-family: Inter, sans-serif;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .text-block-29 {\r\n    font-family: Inter, sans-serif;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .image-34 {\r\n    position: absolute;\r\n    left: 302.5px;\r\n    top: 855.312px;\r\n  }\r\n\r\n  .image-35 {\r\n    position: absolute;\r\n    left: 849px;\r\n    top: 935.312px;\r\n  }\r\n\r\n  .section-13 {\r\n    height: 85%;\r\n  }\r\n\r\n  .image-36 {\r\n    position: absolute;\r\n    left: 145.5px;\r\n    top: 1174.312px;\r\n  }\r\n\r\n  .image-37 {\r\n    position: absolute;\r\n    left: 730.5px;\r\n    top: 1226.312px;\r\n  }\r\n\r\n  .grid-3 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: row;\r\n    -ms-flex-direction: row;\r\n    flex-direction: row;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    justify-items: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .section-14 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    padding-bottom: 100px;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: row;\r\n    -ms-flex-direction: row;\r\n    flex-direction: row;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    grid-auto-columns: 1fr;\r\n    grid-column-gap: 16px;\r\n    grid-row-gap: 16px;\r\n    -ms-grid-columns: 1fr 1fr;\r\n    grid-template-columns: 1fr 1fr;\r\n    -ms-grid-rows: auto auto;\r\n    grid-template-rows: auto auto;\r\n  }\r\n\r\n  .grid-5 {\r\n    -ms-grid-columns: 1fr 1fr 1fr;\r\n    grid-template-columns: 1fr 1fr 1fr;\r\n  }\r\n\r\n  .section-15 {\r\n    margin-bottom: 200px;\r\n    padding-bottom: 20px;\r\n  }\r\n\r\n  .section-17 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    grid-auto-columns: 1fr;\r\n    grid-column-gap: 16px;\r\n    grid-row-gap: 16px;\r\n    -ms-grid-columns: 1fr 1fr;\r\n    grid-template-columns: 1fr 1fr;\r\n    -ms-grid-rows: auto auto;\r\n    grid-template-rows: auto auto;\r\n  }\r\n\r\n  .section-18 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    margin-bottom: 100px;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .heading-19 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    font-family: 'Fontspring demo nekst', sans-serif;\r\n    text-align: center;\r\n  }\r\n\r\n  .grid-6 {\r\n    display: -ms-grid;\r\n    display: grid;\r\n    margin-top: 50px;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    grid-auto-columns: 1fr;\r\n    grid-column-gap: 16px;\r\n    grid-row-gap: 16px;\r\n    -ms-grid-columns: 1fr 1fr 1fr 1fr 1fr;\r\n    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;\r\n    -ms-grid-rows: auto;\r\n    grid-template-rows: auto;\r\n  }\r\n\r\n  .text-block-32 {\r\n    left: auto;\r\n    display: block;\r\n    max-width: none;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: row;\r\n    -ms-flex-direction: row;\r\n    flex-direction: row;\r\n    -webkit-align-self: auto;\r\n    -ms-flex-item-align: auto;\r\n    -ms-grid-row-align: auto;\r\n    align-self: auto;\r\n    -webkit-box-flex: 0;\r\n    -webkit-flex: 0 0 auto;\r\n    -ms-flex: 0 0 auto;\r\n    flex: 0 0 auto;\r\n  }\r\n\r\n  .div-block-2 {\r\n    width: 86%;\r\n  }\r\n\r\n  .div-block-3 {\r\n    margin-top: 0px;\r\n    padding-top: 100px;\r\n  }\r\n\r\n  .image-42 {\r\n    min-height: 58%;\r\n    min-width: 35%;\r\n  }\r\n\r\n  .heading-21 {\r\n    margin-top: 50px;\r\n  }\r\n\r\n  .div-block-4 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    padding-top: 100px;\r\n    padding-right: 100px;\r\n    padding-left: 100px;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    font-family: Inter, sans-serif;\r\n  }\r\n\r\n  .text-block-33 {\r\n    padding-bottom: 25px;\r\n  }\r\n\r\n  .text-block-34 {\r\n    padding-bottom: 0px;\r\n  }\r\n\r\n  .image-43 {\r\n    width: 25%;\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    -ms-grid-row-align: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .text-block-35 {\r\n    padding-bottom: 25px;\r\n  }\r\n\r\n  .text-block-36 {\r\n    padding-bottom: 25px;\r\n  }\r\n\r\n  .image-44 {\r\n    width: 25%;\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    -ms-grid-row-align: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .text-span-10 {\r\n    color: red;\r\n  }\r\n\r\n  .image-45 {\r\n    width: 75%;\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    -ms-grid-row-align: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .image-46 {\r\n    width: 75%;\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    -ms-grid-row-align: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .text-block-37 {\r\n    padding-top: 100px;\r\n    padding-bottom: 25px;\r\n  }\r\n\r\n  .text-block-38 {\r\n    padding-bottom: 25px;\r\n  }\r\n\r\n  .column-5 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    padding-right: 0px;\r\n    padding-left: 0px;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .column-6 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    padding-right: 0px;\r\n    padding-left: 0px;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .text-block-39 {\r\n    padding-bottom: 25px;\r\n  }\r\n\r\n  .columns-2 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    width: 100%;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: row;\r\n    -ms-flex-direction: row;\r\n    flex-direction: row;\r\n    -webkit-box-pack: start;\r\n    -webkit-justify-content: flex-start;\r\n    -ms-flex-pack: start;\r\n    justify-content: flex-start;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    align-self: flex-start;\r\n    grid-column-gap: 0px;\r\n    grid-row-gap: 0px;\r\n  }\r\n\r\n  .image-47 {\r\n    width: 75%;\r\n  }\r\n\r\n  .image-48 {\r\n    width: 75%;\r\n  }\r\n\r\n  .text-block-40 {\r\n    padding-top: 25px;\r\n    padding-bottom: 25px;\r\n  }\r\n\r\n  .image-49 {\r\n    width: 75%;\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    -ms-grid-row-align: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .image-50 {\r\n    width: 75%;\r\n    padding-bottom: 25px;\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    -ms-grid-row-align: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .image-51 {\r\n    width: 75%;\r\n    padding-bottom: 25px;\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    -ms-grid-row-align: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .text-block-41 {\r\n    padding-bottom: 25px;\r\n  }\r\n\r\n  .image-52 {\r\n    width: 75%;\r\n    padding-bottom: 25px;\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    -ms-grid-row-align: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .text-block-42 {\r\n    padding-bottom: 25px;\r\n  }\r\n\r\n  .image-53 {\r\n    width: 75%;\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    -ms-grid-row-align: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .image-54 {\r\n    width: 75%;\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    -ms-grid-row-align: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .text-block-43 {\r\n    padding-bottom: 25px;\r\n  }\r\n\r\n  .image-55 {\r\n    width: 75%;\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    -ms-grid-row-align: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .text-block-44 {\r\n    padding-bottom: 25px;\r\n  }\r\n\r\n  .image-56 {\r\n    width: 75%;\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    -ms-grid-row-align: center;\r\n    align-self: center;\r\n    margin-bottom: 2rem;\r\n  }\r\n\r\n  .image-57 {\r\n    width: 75%;\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    -ms-grid-row-align: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .image-58 {\r\n    width: 75%;\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    -ms-grid-row-align: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .text-block-45 {\r\n    padding-bottom: 25px;\r\n  }\r\n\r\n  .image-59 {\r\n    width: 75%;\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    -ms-grid-row-align: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .button-2 {\r\n    width: 2%;\r\n    border: 1px none #000;\r\n    background-color: transparent;\r\n    background-image: url('./../images/li_arrow-right-circle.png');\r\n    background-position: 0px 0px;\r\n    background-size: auto;\r\n  }\r\n\r\n  .button-3 {\r\n    width: 40px;\r\n    height: 40px;\r\n    border: 1px none #000;\r\n    background-color: transparent;\r\n    background-image: url('./../images/li_arrow-right-circle.png');\r\n    background-position: 0px 0px;\r\n    background-size: cover;\r\n  }\r\n\r\n  .button-4 {\r\n    position: relative;\r\n    left: 220px;\r\n    width: 180px;\r\n    height: 56px;\r\n    padding-top: 20px;\r\n    border: 1px none #000;\r\n    background-color: transparent;\r\n    background-image: url('./../images/Frame-1261152715.png');\r\n    background-position: 0px 0px;\r\n    background-size: auto;\r\n  }\r\n\r\n  .div-block-5 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    margin-right: auto;\r\n    margin-left: auto;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: row;\r\n    -ms-flex-direction: row;\r\n    flex-direction: row;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    grid-auto-columns: 1fr;\r\n    grid-column-gap: 16px;\r\n    grid-row-gap: 16px;\r\n    -ms-grid-columns: 1fr 1fr;\r\n    grid-template-columns: 1fr 1fr;\r\n    -ms-grid-rows: auto auto;\r\n    grid-template-rows: auto auto;\r\n  }\r\n\r\n  .button-5 {\r\n    position: relative;\r\n    left: -101px;\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    width: 119px;\r\n    height: 40px;\r\n    padding-top: 0px;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    align-self: center;\r\n    border: 1px none #000;\r\n    background-color: transparent;\r\n    background-image: url('./../images/LOGO.svg');\r\n    background-position: 0px 0px;\r\n    background-size: auto;\r\n  }\r\n\r\n  .div-block-6 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .div-block-7 {\r\n    margin-top: 100px;\r\n  }\r\n\r\n  .image-60 {\r\n    position: relative;\r\n    left: 98px;\r\n  }\r\n\r\n  .column-7 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: start;\r\n    -webkit-align-items: flex-start;\r\n    -ms-flex-align: start;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .text-block-48 {\r\n    position: relative;\r\n    top: -15px;\r\n    width: 100%;\r\n    height: 100%;\r\n    padding-left: 25px;\r\n    font-family: 'Fontspring demo nekst', sans-serif;\r\n    font-size: 20px;\r\n    line-height: 300%;\r\n    font-weight: 700;\r\n  }\r\n\r\n  .text-block-49 {\r\n    font-family: 'Fontspring demo nekst', sans-serif;\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n  }\r\n\r\n  .text-block-50 {\r\n    font-family: 'Fontspring demo nekst', sans-serif;\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n  }\r\n\r\n  .columns-3 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: row;\r\n    -ms-flex-direction: row;\r\n    flex-direction: row;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: start;\r\n    -webkit-align-items: flex-start;\r\n    -ms-flex-align: start;\r\n    align-items: flex-start;\r\n    -webkit-align-self: auto;\r\n    -ms-flex-item-align: auto;\r\n    align-self: auto;\r\n    -webkit-box-ordinal-group: 2;\r\n    -webkit-order: 1;\r\n    -ms-flex-order: 1;\r\n    order: 1;\r\n    -o-object-fit: cover;\r\n    object-fit: cover;\r\n  }\r\n\r\n  .image-61 {\r\n    padding-bottom: 20px;\r\n  }\r\n\r\n  .image-62 {\r\n    padding-bottom: 20px;\r\n  }\r\n\r\n  .image-63 {\r\n    padding-bottom: 2px;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 1920px) {\r\n  .body {\r\n    height: auto;\r\n    max-height: none;\r\n    max-width: none;\r\n    min-height: auto;\r\n  }\r\n\r\n  .heading-7 {\r\n    margin-left: 210px;\r\n  }\r\n\r\n  .image-12 {\r\n    margin-bottom: 100px;\r\n  }\r\n\r\n  .text-field {\r\n    color: #fff;\r\n  }\r\n\r\n  .text-field-2 {\r\n    color: #fff;\r\n  }\r\n\r\n  .textarea-2 {\r\n    color: #fff;\r\n  }\r\n\r\n  .column-2 {\r\n    padding-left: 0px;\r\n  }\r\n\r\n  .select-field {\r\n    color: #fff;\r\n  }\r\n\r\n  .html-embed {\r\n    margin-top: 100px;\r\n    margin-bottom: 100px;\r\n  }\r\n\r\n  .image-21 {\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    -ms-grid-row-align: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .heading-12 {\r\n    margin-left: 210px;\r\n  }\r\n\r\n  .text-block-10 {\r\n    margin-left: 210px;\r\n    opacity: 0.6;\r\n  }\r\n\r\n  .image-22 {\r\n    left: auto;\r\n    top: 0%;\r\n    right: 0%;\r\n    bottom: auto;\r\n  }\r\n\r\n  .section-7 {\r\n    margin-bottom: 300px;\r\n  }\r\n\r\n  .navbar-3 {\r\n    position: static;\r\n    width: 100%;\r\n    max-width: 100%;\r\n    min-width: 100%;\r\n    margin-right: auto;\r\n    margin-left: auto;\r\n  }\r\n\r\n  .nav-menu-4 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .image-26 {\r\n    position: relative;\r\n    left: -310px;\r\n    padding-left: 0px;\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    -ms-grid-row-align: center;\r\n    align-self: center;\r\n    -webkit-box-ordinal-group: 1;\r\n    -webkit-order: 0;\r\n    -ms-flex-order: 0;\r\n    order: 0;\r\n  }\r\n\r\n  .text-block-15 {\r\n    padding-top: 20px;\r\n  }\r\n\r\n  .icon-2 {\r\n    position: absolute;\r\n    top: 21px;\r\n  }\r\n\r\n  .dropdown-list-2.w--open {\r\n    top: 50px;\r\n  }\r\n\r\n  .dropdown-link-4 {\r\n    margin-top: 20px;\r\n  }\r\n\r\n  .dropdown-toggle-2 {\r\n    top: -11px;\r\n    padding-top: 25px;\r\n  }\r\n\r\n  .image-27 {\r\n    left: auto;\r\n    padding-left: 0px;\r\n    background-image: url('./../images/LOGO.svg');\r\n    background-position: 0px 0px;\r\n    background-size: auto;\r\n  }\r\n\r\n  .navbar-4 {\r\n    display: block;\r\n    margin-right: auto;\r\n    margin-left: auto;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .nav-link-16 {\r\n    padding-left: 270px;\r\n  }\r\n\r\n  .nav-menu-5 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    width: 100%;\r\n    height: auto;\r\n    margin-bottom: 100px;\r\n    padding-right: 0px;\r\n    padding-left: 0px;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: row;\r\n    -ms-flex-direction: row;\r\n    flex-direction: row;\r\n  }\r\n\r\n  .section-9 {\r\n    margin-top: -70px;\r\n    padding-top: 0px;\r\n    padding-bottom: 20px;\r\n  }\r\n\r\n  .container-14 {\r\n    position: relative;\r\n    left: -19%;\r\n    top: -1007px;\r\n  }\r\n\r\n  .container-15 {\r\n    left: 1137px;\r\n    top: 2794px;\r\n  }\r\n\r\n  .container-16 {\r\n    left: 470.609px;\r\n    top: 2570.81px;\r\n  }\r\n\r\n  .container-17 {\r\n    left: 1131.094px;\r\n    top: 3372.81px;\r\n  }\r\n\r\n  .section-13 {\r\n    height: 75%;\r\n    margin-bottom: 50px;\r\n  }\r\n\r\n  .grid-2 {\r\n    display: -ms-grid;\r\n    display: grid;\r\n    grid-auto-flow: row;\r\n    grid-auto-columns: 1fr;\r\n    grid-column-gap: 16px;\r\n    grid-row-gap: 16px;\r\n    -ms-grid-columns: 1fr 1fr 1fr 1fr 1fr;\r\n    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;\r\n    -ms-grid-rows: 1fr;\r\n    grid-template-rows: 1fr;\r\n  }\r\n\r\n  .grid-3 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    -ms-grid-columns: 1fr 1fr 1fr 1fr 1fr;\r\n    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;\r\n    -ms-grid-rows: 1fr;\r\n    grid-template-rows: 1fr;\r\n  }\r\n\r\n  .section-14 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    margin-top: 300px;\r\n    margin-bottom: 0px;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: row;\r\n    -ms-flex-direction: row;\r\n    flex-direction: row;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .grid-4 {\r\n    -ms-grid-columns: 1fr 1fr 1fr;\r\n    grid-template-columns: 1fr 1fr 1fr;\r\n  }\r\n\r\n  .grid-5 {\r\n    -ms-grid-columns: 1fr 1fr 1fr;\r\n    grid-template-columns: 1fr 1fr 1fr;\r\n  }\r\n\r\n  .section-15 {\r\n    margin-top: 0px;\r\n    margin-bottom: 100px;\r\n  }\r\n\r\n  .section-16 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    grid-auto-columns: 1fr;\r\n    grid-column-gap: 16px;\r\n    grid-row-gap: 16px;\r\n    -ms-grid-columns: 1fr 1fr;\r\n    grid-template-columns: 1fr 1fr;\r\n    -ms-grid-rows: auto auto;\r\n    grid-template-rows: auto auto;\r\n  }\r\n\r\n  .image-39 {\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    -ms-grid-row-align: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .container-19 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .section-17 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .image-40 {\r\n    position: relative;\r\n    margin-bottom: 100px;\r\n  }\r\n\r\n  .section-18 {\r\n    margin-bottom: 200px;\r\n  }\r\n\r\n  .heading-19 {\r\n    font-family: 'Fontspring demo nekst', sans-serif;\r\n    font-size: 44px;\r\n  }\r\n\r\n  .text-block-30 {\r\n    margin-bottom: 0px;\r\n    padding-bottom: 10px;\r\n    opacity: 0.6;\r\n    font-family: Inter, sans-serif;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .grid-6 {\r\n    margin-top: 5px;\r\n    -ms-grid-columns: 1fr 1fr 1fr 1fr 1fr;\r\n    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;\r\n    -ms-grid-rows: auto;\r\n    grid-template-rows: auto;\r\n  }\r\n\r\n  .html-embed-4 {\r\n    margin-top: 100px;\r\n  }\r\n\r\n  .text-block-31 {\r\n    width: 100%;\r\n    font-family: Inter, sans-serif;\r\n    text-align: left;\r\n  }\r\n\r\n  .text-block-32 {\r\n    left: auto;\r\n    top: -45px;\r\n    width: 40%;\r\n    padding-left: 0px;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .section-19 {\r\n    margin-bottom: 300px;\r\n  }\r\n\r\n  .div-block-3 {\r\n    width: 100%;\r\n    height: 100.000042%;\r\n  }\r\n\r\n  .text-block-35 {\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n  }\r\n\r\n  .button-3 {\r\n    position: relative;\r\n    left: 101px;\r\n  }\r\n\r\n  .button-4 {\r\n    position: relative;\r\n    left: 380px;\r\n    width: 180px;\r\n    height: 56px;\r\n    padding-top: 20px;\r\n    border: 1px none #000;\r\n    background-color: transparent;\r\n    background-image: url('./../images/Frame-1261152715.png');\r\n    background-position: 0px 0px;\r\n    background-size: auto;\r\n  }\r\n\r\n  .div-block-5 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    max-width: 1920px;\r\n    margin-right: auto;\r\n    margin-left: auto;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .button-5 {\r\n    position: relative;\r\n    left: -255px;\r\n    width: 119px;\r\n    height: 40px;\r\n    padding-top: 20px;\r\n    border: 1px none #000;\r\n    background-color: transparent;\r\n    background-image: url('./../images/LOGO.svg');\r\n    background-position: 0px 0px;\r\n    background-size: auto;\r\n  }\r\n\r\n  .button-5.w--current {\r\n    left: -270px;\r\n  }\r\n\r\n  .image-60 {\r\n    position: relative;\r\n    top: -51px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  .nav-menu-wrapper {\r\n    background-color: transparent;\r\n  }\r\n\r\n  .nav-menu {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    padding-left: 0px;\r\n    -webkit-justify-content: space-around;\r\n    -ms-flex-pack: distribute;\r\n    justify-content: space-around;\r\n    -webkit-flex-wrap: wrap;\r\n    -ms-flex-wrap: wrap;\r\n    flex-wrap: wrap;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    background-color: #fff;\r\n  }\r\n\r\n  .nav-link {\r\n    padding-right: 5px;\r\n    padding-left: 5px;\r\n  }\r\n\r\n  .nav-dropdown-list.shadow-three.w--open {\r\n    position: absolute;\r\n  }\r\n\r\n  .nav-button-wrapper {\r\n    width: 100%;\r\n    margin-left: 0px;\r\n  }\r\n\r\n  .menu-button {\r\n    padding: 12px;\r\n  }\r\n\r\n  .menu-button.w--open {\r\n    background-color: #a6b1bf;\r\n    color: #fff;\r\n  }\r\n\r\n  .body {\r\n    padding-right: 25px;\r\n    padding-left: 25px;\r\n    font-family: Inter, sans-serif;\r\n  }\r\n\r\n  .container-2 {\r\n    max-width: 728px;\r\n  }\r\n\r\n  .hero-wrapper {\r\n    margin-bottom: -40px;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: start;\r\n    -webkit-justify-content: flex-start;\r\n    -ms-flex-pack: start;\r\n    justify-content: flex-start;\r\n    -webkit-box-align: start;\r\n    -webkit-align-items: flex-start;\r\n    -ms-flex-align: start;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .hero-split {\r\n    max-width: 100%;\r\n    margin-bottom: 40px;\r\n  }\r\n\r\n  .text-block-5 {\r\n    margin-right: 0px;\r\n    margin-left: 0px;\r\n  }\r\n\r\n  .image-2 {\r\n    position: relative;\r\n    margin-top: 90px;\r\n    margin-left: 0px;\r\n  }\r\n\r\n  .image-3 {\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .nav-menu-wrapper-2 {\r\n    background-color: transparent;\r\n  }\r\n\r\n  .nav-menu-2 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    padding-left: 0px;\r\n    -webkit-justify-content: space-around;\r\n    -ms-flex-pack: distribute;\r\n    justify-content: space-around;\r\n    -webkit-flex-wrap: wrap;\r\n    -ms-flex-wrap: wrap;\r\n    flex-wrap: wrap;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    background-color: #fff;\r\n  }\r\n\r\n  .nav-link-2 {\r\n    padding-right: 5px;\r\n    padding-left: 5px;\r\n  }\r\n\r\n  .nav-dropdown-list-2.shadow-three.w--open {\r\n    position: absolute;\r\n  }\r\n\r\n  .nav-button-wrapper-2 {\r\n    width: 100%;\r\n    margin-left: 0px;\r\n  }\r\n\r\n  .menu-button-2 {\r\n    padding: 12px;\r\n  }\r\n\r\n  .menu-button-2.w--open {\r\n    background-color: #a6b1bf;\r\n    color: #fff;\r\n  }\r\n\r\n  .paragraph-2 {\r\n    margin-top: 25px;\r\n  }\r\n\r\n  \r\n\r\n  .heading-7 {\r\n    width: 100%;\r\n    margin-left: 0px;\r\n    padding-left: 20px;\r\n    font-size: 24px;\r\n  }\r\n\r\n  .container-5 {\r\n    max-width: 728px;\r\n  }\r\n\r\n  .footer-wrapper-two {\r\n    -webkit-flex-wrap: wrap;\r\n    -ms-flex-wrap: wrap;\r\n    flex-wrap: wrap;\r\n  }\r\n\r\n  .footer-form {\r\n    width: 100%;\r\n    margin-top: 40px;\r\n  }\r\n\r\n  .footer-form-container {\r\n    max-width: 350px;\r\n  }\r\n\r\n  .text-field {\r\n    width: 82.1%;\r\n    min-height: auto;\r\n    min-width: 590px;\r\n  }\r\n\r\n  .text-field-2 {\r\n    width: 82.1%;\r\n    min-width: 590px;\r\n  }\r\n\r\n  .select-field {\r\n    width: 82.1%;\r\n  }\r\n\r\n  .heading-10 {\r\n    width: 85%;\r\n    margin-top: 0px;\r\n    margin-bottom: 0px;\r\n    margin-left: 0px;\r\n    padding: 20px;\r\n  }\r\n\r\n  .text-block-9 {\r\n    width: 85%;\r\n    margin-left: 0px;\r\n    padding-right: 20px;\r\n    padding-left: 20px;\r\n  }\r\n\r\n  .image-21 {\r\n    left: auto;\r\n  }\r\n\r\n  .heading-12 {\r\n    width: 95%;\r\n    margin-left: 0px;\r\n    padding-left: 20px;\r\n  }\r\n\r\n  .text-block-10 {\r\n    margin-left: 0px;\r\n    padding-left: 20px;\r\n    opacity: 0.6;\r\n  }\r\n\r\n  .image-22 {\r\n    left: auto;\r\n    top: 0%;\r\n    right: 0%;\r\n    bottom: auto;\r\n    max-height: 70%;\r\n    opacity: 0.2;\r\n  }\r\n\r\n  .image-23 {\r\n    margin-top: 15px;\r\n  }\r\n\r\n  .navbar-2 {\r\n    background-color: transparent;\r\n    font-family: Lato, sans-serif;\r\n    color: #fff;\r\n  }\r\n\r\n  .image-27 {\r\n    position: relative;\r\n    left: auto;\r\n  }\r\n\r\n  .nav-menu-5 {\r\n    left: auto;\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    margin-left: 0px;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: row;\r\n    -ms-flex-direction: row;\r\n    flex-direction: row;\r\n    -webkit-box-pack: start;\r\n    -webkit-justify-content: flex-start;\r\n    -ms-flex-pack: start;\r\n    justify-content: flex-start;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    -webkit-align-self: auto;\r\n    -ms-flex-item-align: auto;\r\n    align-self: auto;\r\n  }\r\n\r\n  .section-10 {\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .container-12 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .section-12 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .grid-3 {\r\n    display: -ms-grid;\r\n    display: grid;\r\n    grid-auto-columns: 1fr;\r\n    grid-column-gap: 16px;\r\n    grid-row-gap: 16px;\r\n    -ms-grid-columns: 1fr 1fr;\r\n    grid-template-columns: 1fr 1fr;\r\n    -ms-grid-rows: auto auto;\r\n    grid-template-rows: auto auto;\r\n  }\r\n\r\n  .image-38 {\r\n    position: relative;\r\n    left: 110px;\r\n  }\r\n\r\n  .section-18 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    padding-top: 25px;\r\n    padding-bottom: 25px;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .text-block-32 {\r\n    left: auto;\r\n    padding-right: 0px;\r\n    padding-left: 0px;\r\n  }\r\n\r\n  .div-block-2 {\r\n    margin-left: 0px;\r\n  }\r\n\r\n  .div-block-4 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .image-43 {\r\n    display: inline-block;\r\n  }\r\n\r\n  .text-block-37 {\r\n    padding-top: 25px;\r\n    padding-bottom: 25px;\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n  }\r\n\r\n  .text-block-38 {\r\n    padding-bottom: 25px;\r\n  }\r\n\r\n  .text-block-39 {\r\n    padding-bottom: 25px;\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n  }\r\n\r\n  .columns-2 {\r\n    padding-bottom: 25px;\r\n  }\r\n\r\n  .text-block-40 {\r\n    padding-bottom: 25px;\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n  }\r\n\r\n  .image-50 {\r\n    padding-bottom: 25px;\r\n  }\r\n\r\n  .image-52 {\r\n    padding-bottom: 25px;\r\n  }\r\n\r\n  .image-53 {\r\n    padding-bottom: 25px;\r\n  }\r\n\r\n  .text-block-43 {\r\n    padding-bottom: 25px;\r\n  }\r\n\r\n  .text-block-44 {\r\n    padding-bottom: 25px;\r\n  }\r\n\r\n  .text-block-45 {\r\n    padding-top: 25px;\r\n    padding-bottom: 25px;\r\n  }\r\n\r\n  .button-3 {\r\n    width: 40px;\r\n    height: 40px;\r\n    padding: 0px;\r\n    background-color: transparent;\r\n    background-image: url('./../images/li_arrow-right-circle.png');\r\n    background-position: 0px 0px;\r\n    background-size: auto;\r\n  }\r\n\r\n  .button-4 {\r\n    left: 207px;\r\n  }\r\n\r\n  .button-5 {\r\n    left: 4px;\r\n  }\r\n\r\n  .button-5.w--current {\r\n    left: 100px;\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    -ms-grid-row-align: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .div-block-6 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    padding-top: 25px;\r\n    padding-bottom: 25px;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .div-block-7 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    font-family: Inter, sans-serif;\r\n  }\r\n\r\n  .heading-22 {\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n  }\r\n\r\n  .heading-23 {\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n  }\r\n\r\n  .heading-24 {\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n  }\r\n\r\n  .heading-25 {\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n  }\r\n\r\n  .heading-26 {\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n  }\r\n\r\n  .heading-27 {\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n  }\r\n\r\n  .text-block-46 {\r\n    padding-bottom: 25px;\r\n  }\r\n\r\n  .text-block-47 {\r\n    padding-bottom: 25px;\r\n  }\r\n\r\n  .image-60 {\r\n    left: auto;\r\n  }\r\n\r\n  .text-block-48 {\r\n    line-height: 300%;\r\n  }\r\n\r\n  .form {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: start;\r\n    -webkit-align-items: flex-start;\r\n    -ms-flex-align: start;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .menu-button-6 {\r\n    left: -390px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .navbar-brand {\r\n    padding-left: 0px;\r\n  }\r\n\r\n  .nav-menu {\r\n    padding-bottom: 30px;\r\n    padding-left: 0px;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .nav-link {\r\n    display: inline-block;\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n  }\r\n\r\n  .nav-dropdown {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .nav-dropdown-toggle {\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n  }\r\n\r\n  .nav-dropdown-list.shadow-three {\r\n    box-shadow: 0 8px 50px 0 rgba(0, 0, 0, 0.05);\r\n  }\r\n\r\n  .nav-dropdown-list.shadow-three.w--open {\r\n    position: relative;\r\n  }\r\n\r\n  .nav-dropdown-list.shadow-three.mobile-shadow-hide {\r\n    box-shadow: none;\r\n  }\r\n\r\n  .mobile-margin-top-10 {\r\n    margin-top: 10px;\r\n  }\r\n\r\n  .hero-heading-center {\r\n    padding: 60px 15px;\r\n  }\r\n\r\n  .heading-2 {\r\n    margin-top: 10px;\r\n    padding-left: 10px;\r\n  }\r\n\r\n  .text-block-5 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    margin-right: 0px;\r\n    margin-left: 0px;\r\n    padding-right: 20px;\r\n    padding-left: 20px;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .image-2 {\r\n    margin-left: 0px;\r\n  }\r\n\r\n  .navbar-brand-2 {\r\n    padding-left: 0px;\r\n  }\r\n\r\n  .nav-menu-2 {\r\n    padding-bottom: 30px;\r\n    padding-left: 0px;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .nav-link-2 {\r\n    display: inline-block;\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n  }\r\n\r\n  .nav-dropdown-2 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .nav-dropdown-toggle-2 {\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n  }\r\n\r\n  .nav-dropdown-list-2.shadow-three {\r\n    box-shadow: 0 8px 50px 0 rgba(0, 0, 0, 0.05);\r\n  }\r\n\r\n  .nav-dropdown-list-2.shadow-three.w--open {\r\n    position: relative;\r\n  }\r\n\r\n  .nav-dropdown-list-2.shadow-three.mobile-shadow-hide {\r\n    box-shadow: none;\r\n  }\r\n\r\n  .mobile-margin-top-11 {\r\n    margin-top: 10px;\r\n  }\r\n\r\n  .footer-light {\r\n    padding-right: 15px;\r\n    padding-left: 15px;\r\n  }\r\n\r\n  .footer-bottom {\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: start;\r\n    -webkit-justify-content: flex-start;\r\n    -ms-flex-pack: start;\r\n    justify-content: flex-start;\r\n    -webkit-box-align: start;\r\n    -webkit-align-items: flex-start;\r\n    -ms-flex-align: start;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .footer-copyright {\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n  }\r\n\r\n  .footer-social-block-two {\r\n    margin-top: 20px;\r\n  }\r\n\r\n  .footer-social-link {\r\n    margin-left: 20px;\r\n  }\r\n\r\n  .heading-10 {\r\n    width: 100%;\r\n    height: 72.3224%;\r\n    min-height: 63%;\r\n  }\r\n\r\n  .text-block-9 {\r\n    width: 70%;\r\n    border-radius: 0px;\r\n    opacity: 0.6;\r\n    color: #fff;\r\n  }\r\n\r\n  .image-18 {\r\n    display: block;\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    -ms-grid-row-align: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .image-19 {\r\n    display: block;\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    -ms-grid-row-align: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .container-6 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .image-20 {\r\n    position: static;\r\n    left: 0px;\r\n    top: auto;\r\n    margin-top: 20px;\r\n  }\r\n\r\n  .image-21 {\r\n    left: 0px;\r\n    top: 10px;\r\n  }\r\n\r\n  .image-25 {\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    -ms-grid-row-align: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .heading-13 {\r\n    margin-left: 0px;\r\n    padding-right: 20px;\r\n    padding-left: 20px;\r\n  }\r\n\r\n  .text-block-12 {\r\n    margin-left: 0px;\r\n    padding-right: 20px;\r\n    padding-left: 20px;\r\n  }\r\n\r\n  .heading-14 {\r\n    margin-left: 0px;\r\n    padding-left: 20px;\r\n  }\r\n\r\n  .text-block-13 {\r\n    margin-left: 0px;\r\n    padding-bottom: 20px;\r\n    padding-left: 20px;\r\n  }\r\n\r\n  .text-block-14 {\r\n    margin-left: 0px;\r\n    padding-right: 20px;\r\n    padding-left: 20px;\r\n  }\r\n\r\n  .div-block {\r\n    margin-right: 20px;\r\n    margin-left: 20px;\r\n    padding-right: 20px;\r\n    padding-left: 20px;\r\n    border-top: 1px solid #fff;\r\n    border-radius: 2px;\r\n    opacity: 0.6;\r\n  }\r\n\r\n  .section-9 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .container-11 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .section-10 {\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .container-12 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .section-12 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .button-5.w--current {\r\n    left: 27px;\r\n  }\r\n\r\n  .columns-3 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n  }\r\n\r\n  .menu-button-6 {\r\n    left: -277px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 479px) {\r\n  .nav-menu {\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .nav-button-wrapper {\r\n    width: auto;\r\n  }\r\n\r\n  .body {\r\n    max-height: none;\r\n    max-width: none;\r\n    min-width: 100%;\r\n  }\r\n\r\n  .container-2 {\r\n    max-width: none;\r\n  }\r\n\r\n  .centered-heading {\r\n    margin-bottom: 24px;\r\n  }\r\n\r\n  .heading-2 {\r\n    padding-right: 10px;\r\n    padding-left: 10px;\r\n    font-size: 24px;\r\n  }\r\n\r\n  .text-block-5 {\r\n    margin: 0px;\r\n    padding: 20px;\r\n    opacity: 0.6;\r\n    color: #fff;\r\n    text-align: center;\r\n  }\r\n\r\n  .image-2 {\r\n    position: relative;\r\n    left: 0%;\r\n    top: 0%;\r\n    right: 0%;\r\n    bottom: 0%;\r\n    margin-top: 0px;\r\n    margin-left: 0px;\r\n    padding-top: 20px;\r\n    float: none;\r\n  }\r\n\r\n  .nav-menu-2 {\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .nav-button-wrapper-2 {\r\n    width: auto;\r\n  }\r\n\r\n  .heading-4 {\r\n    padding-left: 0px;\r\n  }\r\n\r\n  .paragraph-2 {\r\n    margin-top: 218px;\r\n  }\r\n\r\n  .paragraph-3 {\r\n    width: 100%;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .paragraph-5 {\r\n    margin-top: 21px;\r\n  }\r\n\r\n  .paragraph-6 {\r\n    margin-top: 250px;\r\n  }\r\n\r\n \r\n\r\n  .heading-7 {\r\n    min-height: 0px;\r\n    min-width: 0px;\r\n    margin-left: 0px;\r\n    padding: 165px 20px 0px;\r\n    font-size: 24px;\r\n    line-height: 136.5%;\r\n  }\r\n\r\n  .image-12 {\r\n    max-width: 95%;\r\n    min-height: auto;\r\n    min-width: auto;\r\n    padding-top: 100px;\r\n  }\r\n\r\n  .container-5 {\r\n    max-width: none;\r\n  }\r\n\r\n  .footer-wrapper-two {\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: start;\r\n    -webkit-justify-content: flex-start;\r\n    -ms-flex-pack: start;\r\n    justify-content: flex-start;\r\n    -webkit-box-align: start;\r\n    -webkit-align-items: flex-start;\r\n    -ms-flex-align: start;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .footer-block-two {\r\n    margin-top: 40px;\r\n  }\r\n\r\n  .footer-bottom {\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: start;\r\n    -webkit-justify-content: flex-start;\r\n    -ms-flex-pack: start;\r\n    justify-content: flex-start;\r\n    -webkit-box-align: start;\r\n    -webkit-align-items: flex-start;\r\n    -ms-flex-align: start;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .footer-social-block-two {\r\n    margin-top: 20px;\r\n  }\r\n\r\n  .heading-8 {\r\n    width: 100%;\r\n    padding-bottom: 25px;\r\n    line-height: 80px;\r\n  }\r\n\r\n  .field-label-2 {\r\n    margin-bottom: 0px;\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n  }\r\n\r\n  .text-field {\r\n    width: 80%;\r\n    height: 40px;\r\n    min-width: auto;\r\n    margin-bottom: 0px;\r\n    background-image: url('./../images/Rectangle-9397-2.png');\r\n    background-size: auto;\r\n    color: #fff;\r\n  }\r\n\r\n  .text-field-2 {\r\n    width: 91%;\r\n    height: 43px;\r\n    min-width: auto;\r\n    margin-bottom: 0px;\r\n    padding-bottom: 30px;\r\n    background-image: url('./../images/Rectangle-9397-2.png'), url('./../images/Rectangle-9397.png');\r\n    background-position: 0px 0px, 0px 0px;\r\n    background-size: auto, auto;\r\n    color: #fff;\r\n  }\r\n\r\n  .field-label-3 {\r\n    margin-bottom: 0px;\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n  }\r\n\r\n  .field-label-4 {\r\n    margin-bottom: 0px;\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n  }\r\n\r\n  .submit-button {\r\n    width: 97%;\r\n    height: 60px;\r\n    min-height: auto;\r\n    min-width: auto;\r\n    margin-left: 0px;\r\n    background-image: url('./../images/button-submit.png');\r\n    color: transparent;\r\n  }\r\n\r\n  .textarea-2 {\r\n    width: 100%;\r\n    color: #fff;\r\n  }\r\n\r\n  .column-2 {\r\n    margin-top: 0px;\r\n  }\r\n\r\n  .select-field {\r\n    width: 100%;\r\n    min-width: auto;\r\n    color: #fff;\r\n  }\r\n\r\n  .heading-10 {\r\n    min-height: 184px;\r\n    margin-top: -60px;\r\n    margin-left: 0px;\r\n    padding: 20px 20px;\r\n    font-size: 40px;\r\n    line-height: 136%;\r\n  }\r\n\r\n  .text-block-9 {\r\n    min-height: 129px;\r\n    width: 100%;\r\n    margin-left: 0px;\r\n    padding-right: 20px;\r\n    padding-left: 20px;\r\n    font-size: 14px;\r\n    line-height: 210%;\r\n  }\r\n\r\n  .image-17 {\r\n    position: static;\r\n    left: 0px;\r\n    top: auto;\r\n    margin-top: 0px;\r\n    padding-right: 20px;\r\n    padding-left: 20px;\r\n  }\r\n\r\n  .image-18 {\r\n    position: static;\r\n    left: -8px;\r\n    top: auto;\r\n    margin-top: auto;\r\n    padding-right: 20px;\r\n    padding-left: 20px;\r\n  }\r\n\r\n  .image-19 {\r\n    position: static;\r\n    padding-right: 20px;\r\n    padding-left: 20px;\r\n  }\r\n\r\n  .container-6 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .image-20 {\r\n    left: 0px;\r\n  }\r\n\r\n  .image-21 {\r\n    left: 0px;\r\n    top: 10px;\r\n  }\r\n\r\n  .heading-12 {\r\n    width: 100%;\r\n    height: 100%;\r\n    min-height: 378px;\r\n    margin-top: 50px;\r\n    margin-left: 0px;\r\n    padding-right: 20px;\r\n    padding-left: 20px;\r\n    font-size: 32px;\r\n  }\r\n\r\n  .text-block-10 {\r\n    width: 100%;\r\n    height: 100%;\r\n    margin-bottom: 100px;\r\n    margin-left: 0px;\r\n    padding: 10px 20px;\r\n    opacity: 0.6;\r\n  }\r\n\r\n  .image-22 {\r\n    width: 100%;\r\n    right: auto;\r\n    bottom: auto;\r\n    margin-bottom: -29px;\r\n    opacity: 0.2;\r\n    -o-object-fit: fill;\r\n    object-fit: fill;\r\n  }\r\n\r\n  \r\n\r\n  .container-7 {\r\n    background-color: transparent;\r\n  }\r\n\r\n  .image-23 {\r\n    margin-top: 15px;\r\n  }\r\n\r\n  .navbar-2 {\r\n    background-color: transparent;\r\n  }\r\n\r\n  .nav-menu-3 {\r\n    background-color: transparent;\r\n  }\r\n\r\n  .image-25 {\r\n    position: static;\r\n    left: -8px;\r\n    padding-right: 20px;\r\n    padding-left: 20px;\r\n    float: left;\r\n  }\r\n\r\n  .text-block-11 {\r\n    margin-left: -60px;\r\n    color: #fff;\r\n  }\r\n\r\n  .icon {\r\n    color: #fff;\r\n  }\r\n\r\n  .dropdown-link {\r\n    margin-top: -40px;\r\n    color: #fff;\r\n  }\r\n\r\n  .dropdown-list.w--open {\r\n    background-color: transparent;\r\n  }\r\n\r\n  .dropdown-link-2 {\r\n    color: #fff;\r\n  }\r\n\r\n  .dropdown-link-3 {\r\n    color: #fff;\r\n  }\r\n\r\n  .menu-button-3 {\r\n    background-color: transparent;\r\n  }\r\n\r\n  .menu-button-3.w--open {\r\n    background-color: transparent;\r\n  }\r\n\r\n  .heading-13 {\r\n    margin-left: 0px;\r\n    padding-right: 20px;\r\n    padding-left: 20px;\r\n  }\r\n\r\n  .text-block-12 {\r\n    margin-left: 0px;\r\n    padding-right: 20px;\r\n    padding-left: 20px;\r\n  }\r\n\r\n  .heading-14 {\r\n    margin-top: 50px;\r\n    margin-left: 0px;\r\n    padding-right: 20px;\r\n    padding-left: 20px;\r\n  }\r\n\r\n  .text-block-13 {\r\n    margin-left: 0px;\r\n    padding-left: 20px;\r\n    opacity: 0.6;\r\n  }\r\n\r\n  .text-block-14 {\r\n    margin-left: 0px;\r\n    padding-top: 20px;\r\n    padding-right: 20px;\r\n    padding-left: 20px;\r\n  }\r\n\r\n  .div-block {\r\n    border-top: 1px solid #fff;\r\n    border-radius: 2px;\r\n  }\r\n\r\n  .navbar-3 {\r\n    background-color: transparent;\r\n  }\r\n\r\n  .nav-menu-4 {\r\n    width: 80%;\r\n    padding-top: 97px;\r\n    background-color: #002730;\r\n  }\r\n\r\n  .image-26 {\r\n    margin-top: 10px;\r\n    padding-top: 0px;\r\n  }\r\n\r\n  .nav-link-11 {\r\n    margin-top: -20px;\r\n    color: #fff;\r\n  }\r\n\r\n  .nav-link-12 {\r\n    color: #fff;\r\n  }\r\n\r\n  .nav-link-13 {\r\n    color: #fff;\r\n  }\r\n\r\n  .text-block-15 {\r\n    color: #fff;\r\n  }\r\n\r\n  .icon-2 {\r\n    color: #fff;\r\n  }\r\n\r\n  .nav-link-14 {\r\n    color: #fff;\r\n  }\r\n\r\n  .nav-link-15 {\r\n    color: #fff;\r\n  }\r\n\r\n  .dropdown-list-2.w--open {\r\n    background-color: transparent;\r\n    color: #fff;\r\n  }\r\n\r\n  .dropdown-link-4 {\r\n    color: #fff;\r\n  }\r\n\r\n  .dropdown-link-5 {\r\n    color: #fff;\r\n  }\r\n\r\n  .dropdown-link-6 {\r\n    color: #fff;\r\n  }\r\n\r\n  .container-8 {\r\n    background-color: transparent;\r\n  }\r\n\r\n  .dropdown-toggle-2 {\r\n    left: -90px;\r\n    margin-left: 0px;\r\n    padding-left: 20px;\r\n  }\r\n\r\n  .menu-button-4 {\r\n    background-color: transparent;\r\n  }\r\n\r\n  .menu-button-4.w--open {\r\n    background-color: transparent;\r\n  }\r\n\r\n  .nav-link-16 {\r\n    padding-right: 0px;\r\n    padding-left: 0px;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .nav-link-17 {\r\n    padding-right: 10px;\r\n    padding-left: 10px;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .nav-link-18 {\r\n    padding-left: 0px;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .nav-menu-5 {\r\n    margin-right: auto;\r\n    margin-left: auto;\r\n    padding-right: 0px;\r\n    padding-bottom: 10px;\r\n    padding-left: 0px;\r\n    background-color: transparent;\r\n  }\r\n\r\n  .menu-button-5 {\r\n    background-color: transparent;\r\n  }\r\n\r\n  .menu-button-5.w--open {\r\n    background-color: transparent;\r\n  }\r\n\r\n  .image-28 {\r\n    position: relative;\r\n    left: -77px;\r\n    top: -85px;\r\n  }\r\n\r\n  .image-29 {\r\n    position: relative;\r\n    left: -70px;\r\n    top: -85px;\r\n    padding-left: 20px;\r\n  }\r\n\r\n  .section-9 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .container-11 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .section-10 {\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .image-30 {\r\n    width: 80%;\r\n    max-width: none;\r\n    padding-bottom: 20px;\r\n    padding-left: 10px;\r\n  }\r\n\r\n  .image-31 {\r\n    max-width: 80%;\r\n    padding-bottom: 20px;\r\n  }\r\n\r\n  .image-32 {\r\n    max-width: 80%;\r\n    padding-top: 20px;\r\n    padding-right: 10px;\r\n  }\r\n\r\n  .container-12 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .heading-15 {\r\n    font-family: Inter, sans-serif;\r\n    color: #03e287;\r\n    font-size: 24px;\r\n  }\r\n\r\n  .text-block-17 {\r\n    padding-bottom: 16px;\r\n  }\r\n\r\n  .text-block-18 {\r\n    padding-bottom: 16px;\r\n  }\r\n\r\n  .text-block-19 {\r\n    padding-bottom: 16px;\r\n    opacity: 0.6;\r\n  }\r\n\r\n  .container-14 {\r\n    position: absolute;\r\n    left: 65px;\r\n    top: 2911px;\r\n    max-height: 100%;\r\n    max-width: 100%;\r\n    padding-right: 20px;\r\n    font-family: Inter, sans-serif;\r\n  }\r\n\r\n  .heading-16 {\r\n    color: #03e287;\r\n    font-size: 24px;\r\n  }\r\n\r\n  .text-block-22 {\r\n    padding-bottom: 16px;\r\n  }\r\n\r\n  .text-block-23 {\r\n    padding-bottom: 16px;\r\n  }\r\n\r\n  .container-15 {\r\n    position: absolute;\r\n    left: 59px;\r\n    top: 3178px;\r\n    font-family: Inter, sans-serif;\r\n  }\r\n\r\n  .heading-17 {\r\n    font-family: Inter, sans-serif;\r\n    color: #03e287;\r\n    font-size: 24px;\r\n  }\r\n\r\n  .text-block-25 {\r\n    padding-bottom: 16px;\r\n    opacity: 0.6;\r\n    font-family: Inter, sans-serif;\r\n  }\r\n\r\n  .text-block-26 {\r\n    padding-bottom: 16px;\r\n    font-family: Inter, sans-serif;\r\n  }\r\n\r\n  .container-16 {\r\n    position: absolute;\r\n    left: 58px;\r\n    top: 3404px;\r\n  }\r\n\r\n  .heading-18 {\r\n    font-family: Inter, sans-serif;\r\n    color: #03e287;\r\n    font-size: 24px;\r\n  }\r\n\r\n  .text-block-27 {\r\n    font-family: Inter, sans-serif;\r\n  }\r\n\r\n  .container-17 {\r\n    position: absolute;\r\n    left: 53px;\r\n    top: 3624px;\r\n  }\r\n\r\n  .text-block-28 {\r\n    padding-bottom: 16px;\r\n    font-family: Inter, sans-serif;\r\n  }\r\n\r\n  .text-block-29 {\r\n    font-family: Inter, sans-serif;\r\n  }\r\n\r\n  .container-18 {\r\n    padding-top: 20px;\r\n    padding-bottom: 50px;\r\n    padding-left: 10px;\r\n  }\r\n\r\n  .section-12 {\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .grid-3 {\r\n    display: -ms-grid;\r\n    display: grid;\r\n    padding: 20px;\r\n    grid-auto-columns: 1fr;\r\n    grid-column-gap: 16px;\r\n    grid-row-gap: 16px;\r\n    -ms-grid-columns: 1fr 1fr;\r\n    grid-template-columns: 1fr 1fr;\r\n    -ms-grid-rows: auto auto;\r\n    grid-template-rows: auto auto;\r\n  }\r\n\r\n  .image-38 {\r\n    left: 80px;\r\n    display: block;\r\n    margin-left: 0px;\r\n  }\r\n\r\n  .grid-5 {\r\n    padding-right: 20px;\r\n    padding-bottom: 20px;\r\n    padding-left: 20px;\r\n  }\r\n\r\n  .image-40 {\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .section-18 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    padding-right: 20px;\r\n    padding-left: 20px;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .heading-19 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .text-block-30 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: row;\r\n    -ms-flex-direction: row;\r\n    flex-direction: row;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .grid-6 {\r\n    display: -ms-grid;\r\n    display: grid;\r\n    width: 100%;\r\n    height: 100%;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: row;\r\n    -ms-flex-direction: row;\r\n    flex-direction: row;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    -ms-grid-row-align: auto;\r\n    align-self: auto;\r\n    grid-auto-flow: row;\r\n    grid-auto-columns: 1fr;\r\n    grid-column-gap: 16px;\r\n    grid-row-gap: 16px;\r\n    -ms-grid-columns: 1fr 1fr 1fr 1fr 1fr;\r\n    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;\r\n    -ms-grid-rows: 72px auto;\r\n    grid-template-rows: 72px auto;\r\n  }\r\n\r\n  .text-block-32 {\r\n    left: auto;\r\n    display: block;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: row;\r\n    -ms-flex-direction: row;\r\n    flex-direction: row;\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    -ms-grid-row-align: center;\r\n    align-self: center;\r\n    -webkit-box-ordinal-group: 1;\r\n    -webkit-order: 0;\r\n    -ms-flex-order: 0;\r\n    order: 0;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .column-3 {\r\n    margin-top: 75px;\r\n    padding-left: 20px;\r\n  }\r\n\r\n  .column-4 {\r\n    padding-left: 20px;\r\n  }\r\n\r\n  .div-block-2 {\r\n    margin-top: 50px;\r\n    margin-left: 0px;\r\n  }\r\n\r\n  .div-block-4 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    padding-right: 0px;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    font-family: Inter, sans-serif;\r\n  }\r\n\r\n  .text-block-33 {\r\n    display: block;\r\n    padding-left: 0px;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .text-block-34 {\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n    -webkit-box-ordinal-group: 1;\r\n    -webkit-order: 0;\r\n    -ms-flex-order: 0;\r\n    order: 0;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .image-43 {\r\n    max-width: 80%;\r\n    -webkit-align-self: center;\r\n    -ms-flex-item-align: center;\r\n    -ms-grid-row-align: center;\r\n    align-self: center;\r\n  }\r\n\r\n  .text-block-35 {\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .text-block-36 {\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .image-44 {\r\n    max-width: 80%;\r\n  }\r\n\r\n  .image-45 {\r\n    max-width: 80%;\r\n  }\r\n\r\n  .image-46 {\r\n    max-width: 80%;\r\n  }\r\n\r\n  .text-block-37 {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .text-block-38 {\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .text-block-39 {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .image-47 {\r\n    max-width: 80%;\r\n  }\r\n\r\n  .image-48 {\r\n    max-width: 80%;\r\n  }\r\n\r\n  .text-block-40 {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .image-49 {\r\n    display: block;\r\n    max-width: 80%;\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n  }\r\n\r\n  .image-50 {\r\n    max-width: 80%;\r\n  }\r\n\r\n  .image-51 {\r\n    max-width: 80%;\r\n    padding-bottom: 20px;\r\n  }\r\n\r\n  .text-block-41 {\r\n    padding-bottom: 20px;\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .image-52 {\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n  }\r\n\r\n  .text-block-42 {\r\n    padding-bottom: 25px;\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .image-54 {\r\n    max-width: 80%;\r\n  }\r\n\r\n  .text-block-43 {\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .image-55 {\r\n    max-width: 80%;\r\n  }\r\n\r\n  .text-block-44 {\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .image-57 {\r\n    max-width: 80%;\r\n  }\r\n\r\n  .image-58 {\r\n    max-width: 80%;\r\n  }\r\n\r\n  .text-block-45 {\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .image-59 {\r\n    max-width: 80%;\r\n  }\r\n\r\n  .button-3 {\r\n    width: 40px;\r\n    height: 40px;\r\n    background-color: transparent;\r\n    background-image: url('./../images/li_arrow-right-circle.png');\r\n    background-position: 0px 0px;\r\n    background-size: auto;\r\n  }\r\n\r\n  .button-5 {\r\n    left: 10px;\r\n    width: 32%;\r\n  }\r\n\r\n  .button-5.w--current {\r\n    left: 86px;\r\n    width: 30%;\r\n    padding-right: 0px;\r\n  }\r\n\r\n  .section-20 {\r\n    margin-top: -60px;\r\n  }\r\n\r\n  .heading-22 {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .heading-23 {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .heading-24 {\r\n    width: 50%;\r\n    font-size: 20px;\r\n  }\r\n\r\n  .heading-25 {\r\n    width: 80%;\r\n    padding-left: 0px;\r\n    font-size: 20px;\r\n  }\r\n\r\n  .heading-26 {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .heading-27 {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .text-block-46 {\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .text-block-47 {\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .heading-28 {\r\n    max-width: 80%;\r\n    font-size: 20px;\r\n  }\r\n\r\n  .heading-29 {\r\n    max-width: 80%;\r\n    font-size: 20px;\r\n  }\r\n\r\n  .heading-30 {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .heading-31 {\r\n    max-width: 80%;\r\n    font-size: 20px;\r\n  }\r\n\r\n  .heading-32 {\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n  }\r\n\r\n  .heading-33 {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .heading-34 {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .heading-35 {\r\n    width: 80%;\r\n    font-size: 20px;\r\n  }\r\n\r\n  .column-7 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: column;\r\n    -ms-flex-direction: column;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .text-block-48 {\r\n    padding-left: 25px;\r\n    line-height: 250%;\r\n  }\r\n\r\n  .columns-3 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n    -webkit-flex-direction: row;\r\n    -ms-flex-direction: row;\r\n    flex-direction: row;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .image-61 {\r\n    padding-bottom: 10px;\r\n  }\r\n\r\n  .image-62 {\r\n    padding-bottom: 10px;\r\n  }\r\n\r\n  .menu-button-6 {\r\n    left: -234px;\r\n    background-color: transparent;\r\n  }\r\n\r\n  .image-64 {\r\n    width: 90%;\r\n    max-width: none;\r\n  }\r\n\r\n  .container-20 {\r\n    display: -webkit-box;\r\n    display: -webkit-flex;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -webkit-align-items: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .section-22 {\r\n    display: inline-block;\r\n  }\r\n\r\n  .image-65 {\r\n    max-width: 80%;\r\n  }\r\n\r\n  .text-block-51 {\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .text-block-52 {\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .text-block-53 {\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .text-block-54 {\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .text-block-55 {\r\n    max-width: 80%;\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .text-block-56 {\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n  }\r\n\r\n  .text-block-57 {\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .heading-36 {\r\n    max-width: 80%;\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .heading-37 {\r\n    max-width: 80%;\r\n    -webkit-align-self: flex-start;\r\n    -ms-flex-item-align: start;\r\n    align-self: flex-start;\r\n    font-size: 20px;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 1920px) {\r\n  #w-node-_0a7a8c99-ea77-4198-995e-5a9c886ab140-b508944f {\r\n    -ms-grid-column: span 1;\r\n    grid-column-start: span 1;\r\n    -ms-grid-column-span: 1;\r\n    grid-column-end: span 1;\r\n    -ms-grid-row: span 1;\r\n    grid-row-start: span 1;\r\n    -ms-grid-row-span: 1;\r\n    grid-row-end: span 1;\r\n  }\r\n\r\n  #w-node-_49e540cd-072e-b366-bc18-cc663cef7cba-b508944f {\r\n    -ms-grid-column: span 1;\r\n    grid-column-start: span 1;\r\n    -ms-grid-column-span: 1;\r\n    grid-column-end: span 1;\r\n    -ms-grid-row: span 1;\r\n    grid-row-start: span 1;\r\n    -ms-grid-row-span: 1;\r\n    grid-row-end: span 1;\r\n  }\r\n\r\n  #w-node-c82dcc88-eba5-1491-e2f6-a52d47293a8d-b508944f {\r\n    -ms-grid-column: span 1;\r\n    grid-column-start: span 1;\r\n    -ms-grid-column-span: 1;\r\n    grid-column-end: span 1;\r\n    -ms-grid-row: span 1;\r\n    grid-row-start: span 1;\r\n    -ms-grid-row-span: 1;\r\n    grid-row-end: span 1;\r\n  }\r\n\r\n  #w-node-cfa57362-1001-5e3f-623e-bfaa4393e68d-b508944f {\r\n    -ms-grid-column: span 1;\r\n    grid-column-start: span 1;\r\n    -ms-grid-column-span: 1;\r\n    grid-column-end: span 1;\r\n    -ms-grid-row: span 1;\r\n    grid-row-start: span 1;\r\n    -ms-grid-row-span: 1;\r\n    grid-row-end: span 1;\r\n  }\r\n\r\n  #w-node-_010cbedd-6fb8-3014-299a-74b500317e23-b508944f {\r\n    -ms-grid-column: span 1;\r\n    grid-column-start: span 1;\r\n    -ms-grid-column-span: 1;\r\n    grid-column-end: span 1;\r\n    -ms-grid-row: span 1;\r\n    grid-row-start: span 1;\r\n    -ms-grid-row-span: 1;\r\n    grid-row-end: span 1;\r\n  }\r\n\r\n  #w-node-b12b6411-2875-daad-7590-22e0aee6a84a-b508944f {\r\n    -ms-grid-column: span 1;\r\n    grid-column-start: span 1;\r\n    -ms-grid-column-span: 1;\r\n    grid-column-end: span 1;\r\n    -ms-grid-row: span 1;\r\n    grid-row-start: span 1;\r\n    -ms-grid-row-span: 1;\r\n    grid-row-end: span 1;\r\n  }\r\n\r\n  #w-node-_8cdaead8-6806-eaa6-0e7f-adf391103dcc-b508944f {\r\n    -ms-grid-column: span 1;\r\n    grid-column-start: span 1;\r\n    -ms-grid-column-span: 1;\r\n    grid-column-end: span 1;\r\n    -ms-grid-row: span 1;\r\n    grid-row-start: span 1;\r\n    -ms-grid-row-span: 1;\r\n    grid-row-end: span 1;\r\n  }\r\n\r\n  #w-node-_8d34484b-5af1-0196-3545-2efacb059d52-b508944f {\r\n    -ms-grid-column: span 1;\r\n    grid-column-start: span 1;\r\n    -ms-grid-column-span: 1;\r\n    grid-column-end: span 1;\r\n    -ms-grid-row: span 1;\r\n    grid-row-start: span 1;\r\n    -ms-grid-row-span: 1;\r\n    grid-row-end: span 1;\r\n  }\r\n\r\n  #w-node-_65d39dd0-7a4b-de21-c29e-2a231b55d495-b508944f {\r\n    -ms-grid-column: span 1;\r\n    grid-column-start: span 1;\r\n    -ms-grid-column-span: 1;\r\n    grid-column-end: span 1;\r\n    -ms-grid-row: span 1;\r\n    grid-row-start: span 1;\r\n    -ms-grid-row-span: 1;\r\n    grid-row-end: span 1;\r\n  }\r\n\r\n  #w-node-_0e11f50c-4447-db37-8817-c599062737e9-b508944f {\r\n    -ms-grid-column: span 1;\r\n    grid-column-start: span 1;\r\n    -ms-grid-column-span: 1;\r\n    grid-column-end: span 1;\r\n    -ms-grid-row: span 1;\r\n    grid-row-start: span 1;\r\n    -ms-grid-row-span: 1;\r\n    grid-row-end: span 1;\r\n  }\r\n\r\n  #w-node-_0776ad76-4161-a92d-5968-9059a2dd937c-b508944f {\r\n    -ms-grid-column: span 1;\r\n    grid-column-start: span 1;\r\n    -ms-grid-column-span: 1;\r\n    grid-column-end: span 1;\r\n    -ms-grid-row: span 1;\r\n    grid-row-start: span 1;\r\n    -ms-grid-row-span: 1;\r\n    grid-row-end: span 1;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 479px) {\r\n  #w-node-_0776ad76-4161-a92d-5968-9059a2dd937c-b508944f {\r\n    -ms-grid-column-align: auto;\r\n    justify-self: auto;\r\n    -ms-grid-row-align: auto;\r\n    align-self: auto;\r\n    -ms-grid-column-span: 1;\r\n    grid-column-end: span 1;\r\n    -ms-grid-column: span 1;\r\n    grid-column-start: span 1;\r\n    -ms-grid-row-span: 1;\r\n    grid-row-end: span 1;\r\n    -ms-grid-row: span 1;\r\n    grid-row-start: span 1;\r\n  }\r\n}\r\n\r\n@font-face {\r\n  font-family: 'Fontspring demo nekst';\r\n  src: url('./../fonts/Fontspring-DEMO-nekst-thin.otf') format('opentype');\r\n  font-weight: 100;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n@font-face {\r\n  font-family: 'Fontspring demo nekst';\r\n  src: url('./../fonts/Fontspring-DEMO-nekst-medium.otf') format('opentype');\r\n  font-weight: 500;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n@font-face {\r\n  font-family: 'Fontspring demo nekst';\r\n  src: url('./../fonts/Fontspring-DEMO-nekst-regular.otf') format('opentype');\r\n  font-weight: 400;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n@font-face {\r\n  font-family: 'Fontspring demo nekst';\r\n  src: url('./../fonts/Fontspring-DEMO-nekst-light.otf') format('opentype');\r\n  font-weight: 300;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n@font-face {\r\n  font-family: 'Fontspring demo nekst';\r\n  src: url('./../fonts/Fontspring-DEMO-nekst-black.otf') format('opentype');\r\n  font-weight: 900;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n@font-face {\r\n  font-family: 'Fontspring demo nekst';\r\n  src: url('./../fonts/Fontspring-DEMO-nekst-semibold.otf') format('opentype');\r\n  font-weight: 600;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n@font-face {\r\n  font-family: 'Fontspring demo nekst';\r\n  src: url('./../fonts/Fontspring-DEMO-nekst-bold.otf') format('opentype');\r\n  font-weight: 700;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n.partners{\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n.partners img{\r\n  object-fit: contain;\r\n}\r\n@media screen and (max-width: 1440px) {\r\n  .partners img{\r\n    max-width: 135px;\r\n    max-height: 40px;\r\n  }\r\n}\r\n@media screen and (max-width: 834px) {\r\n  .partners{\r\n    justify-content: center;\r\n    flex-wrap: wrap;\r\n  }\r\n}\r\n@media screen and (max-width: 834px) {\r\n  .partners img{\r\n    max-width: 100px;\r\n  }\r\n}\r\n.team img{\r\n  margin-right: auto;\r\n  margin-left: auto;\r\n}\r\n@media screen and (min-width: 834px) {\r\n  .div-block-4{\r\n    width: 80%;\r\n  }\r\n}\r\n.section-3{\r\n  margin-top: 5rem;\r\n}\r\n@media screen and (min-width: 1440px) {\r\n  .section-3{\r\n    margin-top: 10rem;\r\n  }\r\n}\r\n\r\n\r\n.price-ticker {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border: 2px solid #ccc;\r\n  border-radius: 10px;\r\n  padding: 20px;\r\n  margin: 20px;\r\n  width: 300px;\r\n  text-align: center;\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n  background-color: #ffffff;\r\n}\r\n\r\n.price-ticker h2 {\r\n  margin-bottom: 15px;\r\n  font-size: 22px;\r\n  color: #333;\r\n}\r\n\r\n.price-ticker p {\r\n  font-size: 18px;\r\n  color: #2b9348;\r\n}\r\n\r\n.price-ticker p.error {\r\n  color: red;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
